export const FORM_VALUES_DEGREE = [
    { label: 'Advanced Diploma Courses', value: 'Advanced Diploma Courses' },
    {
      label: 'Advanced Program (Advanced Program)',
      value: 'Advanced Program (Advanced Program)',
    },
    {
      label: 'Animation, Graphics and Multimedia',
      value: 'Animation, Graphics and Multimedia',
    },
    { label: 'Aviation Courses', value: 'Aviation Courses' },
    { label: 'B.Com (Hons.)', value: 'B.Com (Hons.)' },
    { label: 'BA (Hons.) in Economics', value: 'BA (Hons.) in Economics' },
    { label: 'BA in History', value: 'BA in History' },
    {
      label: 'Bachelor in Foreign Language',
      value: 'Bachelor in Foreign Language',
    },
    {
      label: 'Bachelor of Architecture (B.Arch)',
      value: 'Bachelor of Architecture (B.Arch)',
    },
    {
      label: 'Bachelor of Ayurvedic Medicine and Surgery',
      value: 'Bachelor of Ayurvedic Medicine and Surgery',
    },
    {
      label: 'Bachelor of Business Administration (BBA)',
      value: 'Bachelor of Business Administration (BBA)',
    },
    {
      label: 'Bachelor of Business Studies (BBS)',
      value: 'Bachelor of Business Studies (BBS)',
    },
    {
      label: 'Bachelor of Commerce (B.Com)',
      value: 'Bachelor of Commerce (B.Com)',
    },
    {
      label: 'Bachelor of Computer Applications (BCA)',
      value: 'Bachelor of Computer Applications (BCA)',
    },
    {
      label: 'Bachelor of Dental Surgery (BDS)',
      value: 'Bachelor of Dental Surgery (BDS)',
    },
    {
      label: 'Bachelor of Design (B. Design)',
      value: 'Bachelor of Design (B. Design)',
    },
    {
      label: 'Bachelor of Engineering (BE)',
      value: 'Bachelor of Engineering (BE)',
    },
    {
      label: 'Bachelor of Event Management (BEM)',
      value: 'Bachelor of Event Management (BEM)',
    },
    {
      label: 'Bachelor of Fashion Designing (BFD)',
      value: 'Bachelor of Fashion Designing (BFD)',
    },
    {
      label: 'Bachelor of Fine Arts (BFA)',
      value: 'Bachelor of Fine Arts (BFA)',
    },
    {
      label: 'Bachelor of Homeopathic Medicine and Surgery',
      value: 'Bachelor of Homeopathic Medicine and Surgery',
    },
    {
      label: 'Bachelor of Journalism and Mass Communication (BJMC)',
      value: 'Bachelor of Journalism and Mass Communication (BJMC)',
    },
    {
      label: 'Bachelor of Management Science (BMS)',
      value: 'Bachelor of Management Science (BMS)',
    },
    {
      label: 'Bachelor of Medicine ( M.B.B.S)',
      value: 'Bachelor of Medicine ( M.B.B.S)',
    },
    {
      label: 'Bachelor of Performing Arts',
      value: 'Bachelor of Performing Arts',
    },
    {
      label: 'Bachelor of Pharmacy (BPharma)',
      value: 'Bachelor of Pharmacy (BPharma)',
    },
    {
      label: 'Bachelor of Physiotherapy (BPT)',
      value: 'Bachelor of Physiotherapy (BPT)',
    },
    { label: 'Bachelor of Science (BSc)', value: 'Bachelor of Science (BSc)' },
    {
      label: 'Bachelor of Technology (B.Tech)',
      value: 'Bachelor of Technology (B.Tech)',
    },
    {
      label: 'Bachelor of Travel and Tourism Management (BTTM)',
      value: 'Bachelor of Travel and Tourism Management (BTTM)',
    },
    {
      label: "Certificate Courses Certificate Courses'",
      value: "Certificate Courses Certificate Courses'",
    },
    { label: 'Chartered Accountancy (CA)', value: 'Chartered Accountancy (CA)' },
    { label: 'Company Secretary (CS)', value: 'Company Secretary (CS)' },
    {
      label: "Diploma Courses Diploma Courses'",
      value: "Diploma Courses Diploma Courses'",
    },
    {
      label: 'Executive Fellow Program In Management (E.F.P.M)',
      value: 'Executive Fellow Program In Management (E.F.P.M)',
    },
    {
      label: 'Executive Management Programme (E.M.P)',
      value: 'Executive Management Programme (E.M.P)',
    },
    {
      label: 'Fellow Programme (Fellow Programme)',
      value: 'Fellow Programme (Fellow Programme)',
    },
    {
      label: 'Integrated Law Program- BBA LL.B',
      value: 'Integrated Law Program- BBA LL.B',
    },
    {
      label: 'Integrated Law Course- BA + LL.B',
      value: 'Integrated Law Course- BA + LL.B',
    },
    {
      label: 'Integrated Law Program- B.Com LL.B.',
      value: 'Integrated Law Program- B.Com LL.B.',
    },
    {
      label: 'International Programme (International Programme)',
      value: 'International Programme (International Programme)',
    },
    { label: 'Other', value: 'Other' },
  ];
  
  export const FORM_VALUES_LANGUAGE = [
    {
      label: 'Abkhazian',
      value: 'Abkhazian',
    },
    {
      label: 'Afar',
      value: 'Afar',
    },
    {
      label: 'Afrikaans',
      value: 'Afrikaans',
    },
    {
      label: 'Akan',
      value: 'Akan',
    },
    {
      label: 'Albanian',
      value: 'Albanian',
    },
    {
      label: 'Amharic',
      value: 'Amharic',
    },
    {
      label: 'Arabic',
      value: 'Arabic',
    },
    {
      label: 'Aragonese',
      value: 'Aragonese',
    },
    {
      label: 'Armenian',
      value: 'Armenian',
    },
    {
      label: 'Assamese',
      value: 'Assamese',
    },
    {
      label: 'Asturian',
      value: 'Asturian',
    },
    {
      label: 'Avaric',
      value: 'Avaric',
    },
    {
      label: 'Avestan',
      value: 'Avestan',
    },
    {
      label: 'Aymara',
      value: 'Aymara',
    },
    {
      label: 'Azerbaijani',
      value: 'Azerbaijani',
    },
    {
      label: 'Bambara',
      value: 'Bambara',
    },
    {
      label: 'Bashkir',
      value: 'Bashkir',
    },
    {
      label: 'Basque',
      value: 'Basque',
    },
    {
      label: 'Belarusian',
      value: 'Belarusian',
    },
    {
      label: 'Bengali',
      value: 'Bengali',
    },
    {
      label: 'Bihari',
      value: 'Bihari',
    },
    {
      label: 'Bislama',
      value: 'Bislama',
    },
    {
      label: 'Bosnian',
      value: 'Bosnian',
    },
    {
      label: 'Breton',
      value: 'Breton',
    },
    {
      label: 'Bulgarian',
      value: 'Bulgarian',
    },
    {
      label: 'Burmese',
      value: 'Burmese',
    },
    {
      label: 'Catalan',
      value: 'Catalan',
    },
    {
      label: 'Cebuano',
      value: 'Cebuano',
    },
    {
      label: 'Chamorro',
      value: 'Chamorro',
    },
    {
      label: 'Chechen',
      value: 'Chechen',
    },
    {
      label: 'Chichewa',
      value: 'Chichewa',
    },
    {
      label: 'Chinese',
      value: 'Chinese',
    },
    {
      label: 'Church Slavic',
      value: 'Church Slavic',
    },
    {
      label: 'Chuvash',
      value: 'Chuvash',
    },
    {
      label: 'Cornish',
      value: 'Cornish',
    },
    {
      label: 'Corsican',
      value: 'Corsican',
    },
    {
      label: 'Cree',
      value: 'Cree',
    },
    {
      label: 'Croatian',
      value: 'Croatian',
    },
    {
      label: 'Czech',
      value: 'Czech',
    },
    {
      label: 'Danish',
      value: 'Danish',
    },
    {
      label: 'Dari',
      value: 'Dari',
    },
    {
      label: 'Divehi',
      value: 'Divehi',
    },
    {
      label: 'Dutch',
      value: 'Dutch',
    },
    {
      label: 'Dzongkha',
      value: 'Dzongkha',
    },
    {
      label: 'English',
      value: 'English',
    },
    {
      label: 'Esperanto',
      value: 'Esperanto',
    },
    {
      label: 'Estonian',
      value: 'Estonian',
    },
    {
      label: 'Ewe',
      value: 'Ewe',
    },
    {
      label: 'Faroese',
      value: 'Faroese',
    },
    {
      label: 'Fijian',
      value: 'Fijian',
    },
    {
      label: 'Filipino',
      value: 'Filipino',
    },
    {
      label: 'Finnish',
      value: 'Finnish',
    },
    {
      label: 'Flemish',
      value: 'Flemish',
    },
    {
      label: 'French',
      value: 'French',
    },
    {
      label: 'French',
      value: 'French',
    },
    {
      label: 'Fulah',
      value: 'Fulah',
    },
    {
      label: 'Galician',
      value: 'Galician',
    },
    {
      label: 'Ganda',
      value: 'Ganda',
    },
    {
      label: 'Georgian',
      value: 'Georgian',
    },
    {
      label: 'German',
      value: 'German',
    },
    {
      label: 'Greek',
      value: 'Greek',
    },
    {
      label: 'Guarani',
      value: 'Guarani',
    },
    {
      label: 'Gujarati',
      value: 'Gujarati',
    },
    {
      label: 'Haitian Creole',
      value: 'Haitian Creole',
    },
    {
      label: 'Hausa',
      value: 'Hausa',
    },
    {
      label: 'Hawaiian',
      value: 'Hawaiian',
    },
    {
      label: 'Hebrew',
      value: 'Hebrew',
    },
    {
      label: 'Herero',
      value: 'Herero',
    },
    {
      label: 'Hindi',
      value: 'Hindi',
    },
    {
      label: 'Hiri Motu',
      value: 'Hiri Motu',
    },
    {
      label: 'Hungarian',
      value: 'Hungarian',
    },
    {
      label: 'Icelandic',
      value: 'Icelandic',
    },
    {
      label: 'Ido',
      value: 'ido',
    },
    {
      label: 'Igbo',
      value: 'Igbo',
    },
    {
      label: 'Indonesian',
      value: 'Indonesian',
    },
    {
      label: 'Interlingua',
      value: 'Interlingua',
    },
    {
      label: 'Interlingue',
      value: 'Interlingue',
    },
    {
      label: 'Inuktitut',
      value: 'Inuktitut',
    },
    {
      label: 'Inupiaq',
      value: 'Inupiaq',
    },
    {
      label: 'Irish',
      value: 'Irish',
    },
    {
      label: 'Italian',
      value: 'Italian',
    },
    {
      label: 'Jamaican Patois',
      value: 'Jamaican Patois',
    },
    {
      label: 'Japanese',
      value: 'Japanese',
    },
    {
      label: 'Javanese',
      value: 'Javanese',
    },
    {
      label: 'Kabyle',
      value: 'Kabyle',
    },
    {
      label: 'Kalaallisut',
      value: 'Kalaallisut',
    },
    {
      label: 'Kannada',
      value: 'Kannada',
    },
    {
      label: 'Kanuri',
      value: 'Kanuri',
    },
    {
      label: 'Kashmiri',
      value: 'Kashmiri',
    },
    {
      label: 'Kazakh',
      value: 'Kazakh',
    },
    {
      label: 'Khmer',
      value: 'Khmer',
    },
    {
      label: 'Kikuyu',
      value: 'Kikuyu',
    },
    {
      label: 'Kinyarwanda',
      value: 'Kinyarwanda',
    },
    {
      label: 'Kirghiz',
      value: 'Kirghiz',
    },
    {
      label: 'Komi',
      value: 'Komi',
    },
    {
      label: 'Kongo',
      value: 'Kongo',
    },
    {
      label: 'Korean',
      value: 'Korean',
    },
    {
      label: 'Kuanyama',
      value: 'Kuanyama',
    },
    {
      label: 'Kurdish',
      value: 'Kurdish',
    },
    {
      label: 'Lao',
      value: 'Lao',
    },
    {
      label: 'Latin',
      value: 'Latin',
    },
    {
      label: 'Latvian',
      value: 'Latvian',
    },
    {
      label: 'Limburgish',
      value: 'Limburgish',
    },
    {
      label: 'Lingala',
      value: 'Lingala',
    },
    {
      label: 'Lithuanian',
      value: 'Lithuanian',
    },
    {
      label: 'Lojban',
      value: 'Lojban',
    },
    {
      label: 'Luba-Katanga',
      value: 'Luba-Katanga',
    },
    {
      label: 'Luxembourgish',
      value: 'Luxembourgish',
    },
    {
      label: 'Macedonian',
      value: 'Macedonian',
    },
    {
      label: 'Malagasy',
      value: 'Malagasy',
    },
    {
      label: 'Malay',
      value: 'Malay',
    },
    {
      label: 'Malayalam',
      value: 'Malayalam',
    },
    {
      label: 'Maltese',
      value: 'Maltese',
    },
    {
      label: 'Manx',
      value: 'Manx',
    },
    {
      label: 'Marathi',
      value: 'Marathi',
    },
    {
      label: 'Marshallese',
      value: 'Marshallese',
    },
    {
      label: 'Moldavian',
      value: 'Moldavian',
    },
    {
      label: 'Mongolian',
      value: 'Mongolian',
    },
    {
      label: 'Montenegrin',
      value: 'Montenegrin',
    },
    {
      label: 'Nauru',
      value: 'Nauru',
    },
    {
      label: 'Navajo',
      value: 'Navajo',
    },
    {
      label: 'Ndonga',
      value: 'Ndonga',
    },
    {
      label: 'Nepali',
      value: 'Nepali',
    },
    {
      label: 'North Ndebele',
      value: 'North Ndebele',
    },
    {
      label: 'Northern Sami',
      value: 'Northern Sami',
    },
    {
      label: 'Norwegian',
      value: 'Norwegian',
    },
    {
      label: 'Occitan',
      value: 'Occitan',
    },
    {
      label: 'Ojibwa',
      value: 'Ojibwa',
    },
    {
      label: 'Oriya',
      value: 'Oriya',
    },
    {
      label: 'Oromo',
      value: 'Oromo',
    },
    {
      label: 'Ossetian',
      value: 'Ossetian',
    },
    {
      label: 'Pali',
      value: 'Pali',
    },
    {
      label: 'Punjabi',
      value: 'Punjabi',
    },
    {
      label: 'Persian',
      value: 'Persian',
    },
    {
      label: 'Polish',
      value: 'Polish',
    },
    {
      label: 'Portuguese',
      value: 'Portuguese',
    },
    {
      label: 'Pashto',
      value: 'Pashto',
    },
    {
      label: 'Quechua',
      value: 'Quechua',
    },
    {
      label: 'Romani',
      value: 'Romani',
    },
    {
      label: 'Romanian',
      value: 'Romanian',
    },
    {
      label: 'Romansh',
      value: 'Romansh',
    },
    {
      label: 'Rundi',
      value: 'Rundi',
    },
    {
      label: 'Russian',
      value: 'Russian',
    },
    {
      label: 'Rusyn',
      value: 'Rusyn',
    },
    {
      label: 'Samoan',
      value: 'Samoan',
    },
    {
      label: 'Sango',
      value: 'Sango',
    },
    {
      label: 'Sanskrit',
      value: 'Sanskrit',
    },
    {
      label: 'Santali',
      value: 'Santali',
    },
    {
      label: 'Sardinian',
      value: 'Sardinian',
    },
    {
      label: 'Scottish Gaelic',
      value: 'Scottish Gaelic',
    },
    {
      label: 'Serbian',
      value: 'Serbian',
    },
    {
      label: 'Shona',
      value: 'Shona',
    },
    {
      label: 'Sichuan Yi',
      value: 'Sichuan Yi',
    },
    {
      label: 'Sicilian',
      value: 'Sicilian',
    },
    {
      label: 'Sindhi',
      value: 'Sindhi',
    },
    {
      label: 'Sinhalese',
      value: 'Sinhalese',
    },
    {
      label: 'Slovak',
      value: 'Slovak',
    },
    {
      label: 'Slovenian',
      value: 'Slovenian',
    },
    {
      label: 'Somali',
      value: 'Somali',
    },
    {
      label: 'Southern',
      value: 'Southern',
    },
    {
      label: 'South Ndebele',
      value: 'South Ndebele',
    },
    {
      label: 'Spanish',
      value: 'Spanish',
    },
    {
      label: 'Sundanese',
      value: 'Sundanese',
    },
    {
      label: 'Swahili',
      value: 'Swahili',
    },
    {
      label: 'Swati',
      value: 'Swati',
    },
    {
      label: 'Swedish',
      value: 'Swedish',
    },
    {
      label: 'Tagalog',
      value: 'Tagalog',
    },
    {
      label: 'Tahitian',
      value: 'Tahitian',
    },
    {
      label: 'Tajik',
      value: 'Tajik',
    },
    {
      label: 'Tamil',
      value: 'Tamil',
    },
    {
      label: 'Tatar',
      value: 'Tatar',
    },
    {
      label: 'Telugu',
      value: 'Telugu',
    },
    {
      label: 'Thai',
      value: 'Thai',
    },
    {
      label: 'Tibetan',
      value: 'Tibetan',
    },
    {
      label: 'Tigrinya',
      value: 'Tigrinya',
    },
    {
      label: 'Tonga',
      value: 'Tonga',
    },
    {
      label: 'Tsonga',
      value: 'Tsonga',
    },
    {
      label: 'Tswana',
      value: 'Tswana',
    },
    {
      label: 'Turkish',
      value: 'Turkish',
    },
    {
      label: 'Turkmen',
      value: 'Turkmen',
    },
    {
      label: 'Twi',
      value: 'Twi',
    },
    {
      label: 'Ukrainian',
      value: 'Ukrainian',
    },
    {
      label: 'Urdu',
      value: 'Urdu',
    },
    {
      label: 'Uyghur',
      value: 'Uyghur',
    },
    {
      label: 'Uzbek',
      value: 'Uzbek',
    },
    {
      label: 'Venda',
      value: 'Venda',
    },
    {
      label: 'Vietnamese',
      value: 'Vietnamese',
    },
    {
      label: 'Volapük',
      value: 'Volapük',
    },
    {
      label: 'Walloon',
      value: 'Walloon',
    },
    {
      label: 'Welsh',
      value: 'Welsh',
    },
    {
      label: 'Western Frisian',
      value: 'Western Frisian',
    },
    {
      label: 'Wolof',
      value: 'Wolof',
    },
    {
      label: 'Xhosa',
      value: 'Xhosa',
    },
    {
      label: 'Yiddish',
      value: 'Yiddish',
    },
    {
      label: 'Yoruba',
      value: 'Yoruba',
    },
    {
      label: 'Zhuang',
      value: 'Zhuang',
    },
    {
      label: 'Zulu',
      value: 'Zulu',
    },
    {
      label: 'Others',
      value: 'Others',
    },
  ];
  
  export const FORM_VALUES_BOARD_10 = [
    {
      label: 'IB- International Baccalaureate',
      value: 'IB- International Baccalaureate',
    },
    {
      label: 'GCSE- General Certificate of Secondary Education',
      value: 'GCSE- General Certificate of Secondary Education',
    },
    {
      label: 'International General Certificate of Secondary Education',
      value: 'International General Certificate of Secondary Education',
    },
    {
      label: 'ICSE- Indian Certificate of Secondary Education',
      value: 'ICSE- Indian Certificate of Secondary Education',
    },
    {
      label: 'CBSE- Central Board of Secondary Education',
      value: 'CBSE- Central Board of Secondary Education',
    },
    {
      label: 'NIOS- National Institute of Open Schooling',
      value: 'NIOS- National Institute of Open Schooling',
    },
    { label: 'State Board', value: 'State Board' },
    { label: 'Other', value: 'Other' },
  ];
  
  export const FORM_VALUES_BOARD_12 = [
    {
      label: 'GCE A Levels/BTEC- Business and Technology Education Council',
      value: 'GCE A Levels/BTEC- Business and Technology Education Council',
    },
    {
      label: 'IB- International Baccalaureate',
      value: 'IB- International Baccalaureate',
    },
    {
      label: 'IGCSE- International General Certificate of Secondary Education',
      value: 'IGCSE- International General Certificate of Secondary Education',
    },
    {
      label: 'CBSE- Central Board of Secondary Education',
      value: 'CBSE- Central Board of Secondary Education',
    },
    {
      label: 'ICSE- Indian Certificate of Secondary Education',
      value: 'ICSE- Indian Certificate of Secondary Education',
    },
    {
      label: 'ISC- Indian School Certificate',
      value: 'ISC- Indian School Certificate',
    },
    {
      label: 'NIOS- National Institute of Open Schooling',
      value: 'NIOS- National Institute of Open Schooling',
    },
    { label: 'State Board', value: 'State Board' },
    { label: 'Other', value: 'Other' },
  ];
  
  export const FORM_VALUES_INDUSTRY_TYPE = [
    { label: 'Accounting', value: 'Accounting' },
    { label: 'Airlines/Aviation', value: 'Airlines/Aviation' },
    {
      label: 'Alternative Dispute Resolution',
      value: 'Alternative Dispute Resolution',
    },
    { label: 'Alternative Medicine', value: 'Alternative Medicine' },
    { label: 'Animation', value: 'Animation' },
    { label: 'Apparel & Fashion', value: 'Apparel & Fashion' },
    { label: 'Architecture & Planning', value: 'Architecture & Planning' },
    { label: 'Arts and Crafts', value: 'Arts and Crafts' },
    { label: 'Automotive', value: 'Automotive' },
    { label: 'Aviation & Aerospace', value: 'Aviation & Aerospace' },
    { label: 'Banking', value: 'Banking' },
    { label: 'Biotechnology', value: 'Biotechnology' },
    { label: 'Broadcast Media', value: 'Broadcast Media' },
    { label: 'Building Materials', value: 'Building Materials' },
    {
      label: 'Business Supplies and Equipment',
      value: 'Business Supplies and Equipment',
    },
    { label: 'Capital Markets', value: 'Capital Markets' },
    { label: 'Chemicals', value: 'Chemicals' },
    {
      label: 'Civic & Social Organization',
      value: 'Civic & Social Organization',
    },
    { label: 'Civil Engineering', value: 'Civil Engineering' },
    { label: 'Commercial Real Estate', value: 'Commercial Real Estate' },
    {
      label: 'Computer & Network Security',
      value: 'Computer & Network Security',
    },
    { label: 'Computer Games', value: 'Computer Games' },
    { label: 'Computer Hardware', value: 'Computer Hardware' },
    { label: 'Computer Networking', value: 'Computer Networking' },
    { label: 'Computer Software', value: 'Computer Software' },
    { label: 'Construction', value: 'Construction' },
    { label: 'Consumer Electronics', value: 'Consumer Electronics' },
    { label: 'Consumer Goods', value: 'Consumer Goods' },
    { label: 'Consumer Services', value: 'Consumer Services' },
    { label: 'Cosmetics', value: 'Cosmetics' },
    { label: 'Dairy', value: 'Dairy' },
    { label: 'Defense & Space', value: 'Defense & Space' },
    { label: 'Design', value: 'Design' },
    { label: 'Education Management', value: 'Education Management' },
    { label: 'E-Learning', value: 'E-Learning' },
    {
      label: 'Electrical/Electronic Manufacturing',
      value: 'Electrical/Electronic Manufacturing',
    },
    { label: 'Entertainment', value: 'Entertainment' },
    { label: 'Environmental Services', value: 'Environmental Services' },
    { label: 'Events Services', value: 'Events Services' },
    { label: 'Executive Office', value: 'Executive Office' },
    { label: 'Facilities Services', value: 'Facilities Services' },
    { label: 'Farming', value: 'Farming' },
    { label: 'Financial Services', value: 'Financial Services' },
    { label: 'Fine Art', value: 'Fine Art' },
    { label: 'Fishery', value: 'Fishery' },
    { label: 'Food & Beverages', value: 'Food & Beverages' },
    { label: 'Food Production', value: 'Food Production' },
    { label: 'Fund-Raising', value: 'Fund-Raising' },
    { label: 'Furniture', value: 'Furniture' },
    { label: 'Gambling & Casinos', value: 'Gambling & Casinos' },
    { label: 'Glass, Ceramics & Concrete', value: 'Glass, Ceramics & Concrete' },
    { label: 'Government Administration', value: 'Government Administration' },
    { label: 'Government Relations', value: 'Government Relations' },
    { label: 'Graphic Design', value: 'Graphic Design' },
    {
      label: 'Health, Wellness and Fitness',
      value: 'Health, Wellness and Fitness',
    },
    { label: 'Higher Education', value: 'Higher Education' },
    { label: 'Hospital & Health Care', value: 'Hospital & Health Care' },
    { label: 'Hospitality', value: 'Hospitality' },
    { label: 'Human Resources', value: 'Human Resources' },
    { label: 'Import and Export', value: 'Import and Export' },
    {
      label: 'Individual & Family Services',
      value: 'Individual & Family Services',
    },
    { label: 'Industrial Automation', value: 'Industrial Automation' },
    { label: 'Information Services', value: 'Information Services' },
    {
      label: 'Information Technology and Services',
      value: 'Information Technology and Services',
    },
    { label: 'Insurance', value: 'Insurance' },
    { label: 'International Affairs', value: 'International Affairs' },
    {
      label: 'International Trade and Development',
      value: 'International Trade and Development',
    },
    { label: 'Internet', value: 'Internet' },
    { label: 'Investment Banking', value: 'Investment Banking' },
    { label: 'Investment Management', value: 'Investment Management' },
    { label: 'Judiciary', value: 'Judiciary' },
    { label: 'Law Enforcement', value: 'Law Enforcement' },
    { label: 'Law Practice', value: 'Law Practice' },
    { label: 'Legal Services', value: 'Legal Services' },
    { label: 'Legislative Office', value: 'Legislative Office' },
    { label: 'Leisure, Travel & Tourism', value: 'Leisure, Travel & Tourism' },
    { label: 'Libraries', value: 'Libraries' },
    { label: 'Logistics and Supply Chain', value: 'Logistics and Supply Chain' },
    { label: 'Luxury Goods & Jewelry', value: 'Luxury Goods & Jewelry' },
    { label: 'Machinery', value: 'Machinery' },
    { label: 'Management Consulting', value: 'Management Consulting' },
    { label: 'Maritime', value: 'Maritime' },
    { label: 'Market Research', value: 'Market Research' },
    { label: 'Marketing and Advertising', value: 'Marketing and Advertising' },
    {
      label: 'Mechanical or Industrial Engineering',
      value: 'Mechanical or Industrial Engineering',
    },
    { label: 'Media Production', value: 'Media Production' },
    { label: 'Medical Devices', value: 'Medical Devices' },
    { label: 'Medical Practice', value: 'Medical Practice' },
    { label: 'Mental Health Care', value: 'Mental Health Care' },
    { label: 'Military', value: 'Military' },
    { label: 'Mining & Metals', value: 'Mining & Metals' },
    { label: 'Motion Pictures and Film', value: 'Motion Pictures and Film' },
    { label: 'Museums and Institutions', value: 'Museums and Institutions' },
    { label: 'Music', value: 'Music' },
    { label: 'Nanotechnology', value: 'Nanotechnology' },
    { label: 'Newspapers', value: 'Newspapers' },
    {
      label: 'Non-Profit Organization Management',
      value: 'Non-Profit Organization Management',
    },
    { label: 'Oil & Energy', value: 'Oil & Energy' },
    { label: 'Online Media', value: 'Online Media' },
    { label: 'Outsourcing/Offshoring', value: 'Outsourcing/Offshoring' },
    { label: 'Package/Freight Delivery', value: 'Package/Freight Delivery' },
    { label: 'Packaging and Containers', value: 'Packaging and Containers' },
    { label: 'Paper & Forest Products', value: 'Paper & Forest Products' },
    { label: 'Performing Arts', value: 'Performing Arts' },
    { label: 'Pharmaceuticals', value: 'Pharmaceuticals' },
    { label: 'Philanthropy', value: 'Philanthropy' },
    { label: 'Photography', value: 'Photography' },
    { label: 'Plastics', value: 'Plastics' },
    { label: 'Political Organization', value: 'Political Organization' },
    {
      label: 'Primary/Secondary Education',
      value: 'Primary/Secondary Education',
    },
    { label: 'Printing', value: 'Printing' },
    {
      label: 'Professional Training & Coaching',
      value: 'Professional Training & Coaching',
    },
    { label: 'Program Development', value: 'Program Development' },
    { label: 'Public Policy', value: 'Public Policy' },
    {
      label: 'Public Relations and Communications',
      value: 'Public Relations and Communications',
    },
    { label: 'Public Safety', value: 'Public Safety' },
    { label: 'Publishing', value: 'Publishing' },
    { label: 'Railroad Manufacture', value: 'Railroad Manufacture' },
    { label: 'Ranching', value: 'Ranching' },
    { label: 'Real Estate', value: 'Real Estate' },
    {
      label: 'Recreational Facilities and Services',
      value: 'Recreational Facilities and Services',
    },
    { label: 'Religious Institutions', value: 'Religious Institutions' },
    { label: 'Renewables & Environment', value: 'Renewables & Environment' },
    { label: 'Research', value: 'Research' },
    { label: 'Restaurants', value: 'Restaurants' },
    { label: 'Retail', value: 'Retail' },
    {
      label: 'Security and Investigations',
      value: 'Security and Investigations',
    },
    { label: 'Semiconductors', value: 'Semiconductors' },
    { label: 'Shipbuilding', value: 'Shipbuilding' },
    { label: 'Sporting Goods', value: 'Sporting Goods' },
    { label: 'Sports', value: 'Sports' },
    { label: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
    { label: 'Supermarkets', value: 'Supermarkets' },
    { label: 'Telecommunications', value: 'Telecommunications' },
    { label: 'Textiles', value: 'Textiles' },
    { label: 'Think Tanks', value: 'Think Tanks' },
    { label: 'Tobacco', value: 'Tobacco' },
    {
      label: 'Translation and Localization',
      value: 'Translation and Localization',
    },
    {
      label: 'Transportation/Trucking/Railroad',
      value: 'Transportation/Trucking/Railroad',
    },
    { label: 'Utilities', value: 'Utilities' },
    {
      label: 'Venture Capital & Private Equity',
      value: 'Venture Capital & Private Equity',
    },
    { label: 'Veterinary', value: 'Veterinary' },
    { label: 'Warehousing', value: 'Warehousing' },
    { label: 'Wholesale', value: 'Wholesale' },
    { label: 'Wine and Spirits', value: 'Wine and Spirits' },
    { label: 'Wireless', value: 'Wireless' },
    { label: 'Writing and Editing', value: 'Writing and Editing' },
    { label: 'Other', value: 'Other' },
  ];
  
  export const FORM_VALUES_NATIONALITY = [
    { label: 'Afghan', value: 'Afghan' },
    { label: 'Albanian', value: 'Albanian' },
    { label: 'Algerian', value: 'Algerian' },
    { label: 'American', value: 'American' },
    { label: 'Andorran', value: 'Andorran' },
    { label: 'Angolan', value: 'Angolan' },
    { label: 'Antiguans', value: 'Antiguans' },
    { label: 'Argentinean', value: 'Argentinean' },
    { label: 'Armenian', value: 'Armenian' },
    { label: 'Australian', value: 'Australian' },
    { label: 'Austrian', value: 'Austrian' },
    { label: 'Azerbaijani', value: 'Azerbaijani' },
    { label: 'Bahamian', value: 'Bahamian' },
    { label: 'Bahraini', value: 'Bahraini' },
    { label: 'Bangladeshi', value: 'Bangladeshi' },
    { label: 'Barbadian', value: 'Barbadian' },
    { label: 'Barbudans', value: 'Barbudans' },
    { label: 'Batswana', value: 'Batswana' },
    { label: 'Belarusian', value: 'Belarusian' },
    { label: 'Belgian', value: 'Belgian' },
    { label: 'Belizean', value: 'Belizean' },
    { label: 'Beninese', value: 'Beninese' },
    { label: 'Bhutanese', value: 'Bhutanese' },
    { label: 'Bolivian', value: 'Bolivian' },
    { label: 'Bosnian', value: 'Bosnian' },
    { label: 'Brazilian', value: 'Brazilian' },
    { label: 'British', value: 'British' },
    { label: 'Bruneian', value: 'Bruneian' },
    { label: 'Bulgarian', value: 'Bulgarian' },
    { label: 'Burkinabe', value: 'Burkinabe' },
    { label: 'Burmese', value: 'Burmese' },
    { label: 'Burundian', value: 'Burundian' },
    { label: 'Cambodian', value: 'Cambodian' },
    { label: 'Cameroonian', value: 'Cameroonian' },
    { label: 'Canadian', value: 'Canadian' },
    { label: 'Cape Verdean', value: 'Cape Verdean' },
    { label: 'Central African', value: 'Central African' },
    { label: 'Chadian', value: 'Chadian' },
    { label: 'Chilean', value: 'Chilean' },
    { label: 'Chinese', value: 'Chinese' },
    { label: 'Colombian', value: 'Colombian' },
    { label: 'Comoran', value: 'Comoran' },
    { label: 'Congolese', value: 'Congolese' },
    { label: 'Costa Rican', value: 'Costa Rican' },
    { label: 'Croatian', value: 'Croatian' },
    { label: 'Cuban', value: 'Cuban' },
    { label: 'Cypriot', value: 'Cypriot' },
    { label: 'Czech', value: 'Czech' },
    { label: 'Danish', value: 'Danish' },
    { label: 'Djibouti', value: 'Djibouti' },
    { label: 'Dominican', value: 'Dominican' },
    { label: 'Dutch', value: 'Dutch' },
    { label: 'East Timorese', value: 'East Timorese' },
    { label: 'Ecuadorean', value: 'Ecuadorean' },
    { label: 'Egyptian', value: 'Egyptian' },
    { label: 'Emirian', value: 'Emirian' },
    { label: 'Equatorial Guinean', value: 'Equatorial Guinean' },
    { label: 'Eritrean', value: 'Eritrean' },
    { label: 'Estonian', value: 'Estonian' },
    { label: 'Ethiopian', value: 'Ethiopian' },
    { label: 'Fijian', value: 'Fijian' },
    { label: 'Filipino', value: 'Filipino' },
    { label: 'Finnish', value: 'Finnish' },
    { label: 'French', value: 'French' },
    { label: 'Gabonese', value: 'Gabonese' },
    { label: 'Gambian', value: 'Gambian' },
    { label: 'Georgian', value: 'Georgian' },
    { label: 'German', value: 'German' },
    { label: 'Ghanaian', value: 'Ghanaian' },
    { label: 'Greek', value: 'Greek' },
    { label: 'Grenadian', value: 'Grenadian' },
    { label: 'Guatemalan', value: 'Guatemalan' },
    { label: 'Guinea-Bissauan', value: 'Guinea-Bissauan' },
    { label: 'Guinean', value: 'Guinean' },
    { label: 'Guyanese', value: 'Guyanese' },
    { label: 'Haitian', value: 'Haitian' },
    { label: 'Herzegovinian', value: 'Herzegovinian' },
    { label: 'Honduran', value: 'Honduran' },
    { label: 'Hungarian', value: 'Hungarian' },
    { label: 'I-Kiribati', value: 'I-Kiribati' },
    { label: 'Icelander', value: 'Icelander' },
    { label: 'Indian', value: 'Indian' },
    { label: 'Indonesian', value: 'Indonesian' },
    { label: 'Iranian', value: 'Iranian' },
    { label: 'Iraqi', value: 'Iraqi' },
    { label: 'Irish', value: 'Irish' },
    { label: 'Israeli', value: 'Israeli' },
    { label: 'Italian', value: 'Italian' },
    { label: 'Ivorian', value: 'Ivorian' },
    { label: 'Jamaican', value: 'Jamaican' },
    { label: 'Japanese', value: 'Japanese' },
    { label: 'Jordanian', value: 'Jordanian' },
    { label: 'Kazakhstani', value: 'Kazakhstani' },
    { label: 'Kenyan', value: 'Kenyan' },
    { label: 'Kittian and Nevisian', value: 'Kittian and Nevisian' },
    { label: 'Kuwaiti', value: 'Kuwaiti' },
    { label: 'Kyrgyz', value: 'Kyrgyz' },
    { label: 'Laotian', value: 'Laotian' },
    { label: 'Latvian', value: 'Latvian' },
    { label: 'Lebanese', value: 'Lebanese' },
    { label: 'Liberian', value: 'Liberian' },
    { label: 'Libyan', value: 'Libyan' },
    { label: 'Liechtensteiner', value: 'Liechtensteiner' },
    { label: 'Lithuanian', value: 'Lithuanian' },
    { label: 'Luxembourger', value: 'Luxembourger' },
    { label: 'Macedonian', value: 'Macedonian' },
    { label: 'Malagasy', value: 'Malagasy' },
    { label: 'Malawian', value: 'Malawian' },
    { label: 'Malaysian', value: 'Malaysian' },
    { label: 'Maldivian', value: 'Maldivian' },
    { label: 'Malian', value: 'Malian' },
    { label: 'Maltese', value: 'Maltese' },
    { label: 'Marshallese', value: 'Marshallese' },
    { label: 'Mauritanian', value: 'Mauritanian' },
    { label: 'Mauritian', value: 'Mauritian' },
    { label: 'Mexican', value: 'Mexican' },
    { label: 'Micronesian', value: 'Micronesian' },
    { label: 'Moldovan', value: 'Moldovan' },
    { label: 'Monacan', value: 'Monacan' },
    { label: 'Mongolian', value: 'Mongolian' },
    { label: 'Moroccan', value: 'Moroccan' },
    { label: 'Mosotho', value: 'Mosotho' },
    { label: 'Motswana', value: 'Motswana' },
    { label: 'Mozambican', value: 'Mozambican' },
    { label: 'Namibian', value: 'Namibian' },
    { label: 'Nauruan', value: 'Nauruan' },
    { label: 'Nepalese', value: 'Nepalese' },
    { label: 'New Zealander', value: 'New Zealander' },
    { label: 'Ni-Vanuatu', value: 'Ni-Vanuatu' },
    { label: 'Nicaraguan', value: 'Nicaraguan' },
    { label: 'Nigerian', value: 'Nigerian' },
    { label: 'Nigerien', value: 'Nigerien' },
    { label: 'North Korean', value: 'North Korean' },
    { label: 'Northern Irish', value: 'Northern Irish' },
    { label: 'Norwegian', value: 'Norwegian' },
    { label: 'Omani', value: 'Omani' },
    { label: 'Pakistani', value: 'Pakistani' },
    { label: 'Palauan', value: 'Palauan' },
    { label: 'Panamanian', value: 'Panamanian' },
    { label: 'Papua New Guinean', value: 'Papua New Guinean' },
    { label: 'Paraguayan', value: 'Paraguayan' },
    { label: 'Peruvian', value: 'Peruvian' },
    { label: 'Polish', value: 'Polish' },
    { label: 'Portuguese', value: 'Portuguese' },
    { label: 'Qatari', value: 'Qatari' },
    { label: 'Romanian', value: 'Romanian' },
    { label: 'Russian', value: 'Russian' },
    { label: 'Rwandan', value: 'Rwandan' },
    { label: 'Saint Lucian', value: 'Saint Lucian' },
    { label: 'Salvadoran', value: 'Salvadoran' },
    { label: 'Samoan', value: 'Samoan' },
    { label: 'San Marinese', value: 'San Marinese' },
    { label: 'Sao Tomean', value: 'Sao Tomean' },
    { label: 'Saudi', value: 'Saudi' },
    { label: 'Scottish', value: 'Scottish' },
    { label: 'Senegalese', value: 'Senegalese' },
    { label: 'Serbian', value: 'Serbian' },
    { label: 'Seychellois', value: 'Seychellois' },
    { label: 'Sierra Leonean', value: 'Sierra Leonean' },
    { label: 'Singaporean', value: 'Singaporean' },
    { label: 'Slovakian', value: 'Slovakian' },
    { label: 'Slovenian', value: 'Slovenian' },
    { label: 'Solomon Islander', value: 'Solomon Islander' },
    { label: 'Somali', value: 'Somali' },
    { label: 'South African', value: 'South African' },
    { label: 'South Korean', value: 'South Korean' },
    { label: 'Spanish', value: 'Spanish' },
    { label: 'Sri Lankan', value: 'Sri Lankan' },
    { label: 'Sudanese', value: 'Sudanese' },
    { label: 'Surinamer', value: 'Surinamer' },
    { label: 'Swazi', value: 'Swazi' },
    { label: 'Swedish', value: 'Swedish' },
    { label: 'Swiss', value: 'Swiss' },
    { label: 'Syrian', value: 'Syrian' },
    { label: 'Taiwanese', value: 'Taiwanese' },
    { label: 'Tajik', value: 'Tajik' },
    { label: 'Tanzanian', value: 'Tanzanian' },
    { label: 'Thai', value: 'Thai' },
    { label: 'Togolese', value: 'Togolese' },
    { label: 'Tongan', value: 'Tongan' },
    { label: 'Trinidadian or Tobagonian', value: 'Trinidadian or Tobagonian' },
    { label: 'Tunisian', value: 'Tunisian' },
    { label: 'Turkish', value: 'Turkish' },
    { label: 'Tuvaluan', value: 'Tuvaluan' },
    { label: 'Ugandan', value: 'Ugandan' },
    { label: 'Ukrainian', value: 'Ukrainian' },
    { label: 'Uruguayan', value: 'Uruguayan' },
    { label: 'Uzbekistani', value: 'Uzbekistani' },
    { label: 'Venezuelan', value: 'Venezuelan' },
    { label: 'Welsh', value: 'Welsh' },
    { label: 'Yemenite', value: 'Yemenite' },
    { label: 'Zambian', value: 'Zambian' },
    { label: 'Zimbabwean', value: 'Zimbabwean' },
  ];
  
  export const FORM_VALUES_DEGREE_PG = [
    { label: 'Doctor of Medicine (M.D)', value: 'Doctor of Medicine (M.D)' },
    {
      label: 'Doctor of Philosophy (Ph.D)',
      value: 'Doctor of Philosophy (Ph.D)',
    },
    {
      label: 'Management Development Programme (M.D.P)',
      value: 'Management Development Programme (M.D.P)',
    },
    {
      label: 'Master of Architecture (M.Arch)',
      value: 'Master of Architecture (M.Arch)',
    },
    { label: 'Master of Arts (M.A)', value: 'Master of Arts (M.A)' },
    {
      label: 'Master of Arts in Management (M.A.M)',
      value: 'Master of Arts in Management (M.A.M)',
    },
    {
      label: 'Master of Arts in Personal Management (M.A.P.M)',
      value: 'Master of Arts in Personal Management (M.A.P.M)',
    },
    {
      label: 'Master of Business Administration (M.B.A)',
      value: 'Master of Business Administration (M.B.A)',
    },
    {
      label: 'Master of Business Administration (MBA)',
      value: 'Master of Business Administration (MBA)',
    },
    {
      label: 'Master of Business Economics (M.B.E)',
      value: 'Master of Business Economics (M.B.E)',
    },
    {
      label: 'Master of Business Laws (M.B.L)',
      value: 'Master of Business Laws (M.B.L)',
    },
    {
      label: 'Master of Business Management (M.B.M)',
      value: 'Master of Business Management (M.B.M)',
    },
    {
      label: 'Master of Business Studies (M.B.S)',
      value: 'Master of Business Studies (M.B.S)',
    },
    {
      label: 'Master of Chirurgical (M.Ch)',
      value: 'Master of Chirurgical (M.Ch)',
    },
    { label: 'Master of Commerce (M.Com)', value: 'Master of Commerce (M.Com)' },
    {
      label: 'Master Of Communication And Journalism (M.C.J)',
      value: 'Master Of Communication And Journalism (M.C.J)',
    },
    {
      label: 'Master of Comparative Laws (M.C.L)',
      value: 'Master of Comparative Laws (M.C.L)',
    },
    {
      label: 'Master of Computer Applications (M.C.A)',
      value: 'Master of Computer Applications (M.C.A)',
    },
    {
      label: 'Master of Computer Management (M.C.M)',
      value: 'Master of Computer Management (M.C.M)',
    },
    {
      label: 'Master of Corporate Secretaryship (M.C.S)',
      value: 'Master of Corporate Secretaryship (M.C.S)',
    },
    {
      label: 'Master of Dental Surgery (M.D.S)',
      value: 'Master of Dental Surgery (M.D.S)',
    },
    { label: 'Master of Education (M.Ed)', value: 'Master of Education (M.Ed)' },
    {
      label: 'Master of education in Artificial Intelligence (M.Ed AI)',
      value: 'Master of education in Artificial Intelligence (M.Ed AI)',
    },
    {
      label: 'Master of Engineering (M.E)',
      value: 'Master of Engineering (M.E)',
    },
    {
      label: 'Master of Film Management (M.F.M)',
      value: 'Master of Film Management (M.F.M)',
    },
    {
      label: 'Master of Finance And Control (M.F.C)',
      value: 'Master of Finance And Control (M.F.C)',
    },
    {
      label: 'Master of Financial Services (M.F.S)',
      value: 'Master of Financial Services (M.F.S)',
    },
    {
      label: 'Master of Fine Arts (M.F.A)',
      value: 'Master of Fine Arts (M.F.A)',
    },
    {
      label: 'Master of Fishery Sciences (M.F.Sc)',
      value: 'Master of Fishery Sciences (M.F.Sc)',
    },
    {
      label: 'Master of Foreign Trade (M.F.T)',
      value: 'Master of Foreign Trade (M.F.T)',
    },
    {
      label: 'Master Of Health Science (M.H.Sc)',
      value: 'Master Of Health Science (M.H.Sc)',
    },
    {
      label: 'Master of Hospital Administration (M.H.A)',
      value: 'Master of Hospital Administration (M.H.A)',
    },
    {
      label: 'Master of Hospitality And Hotel Management (M.H.H.M)',
      value: 'Master of Hospitality And Hotel Management (M.H.H.M)',
    },
    {
      label: 'Master of Hospitality Management (M.H.M)',
      value: 'Master of Hospitality Management (M.H.M)',
    },
    {
      label: 'Master of Human Resource Management (M.H.R.M)',
      value: 'Master of Human Resource Management (M.H.R.M)',
    },
    {
      label:
        'Master of Industrial Relation and Personnel Management (MIR and PM)',
      value:
        'Master of Industrial Relation and Personnel Management (MIR and PM)',
    },
    {
      label: 'Master of International Business (M.I.B)',
      value: 'Master of International Business (M.I.B)',
    },
    {
      label: "Master of Journalism (M.J) Master of Journalism (M.J)'",
      value: "Master of Journalism (M.J) Master of Journalism (M.J)'",
    },
    {
      label: 'Master of Labour Management (M.L.M)',
      value: 'Master of Labour Management (M.L.M)',
    },
    { label: 'Master of Law (LL.M)', value: 'Master of Law (LL.M)' },
    { label: 'Master of Laws (M.L)', value: 'Master of Laws (M.L)' },
    {
      label: 'Master of Library and Information Science (M.L.I.Sc)',
      value: 'Master of Library and Information Science (M.L.I.Sc)',
    },
    {
      label: 'Master of Library Science (M.L.Sc)',
      value: 'Master of Library Science (M.L.Sc)',
    },
    {
      label: 'Master of Management Program (M.M.P)',
      value: 'Master of Management Program (M.M.P)',
    },
    {
      label: 'Master of Management Studies (M.M.S)',
      value: 'Master of Management Studies (M.M.S)',
    },
    {
      label: 'Master of Marketing Management (M.M.M)',
      value: 'Master of Marketing Management (M.M.M)',
    },
    {
      label: 'Master of Occupational Theraphy (M.O.T)',
      value: 'Master of Occupational Theraphy (M.O.T)',
    },
    {
      label: 'Master of Performance Management (M.P.M)',
      value: 'Master of Performance Management (M.P.M)',
    },
    {
      label: 'Master of Performing Arts (M.P.A)',
      value: 'Master of Performing Arts (M.P.A)',
    },
    {
      label: 'Master of Personnel Management (MPM)',
      value: 'Master of Personnel Management (MPM)',
    },
    {
      label:
        'Master of Personnel Management and Industrial Relation (MPM and IR)',
      value:
        'Master of Personnel Management and Industrial Relation (MPM and IR)',
    },
    {
      label: 'Master of Pharmacy (M.Pharma)',
      value: 'Master of Pharmacy (M.Pharma)',
    },
    {
      label: 'Master of Philosophy (M.Phil)',
      value: 'Master of Philosophy (M.Phil)',
    },
    {
      label: 'Master Of Physical Education (M.P.Ed)',
      value: 'Master Of Physical Education (M.P.Ed)',
    },
    {
      label: 'Master of Physiotheraphy (M.P.T)',
      value: 'Master of Physiotheraphy (M.P.T)',
    },
    {
      label: 'Master of Psychiatric Epidemiology (M.P.E)',
      value: 'Master of Psychiatric Epidemiology (M.P.E)',
    },
    {
      label: 'Master of Public Health (M.P.H)',
      value: 'Master of Public Health (M.P.H)',
    },
    {
      label: "Master of Science (M.S) Master of Science (M.S)'",
      value: "Master of Science (M.S) Master of Science (M.S)'",
    },
    {
      label: "Master of Science (M.Sc) Master of Science (M.Sc)'",
      value: "Master of Science (M.Sc) Master of Science (M.Sc)'",
    },
    {
      label: 'Master of Social Dynamics (M.S.D)',
      value: 'Master of Social Dynamics (M.S.D)',
    },
    {
      label: 'Master of Social Work (M.S.W)',
      value: 'Master of Social Work (M.S.W)',
    },
    {
      label: 'Master of Technology (M.Tech)',
      value: 'Master of Technology (M.Tech)',
    },
    {
      label: "Master of Theology (M.Th) Master of Theology (M.Th)'",
      value: "Master of Theology (M.Th) Master of Theology (M.Th)'",
    },
    {
      label: 'Master of Tourism Administrations (M.T.A)',
      value: 'Master of Tourism Administrations (M.T.A)',
    },
    {
      label: 'Master of Tourism Management (M.T.M)',
      value: 'Master of Tourism Management (M.T.M)',
    },
    {
      label: 'Master of Veterinary Science (M.V.Sc)',
      value: 'Master of Veterinary Science (M.V.Sc)',
    },
    {
      label: 'Master of Visual Arts (M.V.A)',
      value: 'Master of Visual Arts (M.V.A)',
    },
    {
      label: 'Master of Vocational (M.Voc)',
      value: 'Master of Vocational (M.Voc)',
    },
    { label: 'Masters in Design (M.Des)', value: 'Masters in Design (M.Des)' },
    {
      label: 'Masters in International Management (M.I.M)',
      value: 'Masters in International Management (M.I.M)',
    },
    {
      label: 'Masters in Public Systems Management (M.P.S.M)',
      value: 'Masters in Public Systems Management (M.P.S.M)',
    },
    {
      label: 'Masters of Hospitality and Tourism Management (M.H.T.M)',
      value: 'Masters of Hospitality and Tourism Management (M.H.T.M)',
    },
    {
      label: 'Masters Programme in International Business (M.P.I.B)',
      value: 'Masters Programme in International Business (M.P.I.B)',
    },
    {
      label: 'Post Graduate Programme (PG Programme)',
      value: 'Post Graduate Programme (PG Programme)',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ];
  
  export const FORM_VALUES_CURRENCY = [
    { label: 'INR', value: 'INR' },
    { label: 'USD', value: 'USD' },
    { label: 'AUD', value: 'AUD' },
    { label: 'AED', value: 'AED' },
    { label: 'SGD', value: 'SGD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
  ];
  
  export const FORM_VALUES_GENDER = [
    {
      label: 'Male',
      value: 'Male',
    },
    {
      label: 'Female',
      value: 'Female',
    },
    {
      label: 'Pefer not to say',
      value: 'Pefer not to say',
    },
  ];
  
  export const FORM_VALUES_SPJAIN_HEAR = [
    {
      label: 'Alumnus of SP Jain',
      value: 'Alumnus of SP Jain',
    },
    {
      label: 'EDM Invite',
      value: 'EDM Invite',
    },
    {
      label: 'Email Promotion',
      value: 'Email Promotion',
    },
    {
      label: 'Info Session',
      value: 'Info Session',
    },
    {
      label: 'Newpaper / Magazine Article or Advertisement',
      value: 'Newpaper / Magazine Article or Advertisement',
    },
    {
      label: 'SP Jain Representative',
      value: 'SP Jain Representative',
    },
    {
      label: 'SP Jain Website',
      value: 'SP Jain Website',
    },
    {
      label: 'Social Media',
      value: 'Social Media',
    },
    {
      label: 'TV / Radio',
      value: 'TV / Radio',
    },
  ];
  
  export const FORM_VALUES_JOBTYPE = [
    {
      label: 'Full Time',
      value: 'Full Time',
    },
    {
      label: 'Part Time',
      value: 'Part Time',
    },
    {
      label: 'Internship',
      value: 'Internship',
    },
    {
      label: 'Articleship',
      value: 'Articleship',
    },
    {
      label: 'Full Time (Still Working)',
      value: 'Full Time (Still Working)',
    },
  ];
  
  export const FROM_VALUES_BATCH = [
    { label: '1991', value: '1991' },
    { label: '1992', value: '1992' },
    { label: '1993', value: '1993' },
    { label: '1994', value: '1994' },
    { label: '1995', value: '1995' },
    { label: '1996', value: '1996' },
    { label: '1997', value: '1997' },
    { label: '1998', value: '1998' },
    { label: '1999', value: '1999' },
    { label: '2000', value: '2000' },
    { label: '2001', value: '2001' },
    { label: '2002', value: '2002' },
    { label: '2003', value: '2003' },
    { label: '2004', value: '2004' },
    { label: '2005', value: '2005' },
    { label: '2006', value: '2006' },
    { label: '2007', value: '2007' },
    { label: '2008', value: '2008' },
    { label: '2010', value: '2010' },
    { label: '2011', value: '2011' },
    { label: '2012', value: '2012' },
    { label: '2013', value: '2013' },
    { label: '2014', value: '2014' },
    { label: '2015', value: '2015' },
    { label: '2016', value: '2016' },
    { label: '2017', value: '2017' },
    { label: '2018', value: '2018' },
    { label: '2019', value: '2019' },
    { label: '2020', value: '2020' },
    { label: '2021', value: '2021' },
    { label: '2022', value: '2022' },
  ];
  
  export const FORM_VALUES_YESNO = [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ];
  
  export const FORM_VALUES_UNIVERSITY = [
    {
      label:
        'Academy of Maritime Education and Training (AMET), Chennai ,Tamil Nadu',
      value:
        'Academy of Maritime Education and Training (AMET), Chennai ,Tamil Nadu',
    },
    {
      label: 'Acharya Nagarjuna University, Guntur – 522510 ,Andhra Pradesh',
      value: 'Acharya Nagarjuna University, Guntur – 522510 ,Andhra Pradesh',
    },
    {
      label:
        'Alagappa University, Alagappapuram, Sivaganga, Karaikudi – 630003 ,Tamil Nadu',
      value:
        'Alagappa University, Alagappapuram, Sivaganga, Karaikudi – 630003 ,Tamil Nadu',
    },
    {
      label: 'Aligarh Muslim University, Aligarh, 202002 ,Uttar Pradesh',
      value: 'Aligarh Muslim University, Aligarh, 202002 ,Uttar Pradesh',
    },
    {
      label: 'Amity University Rajasthan, Jaipur – 303002 ,Rajasthan',
      value: 'Amity University Rajasthan, Jaipur – 303002 ,Rajasthan',
    },
    {
      label:
        'Amity University,Amity University Campus Sector - 125, Distt. Gautam Buddha Nagar,Noida – 201313 ,Uttar Pradesh',
      value:
        'Amity University,Amity University Campus Sector - 125, Distt. Gautam Buddha Nagar,Noida – 201313 ,Uttar Pradesh',
    },
    {
      label: 'Andhra University,Visakhapatnam – 530003 ,Andhra Pradesh',
      value: 'Andhra University,Visakhapatnam – 530003 ,Andhra Pradesh',
    },
    {
      label:
        'Arunachal University of Studies, Knowledge City, NH-52 Namsai, District- Namsai – 792103 ,Arunachal Pradesh',
      value:
        'Arunachal University of Studies, Knowledge City, NH-52 Namsai, District- Namsai – 792103 ,Arunachal Pradesh',
    },
    {
      label: 'Assam Don Bosco University ,Assam',
      value: 'Assam Don Bosco University ,Assam',
    },
    {
      label:
        'Assam Down Town University,Sankar Madhab Path, Gandhinagar, Panikhaiti,Guwahati – 781026 ,Assam',
      value:
        'Assam Down Town University,Sankar Madhab Path, Gandhinagar, Panikhaiti,Guwahati – 781026 ,Assam',
    },
    {
      label:
        'Avinashilingam Institute for Home Science and Higher Education for Women,Bharathi Park Road,Coimbatore – 641043 ,Tamil nadu',
      value:
        'Avinashilingam Institute for Home Science and Higher Education for Women,Bharathi Park Road,Coimbatore – 641043 ,Tamil nadu',
    },
    {
      label: 'Awadhesh Pratap Singh University, Rewa – 486003 ,Madhya Pradesh',
      value: 'Awadhesh Pratap Singh University, Rewa – 486003 ,Madhya Pradesh',
    },
    {
      label:
        'Babasaheb Bhimrao Ambedkar Bihar University, Muzaffarpur – 842001 ,Bihar',
      value:
        'Babasaheb Bhimrao Ambedkar Bihar University, Muzaffarpur – 842001 ,Bihar',
    },
    {
      label:
        'Babasaheb Bhimrao Ambedkar University, Lucknow – 226025 ,Uttar Pradesh',
      value:
        'Babasaheb Bhimrao Ambedkar University, Lucknow – 226025 ,Uttar Pradesh',
    },
    {
      label: 'Banaras Hindu University, Varanasi – 221005 ,Uttar Pradesh',
      value: 'Banaras Hindu University, Varanasi – 221005 ,Uttar Pradesh',
    },
    {
      label: 'Bangalore University, Bangalore – 560056 ,Karnataka',
      value: 'Bangalore University, Bangalore – 560056 ,Karnataka',
    },
    {
      label: 'Barkatullah University, Bhopal – 462026 ,Madhya Pradesh',
      value: 'Barkatullah University, Bhopal – 462026 ,Madhya Pradesh',
    },
    {
      label: 'Berhampur University, Berhampur – 760007 ,Odisha',
      value: 'Berhampur University, Berhampur – 760007 ,Odisha',
    },
    {
      label:
        'Bharath Institute of Higher Education and Research (University), Chennai ,Tamil Nadu',
      value:
        'Bharath Institute of Higher Education and Research (University), Chennai ,Tamil Nadu',
    },
    {
      label: 'Bharathiar University,Coimbatore – 641046 ,Tamil Nadu',
      value: 'Bharathiar University,Coimbatore – 641046 ,Tamil Nadu',
    },
    {
      label:
        'Bharathidasan University, Palkalaiperur,Tiruchirapalli – 620024 ,Tamil Nadu',
      value:
        'Bharathidasan University, Palkalaiperur,Tiruchirapalli – 620024 ,Tamil Nadu',
    },
    {
      label: 'Bharati Vidyapeeth University, Pune – 411030 ,Maharashtra',
      value: 'Bharati Vidyapeeth University, Pune – 411030 ,Maharashtra',
    },
    {
      label:
        'Birla Institute of Technology and Science, Pilani – 333031 ,Rajasthan',
      value:
        'Birla Institute of Technology and Science, Pilani – 333031 ,Rajasthan',
    },
    {
      label: 'BLDE University, Vijayapur ,Karnataka',
      value: 'BLDE University, Vijayapur ,Karnataka',
    },
    {
      label: 'Bundelkhand University, Jhansi – 284128 ,Uttar Pradesh',
      value: 'Bundelkhand University, Jhansi – 284128 ,Uttar Pradesh',
    },
    {
      label: 'Central University of Gujarat, Gandhinagar – 382030 ,Gujarat',
      value: 'Central University of Gujarat, Gandhinagar – 382030 ,Gujarat',
    },
    {
      label: 'Central University of Haryana, Mahendragarh – 123029 ,Haryana',
      value: 'Central University of Haryana, Mahendragarh – 123029 ,Haryana',
    },
    {
      label:
        'Central University of Himachal Pradesh, Dharamshala, Kangra – 176215 ,Himachal Pradesh',
      value:
        'Central University of Himachal Pradesh, Dharamshala, Kangra – 176215 ,Himachal Pradesh',
    },
    {
      label:
        'Central University of Jammu, Samba, Jammu – 181143 ,Jammu and Kashmir',
      value:
        'Central University of Jammu, Samba, Jammu – 181143 ,Jammu and Kashmir',
    },
    {
      label:
        'Central University of Jharkhand,CTI Campus, Ratu-Lohardaga Road, Brambe, Ranchi – 835205 ,Jharkhand',
      value:
        'Central University of Jharkhand,CTI Campus, Ratu-Lohardaga Road, Brambe, Ranchi – 835205 ,Jharkhand',
    },
    {
      label:
        'Central University of Kashmir, Srinagar – 190015 ,Jammu and Kashmir',
      value:
        'Central University of Kashmir, Srinagar – 190015 ,Jammu and Kashmir',
    },
    {
      label: 'Central University of Kerala, Kasargod – 671316 ,Kerala',
      value: 'Central University of Kerala, Kasargod – 671316 ,Kerala',
    },
    {
      label: 'Central University of Orissa, Landiguda, Koraput – 764021 ,Odisha',
      value: 'Central University of Orissa, Landiguda, Koraput – 764021 ,Odisha',
    },
    {
      label: 'Central University of Punjab, Bathinda – 151001 ,Punjab',
      value: 'Central University of Punjab, Bathinda – 151001 ,Punjab',
    },
    {
      label: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
      value: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
    },
    {
      label: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
      value: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
    },
    {
      label: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
      value: 'Central University of Rajasthan, Ajmer – 305817 ,Rajasthan',
    },
    {
      label: 'Central University of South Bihar, Patna – 800014 ,Bihar',
      value: 'Central University of South Bihar, Patna – 800014 ,Bihar',
    },
    {
      label: 'Central University of Tamil Nadu, Thiruvarur – 610101 ,Tamil Nadu',
      value: 'Central University of Tamil Nadu, Thiruvarur – 610101 ,Tamil Nadu',
    },
    {
      label:
        'Centurion University of Technology and Management, Sitapur, Uppalada, Parlakhemundi – 761211 ,Odisha',
      value:
        'Centurion University of Technology and Management, Sitapur, Uppalada, Parlakhemundi – 761211 ,Odisha',
    },
    {
      label: 'Ch. Charan Singh University, Meerut – 250005 ,Uttar Pradesh',
      value: 'Ch. Charan Singh University, Meerut – 250005 ,Uttar Pradesh',
    },
    {
      label: 'Chanakya National Law University, Patna – 800001 ,Bihar',
      value: 'Chanakya National Law University, Patna – 800001 ,Bihar',
    },
    {
      label:
        'Chandigarh University , NH-95,Chandigarh-Ludhiana Highway Gharuan, Mohali –140413 ,Punjab',
      value:
        'Chandigarh University , NH-95,Chandigarh-Ludhiana Highway Gharuan, Mohali –140413 ,Punjab',
    },
    {
      label:
        'Charotar University of Science and Technology (Charusat), Anand – 388421 ,Gujarat',
      value:
        'Charotar University of Science and Technology (Charusat), Anand – 388421 ,Gujarat',
    },
    {
      label: 'Chaudhary Devi Lal University, Sirsa – 125055 ,Haryana',
      value: 'Chaudhary Devi Lal University, Sirsa – 125055 ,Haryana',
    },
    {
      label: 'Chennai Mathematical Institute, Chennai – 603103 ,Tamil Nadu',
      value: 'Chennai Mathematical Institute, Chennai – 603103 ,Tamil Nadu',
    },
    {
      label: 'Chettinad Academy of Research and Education, Chennai ,Tamil Nadu',
      value: 'Chettinad Academy of Research and Education, Chennai ,Tamil Nadu',
    },
    {
      label:
        'Chhatrapati Shahu Ji Maharaj University, Kanpur – 208024 ,Uttar Pradesh',
      value:
        'Chhatrapati Shahu Ji Maharaj University, Kanpur – 208024 ,Uttar Pradesh',
    },
    {
      label: 'Chitkara University, Solan – 174103 ,Himachal Pradesh',
      value: 'Chitkara University, Solan – 174103 ,Himachal Pradesh',
    },
    {
      label:
        'Cochin University of Science and Technology, Cochin – 682022 ,Kerala',
      value:
        'Cochin University of Science and Technology, Cochin – 682022 ,Kerala',
    },
    {
      label: 'D. Y. Patil Education Society, Kolhapur – 416006 ,Maharashtra',
      value: 'D. Y. Patil Education Society, Kolhapur – 416006 ,Maharashtra',
    },
    {
      label:
        'Dakshina Bharat Hindi Prachar Sabha,Thanikachalam Road, T Nagar, Chennai, Madras – 600017 ,Tamil Nadu',
      value:
        'Dakshina Bharat Hindi Prachar Sabha,Thanikachalam Road, T Nagar, Chennai, Madras – 600017 ,Tamil Nadu',
    },
    {
      label:
        'Datta Meghe Institute of Medical Sciences , Wardha – 442004 ,Maharashtra',
      value:
        'Datta Meghe Institute of Medical Sciences , Wardha – 442004 ,Maharashtra',
    },
    {
      label:
        'Davangere University, Shivagangothri, Davangere – 577002 ,Karnataka',
      value:
        'Davangere University, Shivagangothri, Davangere – 577002 ,Karnataka',
    },
    {
      label:
        'Dayalbagh Educational Institute, Dayalbagh,Agra – 282005 ,Uttar Pradesh',
      value:
        'Dayalbagh Educational Institute, Dayalbagh,Agra – 282005 ,Uttar Pradesh',
    },
    {
      label:
        'Deccan College Post-Graduate and Research Institute, Pune – 411006 ,Maharashtra',
      value:
        'Deccan College Post-Graduate and Research Institute, Pune – 411006 ,Maharashtra',
    },
    {
      label:
        'Deenbandhu Chhotu Ram University of Science and Technology, Murthal, Sonepat – 131039 ,Haryana',
      value:
        'Deenbandhu Chhotu Ram University of Science and Technology, Murthal, Sonepat – 131039 ,Haryana',
    },
    {
      label:
        'Defence Institute of Advanced Technology, Girinagar, Pune – 411025 ,Maharashtra',
      value:
        'Defence Institute of Advanced Technology, Girinagar, Pune – 411025 ,Maharashtra',
    },
    {
      label:
        'Delhi Technology University,Bawana Road Shahbad Daulatpur – 110042 ,Delhi',
      value:
        'Delhi Technology University,Bawana Road Shahbad Daulatpur – 110042 ,Delhi',
    },
    {
      label: 'Dev Sanskriti Vishwavidyalaya, Haridwar – 249411 ,Uttarakhand',
      value: 'Dev Sanskriti Vishwavidyalaya, Haridwar – 249411 ,Uttarakhand',
    },
    {
      label:
        'Devi Ahilya Vishwavidyala,Nalanda Parisar, R N T Marg,Indore – 452001 ,Madhya Pradesh',
      value:
        'Devi Ahilya Vishwavidyala,Nalanda Parisar, R N T Marg,Indore – 452001 ,Madhya Pradesh',
    },
    {
      label: 'Dharmsinh Desai University, Nadiad – 387001 ,Gujarat',
      value: 'Dharmsinh Desai University, Nadiad – 387001 ,Gujarat',
    },
    {
      label:
        'Dhirubhai Ambani Institute of Information and Communication Technology (DA-IICT),Gandhinagar – 382007 ,Gujarat',
      value:
        'Dhirubhai Ambani Institute of Information and Communication Technology (DA-IICT),Gandhinagar – 382007 ,Gujarat',
    },
    {
      label: 'Dibrugarh University, Dibrugarh – 786004 ,Assam',
      value: 'Dibrugarh University, Dibrugarh – 786004 ,Assam',
    },
    {
      label: 'Doon University, Dehradun – 248001 ,Uttarakhand',
      value: 'Doon University, Dehradun – 248001 ,Uttarakhand',
    },
    {
      label:
        'Dr. Babasaheb Ambedkar Marathwada University,Jaisingapura, Near Soneri Mahal,Aurangabad – 431004 ,Maharashtra',
      value:
        'Dr. Babasaheb Ambedkar Marathwada University,Jaisingapura, Near Soneri Mahal,Aurangabad – 431004 ,Maharashtra',
    },
    {
      label:
        'Dr. Babasaheb AmbedkarTechnologicalUniversity,Raigad Dist – 402103 ,Maharashtra',
      value:
        'Dr. Babasaheb AmbedkarTechnologicalUniversity,Raigad Dist – 402103 ,Maharashtra',
    },
    {
      label: 'Dr. Bhim Rao Ambedkar University, Agra – 282004 ,Uttar Pradesh',
      value: 'Dr. Bhim Rao Ambedkar University, Agra – 282004 ,Uttar Pradesh',
    },
    {
      label: 'Dr. C. V. Raman University, Bilaspur – 495113 ,Chhattisgarh',
      value: 'Dr. C. V. Raman University, Bilaspur – 495113 ,Chhattisgarh',
    },
    {
      label: 'Dr. D.Y. Patil Vidyapeeth, Pune – 411018 ,Maharashtra',
      value: 'Dr. D.Y. Patil Vidyapeeth, Pune – 411018 ,Maharashtra',
    },
    {
      label: 'Dr. Harisingh Gour Vishwavidyalaya, Sagar – 470003 ,Madhya Pradesh',
      value: 'Dr. Harisingh Gour Vishwavidyalaya, Sagar – 470003 ,Madhya Pradesh',
    },
    {
      label:
        'Dr. M. G. R. Educational and Research Institute , Chennai - 600095 ,Tamil Nadu',
      value:
        'Dr. M. G. R. Educational and Research Institute , Chennai - 600095 ,Tamil Nadu',
    },
    {
      label:
        'Dravidian University ,Srinivasavanam, Kuppam,Chittoor – 517426 ,Andhra Pradesh',
      value:
        'Dravidian University ,Srinivasavanam, Kuppam,Chittoor – 517426 ,Andhra Pradesh',
    },
    {
      label: 'Eternal University ,Himachal Pradesh',
      value: 'Eternal University ,Himachal Pradesh',
    },
    {
      label: 'Fakir Mohan University, Balasore – 756020 ,Odisha',
      value: 'Fakir Mohan University, Balasore – 756020 ,Odisha',
    },
    {
      label:
        'Gandhi Institute of Technology and Management [GITAM], Rushikonda, Visakhapatnam – 530045 ,Andhra Pradesh',
      value:
        'Gandhi Institute of Technology and Management [GITAM], Rushikonda, Visakhapatnam – 530045 ,Andhra Pradesh',
    },
    {
      label: 'Gandhigram Rural Institute , Dindigul – 624302 ,Tamil Nadu',
      value: 'Gandhigram Rural Institute , Dindigul – 624302 ,Tamil Nadu',
    },
    {
      label:
        'Gauhati University ,Gopinath Bardoloi Nagar,Guwahati - 781014 ,Assam',
      value:
        'Gauhati University ,Gopinath Bardoloi Nagar,Guwahati - 781014 ,Assam',
    },
    {
      label:
        'Gautam Buddha University,Yamuna Express Way,Greater Noida – 201310 ,Uttar Pradesh',
      value:
        'Gautam Buddha University,Yamuna Express Way,Greater Noida – 201310 ,Uttar Pradesh',
    },
    {
      label: 'GLA University, Chaumuhan, Mathura – 281406 ,Uttar Pradesh',
      value: 'GLA University, Chaumuhan, Mathura – 281406 ,Uttar Pradesh',
    },
    {
      label:
        'Gokhale Institute of Politics and Economics, Pune – 411004 ,Maharashtra',
      value:
        'Gokhale Institute of Politics and Economics, Pune – 411004 ,Maharashtra',
    },
    {
      label: 'Graphic Era University, Dehradun ,Uttarakhand',
      value: 'Graphic Era University, Dehradun ,Uttarakhand',
    },
    {
      label: 'Gujarat Ayurved University, Jamnagar – 361008 ,Gujarat',
      value: 'Gujarat Ayurved University, Jamnagar – 361008 ,Gujarat',
    },
    {
      label:
        'Gujarat Forensic Sciences University, Gandhinagar – 382009 ,Gujarat',
      value:
        'Gujarat Forensic Sciences University, Gandhinagar – 382009 ,Gujarat',
    },
    {
      label: 'Gujarat National Law University, Gandhinagar – 382007 ,Gujarat',
      value: 'Gujarat National Law University, Gandhinagar – 382007 ,Gujarat',
    },
    {
      label: 'Gujarat University, Ahmedabad, 380009,Gujarat',
      value: 'Gujarat University, Ahmedabad, 380009,Gujarat',
    },
    {
      label: 'Gujarat Vidyapith, Ahmedabad – 380014 ,Gujarat',
      value: 'Gujarat Vidyapith, Ahmedabad – 380014 ,Gujarat',
    },
    {
      label: 'Gulbarga University, Gulbarga – 585106 ,Karnataka',
      value: 'Gulbarga University, Gulbarga – 585106 ,Karnataka',
    },
    {
      label:
        'Guru Jambheshwar University of Science & Technology, Hisa – 125001 ,Haryana ',
      value:
        'Guru Jambheshwar University of Science & Technology, Hisa – 125001 ,Haryana ',
    },
    {
      label: 'Guru Nanak Dev University, Amritsar – 143005 Punjab ',
      value: 'Guru Nanak Dev University, Amritsar – 143005 Punjab ',
    },
    {
      label: 'Gurukula Kangri Vishwavidyalaya, Haridwar ,Uttarakhand',
      value: 'Gurukula Kangri Vishwavidyalaya, Haridwar ,Uttarakhand',
    },
    {
      label: 'Hemchandracharya North Gujarat University,Patan – 384265 ,Gujarat',
      value: 'Hemchandracharya North Gujarat University,Patan – 384265 ,Gujarat',
    },
    {
      label:
        'Hemwati Nandan Bahuguna Garhwal University, Srinagar – Garhwal, Pauri – 246174 ,Uttarakhand',
      value:
        'Hemwati Nandan Bahuguna Garhwal University, Srinagar – Garhwal, Pauri – 246174 ,Uttarakhand',
    },
    {
      label: 'Himachal Pradesh University, Shimla – 171005 ,Himachal Pradesh',
      value: 'Himachal Pradesh University, Shimla – 171005 ,Himachal Pradesh',
    },
    {
      label:
        'Hindustan Institute of Technology and Science (HITS) ,Chennai – 603103 ,Tamil Nadu',
      value:
        'Hindustan Institute of Technology and Science (HITS) ,Chennai – 603103 ,Tamil Nadu',
    },
    {
      label: 'Homi Bhabha National Institut, Mumbai – 400094 ,Maharashtra',
      value: 'Homi Bhabha National Institut, Mumbai – 400094 ,Maharashtra',
    },
    {
      label:
        'ICFAI University Tripura,Simna Road, PO Kamalghat, Mohanpur, West Tripura,Agartala – 799210 ,Tripura',
      value:
        'ICFAI University Tripura,Simna Road, PO Kamalghat, Mohanpur, West Tripura,Agartala – 799210 ,Tripura',
    },
    {
      label: 'IFTM University, Moradabad – 244102 ,Uttar Pradesh',
      value: 'IFTM University, Moradabad – 244102 ,Uttar Pradesh',
    },
    {
      label:
        'IIHMR University, IIHMR University, 1 Prabhu Dayal Marg, Near Sanganer Airport,Jaipur – 302029 ,Rajasthan',
      value:
        'IIHMR University, IIHMR University, 1 Prabhu Dayal Marg, Near Sanganer Airport,Jaipur – 302029 ,Rajasthan',
    },
    {
      label: 'Indian Agricultural Research Institute – 110012 ,Delhi',
      value: 'Indian Agricultural Research Institute – 110012 ,Delhi',
    },
    {
      label:
        'Indian Institute of Foreign Trade, Qutab Institutional Area – 110016 ,Delhi',
      value:
        'Indian Institute of Foreign Trade, Qutab Institutional Area – 110016 ,Delhi',
    },
    {
      label:
        'Indian Institute of Science, C V Raman Road, Bengaluru – 560012 ,Karnataka',
      value:
        'Indian Institute of Science, C V Raman Road, Bengaluru – 560012 ,Karnataka',
    },
    {
      label: 'Indian Law Institute – 110001 ,Delhi',
      value: 'Indian Law Institute – 110001 ,Delhi',
    },
    {
      label:
        'Indira Gandhi Institute of Development Research,Gen. A. K. Vaidya Marg Goregaon East,Mumbai – 400065 ,Maharashtra',
      value:
        'Indira Gandhi Institute of Development Research,Gen. A. K. Vaidya Marg Goregaon East,Mumbai – 400065 ,Maharashtra',
    },
    {
      label:
        'Indira Gandhi National Tribal University, Amarkantak – 484887 ,Madhya Pradesh',
      value:
        'Indira Gandhi National Tribal University, Amarkantak – 484887 ,Madhya Pradesh',
    },
    {
      label:
        'Indraprastha Institute of Information Technology, Okhla Industrial Estate, Phase-III – 110020 ,Delhi',
      value:
        'Indraprastha Institute of Information Technology, Okhla Industrial Estate, Phase-III – 110020 ,Delhi',
    },
    {
      label:
        'Institute of Advanced Studies in Education, Sardarshahar ,Rajasthan',
      value:
        'Institute of Advanced Studies in Education, Sardarshahar ,Rajasthan',
    },
    {
      label:
        'Institute of Chemical Technology, Matunga, Mumbai – 400019 ,Maharashtra',
      value:
        'Institute of Chemical Technology, Matunga, Mumbai – 400019 ,Maharashtra',
    },
    {
      label:
        'Institute of Liver and Biliary Sciences , New Delhi – 110070 ,Delhi',
      value:
        'Institute of Liver and Biliary Sciences , New Delhi – 110070 ,Delhi',
    },
    {
      label: 'Integral University, Lucknow – 226026 ,Uttar Pradesh',
      value: 'Integral University, Lucknow – 226026 ,Uttar Pradesh',
    },
    {
      label:
        'International Institute of Information Technology, Gachibowli, Hyderabad – 500032 ,Telangana',
      value:
        'International Institute of Information Technology, Gachibowli, Hyderabad – 500032 ,Telangana',
    },
    {
      label:
        'Islamic University of Science and Technology,Awantipora – 192122 ,Jammu and Kashmir',
      value:
        'Islamic University of Science and Technology,Awantipora – 192122 ,Jammu and Kashmir',
    },
    {
      label:
        'ITM University, Gwalior ,Turari, NH-75, Jhansi Road,Gwalior – 474001 ,Madhya Pradesh',
      value:
        'ITM University, Gwalior ,Turari, NH-75, Jhansi Road,Gwalior – 474001 ,Madhya Pradesh',
    },
    {
      label: 'Jadavpur University, Kolkata – 700032 West Bengal  ',
      value: 'Jadavpur University, Kolkata – 700032 West Bengal  ',
    },
  
    {
      label: 'Jagan Nath University, Jaipur – 303901 ,Rajasthan',
      value: 'Jagan Nath University, Jaipur – 303901 ,Rajasthan',
    },
    {
      label: 'Jain University ,Bengaluru – 560027 ,Karnataka',
      value: 'Jain University ,Bengaluru – 560027 ,Karnataka',
    },
    {
      label: 'Jain Vishva Bharati Institute, Dist. Nagaur,Ladnun',
      value: 'Jain Vishva Bharati Institute, Dist. Nagaur,Ladnun',
    },
    {
      label: 'Jaipur National University, Jaipur – 302017 ,Rajasthan',
      value: 'Jaipur National University, Jaipur – 302017 ,Rajasthan',
    },
    {
      label: 'Jamia Hamdard (Hamdard University) , Hamdard Nagar – 110062 ,Delhi',
      value: 'Jamia Hamdard (Hamdard University) , Hamdard Nagar – 110062 ,Delhi',
    },
    {
      label:
        'Jamia Millia Islamia, Maulana Mohammed Ali Jauhar Marg – 110025 ,Delhi',
      value:
        'Jamia Millia Islamia, Maulana Mohammed Ali Jauhar Marg – 110025 ,Delhi',
    },
    {
      label:
        'Janardhan Rai Nagar Rajasthan Vidyapeeth , Pratap Nagar, Airport Road, Udaipur – 313 001 ,Rajasthan',
      value:
        'Janardhan Rai Nagar Rajasthan Vidyapeeth , Pratap Nagar, Airport Road, Udaipur – 313 001 ,Rajasthan',
    },
    {
      label:
        'Jawaharlal Nehru Centre for Advanced Scientific Research (JNCASR) , Bengaluru – 560064 ,Karnataka',
      value:
        'Jawaharlal Nehru Centre for Advanced Scientific Research (JNCASR) , Bengaluru – 560064 ,Karnataka',
    },
    {
      label:
        'Jawaharlal Nehru Technological University Hyderabad – 500085 ,Telangana',
      value:
        'Jawaharlal Nehru Technological University Hyderabad – 500085 ,Telangana',
    },
    {
      label:
        'Jawaharlal Nehru Technological University Kakinada, East Godavari, Kakinada – 533003 ,Andhra Pradesh',
      value:
        'Jawaharlal Nehru Technological University Kakinada, East Godavari, Kakinada – 533003 ,Andhra Pradesh',
    },
    {
      label: 'Jawaharlal Nehru University – 110067 ,Delhi',
      value: 'Jawaharlal Nehru University – 110067 ,Delhi',
    },
    {
      label:
        "Jayoti Vidyapeeth Women's University,Vedaant Gyan Valley, Village- Jharna, Mahla Jobner Link Road, Jaipur Ajmer Express Way, Nh-8,Jaipur - 303122 ,Rajasthan",
      value:
        "Jayoti Vidyapeeth Women's University,Vedaant Gyan Valley, Village- Jharna, Mahla Jobner Link Road, Jaipur Ajmer Express Way, Nh-8,Jaipur - 303122 ,Rajasthan",
    },
    {
      label: 'Jaypee Institute of Information Technology, Noida ,Uttar Pradesh',
      value: 'Jaypee Institute of Information Technology, Noida ,Uttar Pradesh',
    },
    {
      label:
        'Jaypee University of Engineering and Technology, Guna – 473226 ,Madhya Pradesh',
      value:
        'Jaypee University of Engineering and Technology, Guna – 473226 ,Madhya Pradesh',
    },
    {
      label:
        'Jaypee University of Information Technology, Waknaghat, Kandaghat, Solan – 173215 ,Himachal Pradesh',
      value:
        'Jaypee University of Information Technology, Waknaghat, Kandaghat, Solan – 173215 ,Himachal Pradesh',
    },
    {
      label:
        'JECRC University, Plot IS - 2036 to IS 2039, Ramchandrapura Industrial Area, Vidhani, Sitapura Extension,Jaipur – 303905 ,Rajasthan',
      value:
        'JECRC University, Plot IS - 2036 to IS 2039, Ramchandrapura Industrial Area, Vidhani, Sitapura Extension,Jaipur – 303905 ,Rajasthan',
    },
    {
      label:
        'Jharkhand Rai University,Kamre, Ratu Road,Ranchi - 835222 ,Jharkhand',
      value:
        'Jharkhand Rai University,Kamre, Ratu Road,Ranchi - 835222 ,Jharkhand',
    },
    {
      label: 'Jiwaji University, Gwalior – 474011 ,Madhya Pradesh',
      value: 'Jiwaji University, Gwalior – 474011 ,Madhya Pradesh',
    },
    {
      label:
        'JSS Academy of Higher Education and Research ,Sri Shivarathreeshwara Nagar, Mysuru - 570015 ,Karnataka',
      value:
        'JSS Academy of Higher Education and Research ,Sri Shivarathreeshwara Nagar, Mysuru - 570015 ,Karnataka',
    },
    {
      label:
        'Kakatiya University, Vidyaranyapuri, Hanamkonda, Warangal – 506009,Telangana',
      value:
        'Kakatiya University, Vidyaranyapuri, Hanamkonda, Warangal – 506009,Telangana',
    },
    {
      label:
        'Kalasalingam Academy of Research and Education, Srivilliputhur ,Tamil Nadu',
      value:
        'Kalasalingam Academy of Research and Education, Srivilliputhur ,Tamil Nadu',
    },
    {
      label:
        'Kalinga Institute of Industrial Technology, Bhubaneswar – 751024 ,Odisha',
      value:
        'Kalinga Institute of Industrial Technology, Bhubaneswar – 751024 ,Odisha',
    },
    {
      label:
        'Kameshwar Singh Darbhanga Sanskrit University, Darbhanga – 846008 ,Bihar',
      value:
        'Kameshwar Singh Darbhanga Sanskrit University, Darbhanga – 846008 ,Bihar',
    },
    {
      label:
        'Kannada University, Vidyaranya,Hospete Taluk, Bellari District – 583276 ,Karnataka',
      value:
        'Kannada University, Vidyaranya,Hospete Taluk, Bellari District – 583276 ,Karnataka',
    },
    {
      label: 'Kannur University, Kannur – 670002 ,Kerala',
      value: 'Kannur University, Kannur – 670002 ,Kerala',
    },
    {
      label: 'Karnatak University, Pavate Nagar, Dharwad – 580003 ,Karnataka',
      value: 'Karnatak University, Pavate Nagar, Dharwad – 580003 ,Karnataka',
    },
    {
      label: 'Karnataka State Law University, Hubballi – 580025 ,Karnataka',
      value: 'Karnataka State Law University, Hubballi – 580025 ,Karnataka',
    },
    {
      label: "Karnataka State Women's University, Bijapur – 586108 ,Karnataka",
      value: "Karnataka State Women's University, Bijapur – 586108 ,Karnataka",
    },
    {
      label: 'Karpagam Academy of Higher Education,Coimbatore ,Tamil Nadu',
      value: 'Karpagam Academy of Higher Education,Coimbatore ,Tamil Nadu',
    },
    {
      label:
        'Karunya Institute of Technology and Sciences , Coimbatore – 641114 ,Tamil Nadu',
      value:
        'Karunya Institute of Technology and Sciences , Coimbatore – 641114 ,Tamil Nadu',
    },
    {
      label:
        'Kavikulaguru Kalidas Sanskrit University, Ramtek, Nagpur – 441106 ,Maharashtra',
      value:
        'Kavikulaguru Kalidas Sanskrit University, Ramtek, Nagpur – 441106 ,Maharashtra',
    },
    {
      label: 'King George Medical University, Lucknow – 226003 ,Uttar Pradesh',
      value: 'King George Medical University, Lucknow – 226003 ,Uttar Pradesh',
    },
    {
      label:
        'KLE Academy of Higher Education and Research, Belgaum – 590010 ,Karnataka',
      value:
        'KLE Academy of Higher Education and Research, Belgaum – 590010 ,Karnataka',
    },
    {
      label: 'Kolhan University, Chaibasa – 833202 ,Jharkhand',
      value: 'Kolhan University, Chaibasa – 833202 ,Jharkhand',
    },
    {
      label:
        'Koneru Lakshmaiah Education Foundation ,Green Fields, Vaddeswaram,Guntur – 522502 ,Andhra Pradesh',
      value:
        'Koneru Lakshmaiah Education Foundation ,Green Fields, Vaddeswaram,Guntur – 522502 ,Andhra Pradesh',
    },
    {
      label: 'Krishna Institute of Medical Science, Karad ,Maharashtra',
      value: 'Krishna Institute of Medical Science, Karad ,Maharashtra',
    },
    {
      label: 'Kumaun University, Nainital – 263001 ,Uttarakhand',
      value: 'Kumaun University, Nainital – 263001 ,Uttarakhand',
    },
    {
      label: 'Kurukshetra University, Kurukshetra – 136119 ,Haryana',
      value: 'Kurukshetra University, Kurukshetra – 136119 ,Haryana',
    },
    {
      label: 'Kuvempu University, Shankaraghatta,Shimoga – 577451 ,Karnataka',
      value: 'Kuvempu University, Shankaraghatta,Shimoga – 577451 ,Karnataka',
    },
    {
      label:
        'Lakshmibai National Institute of Physical Education, Gwalior – 474002 ,Madhya Pradesh',
      value:
        'Lakshmibai National Institute of Physical Education, Gwalior – 474002 ,Madhya Pradesh',
    },
    {
      label:
        'Lalit Narayan Mithila University,Kameshwarnagar, Darbhanga – 846004 ,Bihar',
      value:
        'Lalit Narayan Mithila University,Kameshwarnagar, Darbhanga – 846004 ,Bihar',
    },
    {
      label: 'Lingaya’s University,Faridabad ,Haryana',
      value: 'Lingaya’s University,Faridabad ,Haryana',
    },
    {
      label: 'Magadh University, Bodhgaya, Gaya – 824234 ,Bihar',
      value: 'Magadh University, Bodhgaya, Gaya – 824234 ,Bihar',
    },
    {
      label:
        'Maharaja Agrasen University,Atal Shiksha Kalujhanda, Near Barotiwala, Tehsil Baddi, Distt. Solan,Kalujhanda Barotiwala Baddi Distt Solan –174103 ,Himachal Pradesh',
      value:
        'Maharaja Agrasen University,Atal Shiksha Kalujhanda, Near Barotiwala, Tehsil Baddi, Distt. Solan,Kalujhanda Barotiwala Baddi Distt Solan –174103 ,Himachal Pradesh',
    },
    {
      label:
        'Maharaja Krishnakumarsinhji Bhavnagar University,Sardar Patel Campus,Bhavnagar – 364001 ,Gujarat',
      value:
        'Maharaja Krishnakumarsinhji Bhavnagar University,Sardar Patel Campus,Bhavnagar – 364001 ,Gujarat',
    },
    {
      label:
        'Maharishi Mahesh Yogi Vedic Vishwavidyalaya,Village-Karaundi, Post Office-Mahner, Dheemarkheda,Katni – 483332 ,Madhya Pradesh',
      value:
        'Maharishi Mahesh Yogi Vedic Vishwavidyalaya,Village-Karaundi, Post Office-Mahner, Dheemarkheda,Katni – 483332 ,Madhya Pradesh',
    },
    {
      label:
        'Maharishi Markandeshwar University, Sadopur, Ambala – 134007 ,Haryana',
      value:
        'Maharishi Markandeshwar University, Sadopur, Ambala – 134007 ,Haryana',
    },
    {
      label: 'Maharshi Dayanand Saraswati University, Ajmer – 305009 ,Rajasthan',
      value: 'Maharshi Dayanand Saraswati University, Ajmer – 305009 ,Rajasthan',
    },
    {
      label: 'Maharshi Dayanand University, Rohtak – 124001 ,Haryana ',
      value: 'Maharshi Dayanand University, Rohtak – 124001 ,Haryana ',
    },
    {
      label: 'Maharshi Markandeshwar University,Mullana-Ambala ,Haryana',
      value: 'Maharshi Markandeshwar University,Mullana-Ambala ,Haryana',
    },
    {
      label:
        'Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya, Wardha – 442005 ,Maharashtra',
      value:
        'Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya, Wardha – 442005 ,Maharashtra',
    },
    {
      label:
        'Mahatma Gandhi Chitrakoot Gramodaya Vishwavidyalaya, Chitrakoot, Satna – 485334 ,Madhya Pradesh',
      value:
        'Mahatma Gandhi Chitrakoot Gramodaya Vishwavidyalaya, Chitrakoot, Satna – 485334 ,Madhya Pradesh',
    },
    {
      label:
        'Mahatma Gandhi Kashi Vidyapith,Englishiya Line,Varanasi – 221002 ,Uttar Pradesh',
      value:
        'Mahatma Gandhi Kashi Vidyapith,Englishiya Line,Varanasi – 221002 ,Uttar Pradesh',
    },
    {
      label: 'Mahatma Gandhi University, Athirampuzha, Kottayam – 686560 ,Kerala',
      value: 'Mahatma Gandhi University, Athirampuzha, Kottayam – 686560 ,Kerala',
    },
    {
      label: 'Mahatma Gandhi University, Nalgonda – 508254 ,Telangana',
      value: 'Mahatma Gandhi University, Nalgonda – 508254 ,Telangana',
    },
    {
      label:
        'Mahatma Jyotiba Phule Rohilkhand University, Bareilly – 243006 ,Uttar Pradesh',
      value:
        'Mahatma Jyotiba Phule Rohilkhand University, Bareilly – 243006 ,Uttar Pradesh',
    },
    {
      label:
        'Manav Bharti University, Laddo, Sultanpur, Solan – 173229 ,Himachal Pradesh',
      value:
        'Manav Bharti University, Laddo, Sultanpur, Solan – 173229 ,Himachal Pradesh',
    },
    {
      label: 'Manav Rachna International University,Faridabad ,Haryana',
      value: 'Manav Rachna International University,Faridabad ,Haryana',
    },
    {
      label: 'Manipal Academy of Higher Education ,Udupi – 576119 ,Karnataka',
      value: 'Manipal Academy of Higher Education ,Udupi – 576119 ,Karnataka',
    },
    {
      label: 'Manipur University, Canchipur, Imphal – 795003 ,Manipur',
      value: 'Manipur University, Canchipur, Imphal – 795003 ,Manipur',
    },
    {
      label:
        'Manonmaniam Sundaranar University,Abishekapatti,Tirunelveli – 627012 ,Tamil Nadu',
      value:
        'Manonmaniam Sundaranar University,Abishekapatti,Tirunelveli – 627012 ,Tamil Nadu',
    },
    {
      label:
        'MATS University ,Kharora Highway, Gullu, Aarang,Raipur – 493441 ,Chhattisgarh',
      value:
        'MATS University ,Kharora Highway, Gullu, Aarang,Raipur – 493441 ,Chhattisgarh',
    },
    {
      label:
        'Maulana Abul Kalam Azad University of Technology, Salt Lake, Kolkata – 700064 ,West Bengal',
      value:
        'Maulana Abul Kalam Azad University of Technology, Salt Lake, Kolkata – 700064 ,West Bengal',
    },
    {
      label:
        'Maulana Azad National Urdu University, Hyderabad – 500032 ,Telangana',
      value:
        'Maulana Azad National Urdu University, Hyderabad – 500032 ,Telangana',
    },
    {
      label:
        'Meenakshi Academy of Higher Education and Research, Chennai ,Tamil Nadu',
      value:
        'Meenakshi Academy of Higher Education and Research, Chennai ,Tamil Nadu',
    },
    {
      label: 'Mewar University,NH-79, Gangrar,Chittorgarh – 312901 ,Rajasthan',
      value: 'Mewar University,NH-79, Gangrar,Chittorgarh – 312901 ,Rajasthan',
    },
    {
      label: 'Mizoram University,Tanhril, Aizawl – 796004 ,Mizoram',
      value: 'Mizoram University,Tanhril, Aizawl – 796004 ,Mizoram',
    },
    {
      label: "Mother Teresa Women's University,Kodaikanal –  624101 ,Tamil Nadu",
      value: "Mother Teresa Women's University,Kodaikanal –  624101 ,Tamil Nadu",
    },
    {
      label: 'NALSAR University of Law, Hyderabad – 500101 ,Telangana',
      value: 'NALSAR University of Law, Hyderabad – 500101 ,Telangana',
    },
    {
      label:
        'National Institute of Technology, Itanagar – 791112 ,Arunachal Pradesh',
      value:
        'National Institute of Technology, Itanagar – 791112 ,Arunachal Pradesh',
    },
    {
      label: 'National Institute of Technology, Rourkela – 769008 ,Odisha',
      value: 'National Institute of Technology, Rourkela – 769008 ,Odisha',
    },
    {
      label:
        'National Law School of India University ,Nagarbhavi ,Bengaluru - 560072 ,Karnataka',
      value:
        'National Law School of India University ,Nagarbhavi ,Bengaluru - 560072 ,Karnataka',
    },
    {
      label: 'National Law University, Cuttack – 753015 ,Odisha',
      value: 'National Law University, Cuttack – 753015 ,Odisha',
    },
    {
      label: 'National Law University, Sector 14, Dwarka – 110078 ,Delhi',
      value: 'National Law University, Sector 14, Dwarka – 110078 ,Delhi',
    },
    {
      label: 'Nehru Gram Bharti University, Allahabad ,Uttar Pradesh',
      value: 'Nehru Gram Bharti University, Allahabad ,Uttar Pradesh',
    },
    {
      label: 'NIMS University, Jaipur- Delhi Highway – 303121 ,Rajasthan',
      value: 'NIMS University, Jaipur- Delhi Highway – 303121 ,Rajasthan',
    },
    {
      label: 'Nirma University, Ahmedabad – 382481,Gujarat',
      value: 'Nirma University, Ahmedabad – 382481,Gujarat',
    },
    {
      label: 'Noorul Islam Centre For Higher Education,Thuckalay ,Tamil Nadu',
      value: 'Noorul Islam Centre For Higher Education,Thuckalay ,Tamil Nadu',
    },
    {
      label:
        'North Eastern Hill University, Mawkynroh, Umshing, Shillong – 793022 ,Meghalaya',
      value:
        'North Eastern Hill University, Mawkynroh, Umshing, Shillong – 793022 ,Meghalaya',
    },
    {
      label: 'North Maharashtra University,Jalgaon – 425001 ,Maharashtra',
      value: 'North Maharashtra University,Jalgaon – 425001 ,Maharashtra',
    },
    {
      label: 'North Orissa University, Takatpur, Baripada – 757003 ,Odisha',
      value: 'North Orissa University, Takatpur, Baripada – 757003 ,Odisha',
    },
    {
      label: 'O. P. Jindal Global University, Sonipat – 131001 ,Haryana',
      value: 'O. P. Jindal Global University, Sonipat – 131001 ,Haryana',
    },
    {
      label: 'Osmania University, Hyderabad – 500007 ,Telangana',
      value: 'Osmania University, Hyderabad – 500007 ,Telangana',
    },
    {
      label:
        'Palamuru University,Bandameedipalli,Mahabubnagar – 509001 ,Telangana',
      value:
        'Palamuru University,Bandameedipalli,Mahabubnagar – 509001 ,Telangana',
    },
    {
      label:
        'Pandit Deendayal Petroleum University, Raisan, Gandhinagar, Ahmedabad – 382007 ,Gujarat',
      value:
        'Pandit Deendayal Petroleum University, Raisan, Gandhinagar, Ahmedabad – 382007 ,Gujarat',
    },
    {
      label:
        'Pandit Ravishankar Shukla University, Raipur – 492010 ,Chhattisgarh',
      value:
        'Pandit Ravishankar Shukla University, Raipur – 492010 ,Chhattisgarh',
    },
    {
      label: 'Panjab University, Sector 14, Chandigarh – 160014 ,Punjab',
      value: 'Panjab University, Sector 14, Chandigarh – 160014 ,Punjab',
    },
    {
      label:
        'Patna University, Ashok Rajpath, Near Patna College,Patna – 800005 ,Bihar',
      value:
        'Patna University, Ashok Rajpath, Near Patna College,Patna – 800005 ,Bihar',
    },
    {
      label:
        "People's University,Peoples Campus, Bhanpur,Bhopal – 462037 ,Madhya Pradesh",
      value:
        "People's University,Peoples Campus, Bhanpur,Bhopal – 462037 ,Madhya Pradesh",
    },
    {
      label:
        'Periyar Maniammai Institute of Science and Technology, Thanjavur ,Tamil Nadu',
      value:
        'Periyar Maniammai Institute of Science and Technology, Thanjavur ,Tamil Nadu',
    },
    {
      label: 'Periyar University, Salem –  636011 ,Tamil Nadu',
      value: 'Periyar University, Salem –  636011 ,Tamil Nadu',
    },
    {
      label:
        'Pondicherry University,R. Venkataraman Nagar,Kalapet – 605014 ,Puducherry',
      value:
        'Pondicherry University,R. Venkataraman Nagar,Kalapet – 605014 ,Puducherry',
    },
    {
      label:
        'Ponnaiyah Ramajayam Institute of Science & Technology, Thanjavur ,Tamil Nadu',
      value:
        'Ponnaiyah Ramajayam Institute of Science & Technology, Thanjavur ,Tamil Nadu',
    },
    {
      label:
        'Potti Sreeramulu Telugu University,Public Gardens Nampally Hyderabad – 500004 ,telangana',
      value:
        'Potti Sreeramulu Telugu University,Public Gardens Nampally Hyderabad – 500004 ,telangana',
    },
    {
      label:
        'Pravara Institute of Medical Sciences , Loni, Rahata, Ahmednagar – 413736 ,Maharashtra',
      value:
        'Pravara Institute of Medical Sciences , Loni, Rahata, Ahmednagar – 413736 ,Maharashtra',
    },
    {
      label: 'Presidency University, Kolkata – 700073 ,West Bengal',
      value: 'Presidency University, Kolkata – 700073 ,West Bengal',
    },
    {
      label:
        'Pt. B. D. Sharma University of Health Sciences, Rohtak – 124001 ,Haryana',
      value:
        'Pt. B. D. Sharma University of Health Sciences, Rohtak – 124001 ,Haryana',
    },
    {
      label:
        'Punjab Engineering College , Chandigarh , Punjab Engineering College Sector 12 Chandigarh – 160012,Chandigarh',
      value:
        'Punjab Engineering College , Chandigarh , Punjab Engineering College Sector 12 Chandigarh – 160012,Chandigarh',
    },
    {
      label: 'Punjabi University, Patiala – 147002 ,Punjab',
      value: 'Punjabi University, Patiala – 147002 ,Punjab',
    },
    {
      label: 'Rabindra Bharati University, Kolkata – 700050 ,West Bengal',
      value: 'Rabindra Bharati University, Kolkata – 700050 ,West Bengal',
    },
    {
      label:
        'Rabindranath Tagore University, Village – Mendua, Bhopal-Chiklod Road, Tehsil – Goharganj, Dist. – Raisen, Madhya Pradesh',
      value:
        'Rabindranath Tagore University, Village – Mendua, Bhopal-Chiklod Road, Tehsil – Goharganj, Dist. – Raisen, Madhya Pradesh',
    },
    {
      label: 'Rajiv Gandhi National University of Law, Patiala – 147001 ,Punjab',
      value: 'Rajiv Gandhi National University of Law, Patiala – 147001 ,Punjab',
    },
    {
      label:
        'Rajiv Gandhi Proudyogiki Vishwavidyalaya, Gandhi Nagar, Bhopal – 462033 ,Madhya Pradesh',
      value:
        'Rajiv Gandhi Proudyogiki Vishwavidyalaya, Gandhi Nagar, Bhopal – 462033 ,Madhya Pradesh',
    },
    {
      label:
        'Rajiv Gandhi University, Rono Hills, Itanagar – 791112 ,Arunachal Pradesh',
      value:
        'Rajiv Gandhi University, Rono Hills, Itanagar – 791112 ,Arunachal Pradesh',
    },
    {
      label:
        'Ramakrishna Mission Vivekananda Educational and Research Institute, PO Belur Math, Dist. Howrah – 711202 ,west bengal',
      value:
        'Ramakrishna Mission Vivekananda Educational and Research Institute, PO Belur Math, Dist. Howrah – 711202 ,west bengal',
    },
    {
      label: 'Ranchi University, Ranchi – 834001 ,Jharkhand',
      value: 'Ranchi University, Ranchi – 834001 ,Jharkhand',
    },
    {
      label: 'Rani Durgavati Vishwavidyalaya, Jabalpur, 482001 ,Madhya Pradesh',
      value: 'Rani Durgavati Vishwavidyalaya, Jabalpur, 482001 ,Madhya Pradesh',
    },
    {
      label: 'Rashtriya Sanskrit Vidyapeetha, Tirupati – 517507 ,Andhra Pradesh',
      value: 'Rashtriya Sanskrit Vidyapeetha, Tirupati – 517507 ,Andhra Pradesh',
    },
    {
      label: 'Ravenshaw University, Cuttack – 753003 ,Odisha',
      value: 'Ravenshaw University, Cuttack – 753003 ,Odisha',
    },
    {
      label:
        'Rayalaseema University,National Highway 40, Nandyal Road,Kurnool – 518007 ,Andhra Pradesh',
      value:
        'Rayalaseema University,National Highway 40, Nandyal Road,Kurnool – 518007 ,Andhra Pradesh',
    },
    {
      label:
        'RK University,Rajkot-Bhavnagar Highway, Kasturbadham,Rajkot – 360020 ,Gujarat',
      value:
        'RK University,Rajkot-Bhavnagar Highway, Kasturbadham,Rajkot – 360020 ,Gujarat',
    },
    {
      label: 'Sambalpur University, Burla – 768019 ,Odisha',
      value: 'Sambalpur University, Burla – 768019 ,Odisha',
    },
    {
      label:
        'Sant Gadge Baba Amravati University, Amravati – 444602 ,Maharashtra',
      value:
        'Sant Gadge Baba Amravati University, Amravati – 444602 ,Maharashtra',
    },
    {
      label:
        'Sant Gahira Guru Vishwavidyalaya, Sarguja,New Hospital Road , Darripara,Ambikapur(C.G.) – 497001 ,Chhattisgarh',
      value:
        'Sant Gahira Guru Vishwavidyalaya, Sarguja,New Hospital Road , Darripara,Ambikapur(C.G.) – 497001 ,Chhattisgarh',
    },
    {
      label:
        'Sant Longowal Institute of Engineering and Technology (Deemed-to-be-University u/s 3 of the UGC Act 1956), Longowal, Sangrur – 148106 ,Punjab',
      value:
        'Sant Longowal Institute of Engineering and Technology (Deemed-to-be-University u/s 3 of the UGC Act 1956), Longowal, Sangrur – 148106 ,Punjab',
    },
    {
      label: 'Santosh University, Ghaziabad ,Uttar Pradesh',
      value: 'Santosh University, Ghaziabad ,Uttar Pradesh',
    },
    {
      label: 'Sardar Patel University, Vallabh Vidyanagar – 388120 ,Gujarat',
      value: 'Sardar Patel University, Vallabh Vidyanagar – 388120 ,Gujarat',
    },
    {
      label:
        'Sathyabama Institute of Science and Technology , Chennai – 600119 ,Tamil Nadu',
      value:
        'Sathyabama Institute of Science and Technology , Chennai – 600119 ,Tamil Nadu',
    },
    {
      label:
        'Saveetha Institute of Medical and Technical Sciences,Chennai ,Tamil Nadu',
      value:
        'Saveetha Institute of Medical and Technical Sciences,Chennai ,Tamil Nadu',
    },
    {
      label: 'Savitribai Phule Pune University, Pune – 411007 ,Maharashtra',
      value: 'Savitribai Phule Pune University, Pune – 411007 ,Maharashtra',
    },
    {
      label:
        'Shanmugha Arts, Science, Technology & Research Academy (SASTRA) University, Thanjavur, 613401 Tamil Nadu',
      value:
        'Shanmugha Arts, Science, Technology & Research Academy (SASTRA) University, Thanjavur, 613401 Tamil Nadu',
    },
    {
      label: 'Sharda University, Greater Noida – 201306 ,Uttar Pradesh',
      value: 'Sharda University, Greater Noida – 201306 ,Uttar Pradesh',
    },
    {
      label:
        'Shiv Nadar University,NH-91, Tehsil-Dadri, Gautam Buddha Nagar, Uttar Pradesh – 201314 ,Uttar Pradesh',
      value:
        'Shiv Nadar University,NH-91, Tehsil-Dadri, Gautam Buddha Nagar, Uttar Pradesh – 201314 ,Uttar Pradesh',
    },
    {
      label:
        'Shobhit Institute of Engineering and Technology, Meerut ,Uttar Pradesh',
      value:
        'Shobhit Institute of Engineering and Technology, Meerut ,Uttar Pradesh',
    },
    {
      label:
        'Shoolini University of Biotechnology and Management Sciences, Solan – 173229 ,Himachal Pradesh',
      value:
        'Shoolini University of Biotechnology and Management Sciences, Solan – 173229 ,Himachal Pradesh',
    },
    {
      label:
        "Shreemati Nathibai Damodar Thackersey Women's University, Mumbai – 400020 ,Maharashtra",
      value:
        "Shreemati Nathibai Damodar Thackersey Women's University, Mumbai – 400020 ,Maharashtra",
    },
    {
      label: 'Shri Jagannath Sanskrit Vishvavidyalaya, Puri – 752003 ,Odisha',
      value: 'Shri Jagannath Sanskrit Vishvavidyalaya, Puri – 752003 ,Odisha',
    },
    {
      label:
        'Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha , B-4, Qutub Institutional Area - 110016 ,Delhi',
      value:
        'Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha , B-4, Qutub Institutional Area - 110016 ,Delhi',
    },
    {
      label:
        'Sidho Kanho Birsha University, P.O. Sainik School Ranchi Road, Dist. Purulia,Purulia,West Bengal – 723104 ,West Bengal',
      value:
        'Sidho Kanho Birsha University, P.O. Sainik School Ranchi Road, Dist. Purulia,Purulia,West Bengal – 723104 ,West Bengal',
    },
    {
      label:
        'Sido Kanhu Murmu University,Dighi, University Campus,Dumka – 814110 ,Jharkhand',
      value:
        'Sido Kanhu Murmu University,Dighi, University Campus,Dumka – 814110 ,Jharkhand',
    },
    {
      label:
        'Sikkim Manipal University ,Fifth Mile, Tadong, Gangtok, East Sikkim,Gangtok - 737102 ,Sikkim',
      value:
        'Sikkim Manipal University ,Fifth Mile, Tadong, Gangtok, East Sikkim,Gangtok - 737102 ,Sikkim',
    },
    {
      label:
        'Sikkim University, 6th Mile, Samdur PO, Tadong, Gangtok - 737102 ,Sikkim',
      value:
        'Sikkim University, 6th Mile, Samdur PO, Tadong, Gangtok - 737102 ,Sikkim',
    },
    {
      label: 'Siksha ‘O’ Anusandhan University, Bhubaneshwar ,Odisha',
      value: 'Siksha ‘O’ Anusandhan University, Bhubaneshwar ,Odisha',
    },
    {
      label: 'Solapur University,Kegaon, Solapur – 413255 ,Maharashtra',
      value: 'Solapur University,Kegaon, Solapur – 413255 ,Maharashtra',
    },
    {
      label: 'Sri Balaji Vidyapeeth,Pondicherry ,Puducherry',
      value: 'Sri Balaji Vidyapeeth,Pondicherry ,Puducherry',
    },
    {
      label:
        'Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya , Enathur, Kanchipuram – 631561 ,Tamil Nadu',
      value:
        'Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya , Enathur, Kanchipuram – 631561 ,Tamil Nadu',
    },
    {
      label:
        'Sri Devaraj Urs Academy of Higher Education and Research, Kolar ,Karnataka',
      value:
        'Sri Devaraj Urs Academy of Higher Education and Research, Kolar ,Karnataka',
    },
    {
      label: 'Sri Krishnadevaraya University Anantapur – 515003 ,Andhra Pradesh',
      value: 'Sri Krishnadevaraya University Anantapur – 515003 ,Andhra Pradesh',
    },
    {
      label:
        'Sri Padmavati Mahila Visvavidyalayam, Tirupati – 517502 ,Andhra Pradesh',
      value:
        'Sri Padmavati Mahila Visvavidyalayam, Tirupati – 517502 ,Andhra Pradesh',
    },
    {
      label: 'Sri Siddhartha Academy of Higher Education, Tumkur ,Karnataka',
      value: 'Sri Siddhartha Academy of Higher Education, Tumkur ,Karnataka',
    },
    {
      label:
        'Sri Venkateswara University, Tirupati, Chittoor – 517502 ,Andhra Pradesh',
      value:
        'Sri Venkateswara University, Tirupati, Chittoor – 517502 ,Andhra Pradesh',
    },
    {
      label:
        'SRM Institute of Science and Technology,SRM Nagar, Kancheepuram Dist.,Kattankulathur – 603203 ,Tamil Nadu',
      value:
        'SRM Institute of Science and Technology,SRM Nagar, Kancheepuram Dist.,Kattankulathur – 603203 ,Tamil Nadu',
    },
    {
      label:
        "St. Peter's Institute of Higher Education and Research, Chennai ,Tamil Nadu",
      value:
        "St. Peter's Institute of Higher Education and Research, Chennai ,Tamil Nadu",
    },
    {
      label: 'Sumandeep Vidyapeeth, Vadodara ,Gujarat',
      value: 'Sumandeep Vidyapeeth, Vadodara ,Gujarat',
    },
    {
      label:
        'Suresh Gyan Vihar University, Jagatpura, Jaipur – 302017 ,Rajasthan',
      value:
        'Suresh Gyan Vihar University, Jagatpura, Jaipur – 302017 ,Rajasthan',
    },
    {
      label:
        "SVKM's Narsee Monjee Institute of Management Studies, Vile Parle (W), Mumbai – 400056 ,Maharashtra",
      value:
        "SVKM's Narsee Monjee Institute of Management Studies, Vile Parle (W), Mumbai – 400056 ,Maharashtra",
    },
    {
      label:
        'Swami Ramanand Teerth Marathwada University, Nanded – 431606 ,Maharashtra',
      value:
        'Swami Ramanand Teerth Marathwada University, Nanded – 431606 ,Maharashtra',
    },
    {
      label:
        'Swami Vivekanand Subharti University, Meerut – 250005 ,Uttar Pradesh',
      value:
        'Swami Vivekanand Subharti University, Meerut – 250005 ,Uttar Pradesh',
    },
    {
      label:
        'Swami Vivekananda Yoga Anusandhana Samsthana, Kempegowda Nagar, Bengaluru – 560019 ,Karnataka',
      value:
        'Swami Vivekananda Yoga Anusandhana Samsthana, Kempegowda Nagar, Bengaluru – 560019 ,Karnataka',
    },
    {
      label: 'Symbiosis International University, Pune – 412115 ,Maharashtra',
      value: 'Symbiosis International University, Pune – 412115 ,Maharashtra',
    },
    {
      label:
        'Tamil Nadu Physical Education and Sports University, Chennai – 600127 ,Tamil Nadu',
      value:
        'Tamil Nadu Physical Education and Sports University, Chennai – 600127 ,Tamil Nadu',
    },
    {
      label:
        'Tamil University,Vagaiyur, Trichy Road,Thanjavur – 613010 ,Tamil Nadu',
      value:
        'Tamil University,Vagaiyur, Trichy Road,Thanjavur – 613010 ,Tamil Nadu',
    },
    {
      label:
        'Tata Institute of Fundamental Research , Homi Bhabha Road, Colaba, Mumbai – 400005 ,Maharashtra',
      value:
        'Tata Institute of Fundamental Research , Homi Bhabha Road, Colaba, Mumbai – 400005 ,Maharashtra',
    },
    {
      label: 'Tata Institute of Social Sciences, Mumbai – 400088 ,Maharashtra',
      value: 'Tata Institute of Social Sciences, Mumbai – 400088 ,Maharashtra',
    },
    {
      label: 'Teerthanker Mahaveer University, Moradabad – 244001 ,Uttar Pradesh',
      value: 'Teerthanker Mahaveer University, Moradabad – 244001 ,Uttar Pradesh',
    },
    {
      label: 'Telangana University, Dichpally, Nizamabad – 503322 ,Telangana',
      value: 'Telangana University, Dichpally, Nizamabad – 503322 ,Telangana',
    },
    {
      label:
        'TERI School of Advanced Studies ,Plot No. 10, Institutional Area,Vasant Kunj – 110070 ,Delhi',
      value:
        'TERI School of Advanced Studies ,Plot No. 10, Institutional Area,Vasant Kunj – 110070 ,Delhi',
    },
    {
      label: 'Tezpur University, Tezpur – 784028 ,Assam',
      value: 'Tezpur University, Tezpur – 784028 ,Assam',
    },
    {
      label:
        'Thapar Institute of Engineering and Technology University, Patiala – 147004 ,Punjab',
      value:
        'Thapar Institute of Engineering and Technology University, Patiala – 147004 ,Punjab',
    },
    {
      label:
        'Thapar Institute of Engineering and Technology University,Thapar Technology Campus Post Box 32 Patiala – 147004 ,Punjab',
      value:
        'Thapar Institute of Engineering and Technology University,Thapar Technology Campus Post Box 32 Patiala – 147004 ,Punjab',
    },
    {
      label:
        'The English and Foreign Languages University, Hyderabad – 500007 ,Telangana',
      value:
        'The English and Foreign Languages University, Hyderabad – 500007 ,Telangana',
    },
    {
      label:
        'The ICFAI Foundation for Higher Education , Donthanapalli, Hyderabad – 501203 ,Telangana',
      value:
        'The ICFAI Foundation for Higher Education , Donthanapalli, Hyderabad – 501203 ,Telangana',
    },
    {
      label:
        'The ICFAI University, Rajawala Road, Central Hope Town, Selaqui, Dehradun,Uttarakhand – 248197 ,Uttarakhand',
      value:
        'The ICFAI University, Rajawala Road, Central Hope Town, Selaqui, Dehradun,Uttarakhand – 248197 ,Uttarakhand',
    },
    {
      label:
        'The LNM Institute of Information Technology , Jaipur – 302031 ,Rajasthan',
      value:
        'The LNM Institute of Information Technology , Jaipur – 302031 ,Rajasthan',
    },
    {
      label:
        'The Maharaja Sayajirao University of Baroda, Vadodara – 390002 ,Gujarat',
      value:
        'The Maharaja Sayajirao University of Baroda, Vadodara – 390002 ,Gujarat',
    },
    {
      label: 'The NorthCap University, Gurgaon – 122017 ,Haryana',
      value: 'The NorthCap University, Gurgaon – 122017 ,Haryana',
    },
    {
      label: 'Thiruvalluvar University,Serkkadu,Vellore – 632115 ,Tamil Nadu',
      value: 'Thiruvalluvar University,Serkkadu,Vellore – 632115 ,Tamil Nadu',
    },
    {
      label:
        'Tilak Maharashtra Vidyapeeth ,Vidyapeeth Bhavan, Mukundnagar, Gultekdi,Pune – 411037 ,Maharashtra',
      value:
        'Tilak Maharashtra Vidyapeeth ,Vidyapeeth Bhavan, Mukundnagar, Gultekdi,Pune – 411037 ,Maharashtra',
    },
    {
      label: 'Tilka Manjhi Bhagalpur University, Bhagalpur – 812007 ,Bihar',
      value: 'Tilka Manjhi Bhagalpur University, Bhagalpur – 812007 ,Bihar',
    },
    {
      label: 'Tripura University, Suryamaninagar, Agartala – 799022 ,Tripura',
      value: 'Tripura University, Suryamaninagar, Agartala – 799022 ,Tripura',
    },
    {
      label:
        'UKA Tarsadia University, Maliba Campus, Gopal Vidyanagar, Bardoli-Mahuva Road, Taluka-Mahuva,Bardoli ,Dist.- Surat – 394350 ,Gujarat',
      value:
        'UKA Tarsadia University, Maliba Campus, Gopal Vidyanagar, Bardoli-Mahuva Road, Taluka-Mahuva,Bardoli ,Dist.- Surat – 394350 ,Gujarat',
    },
    {
      label:
        'University of Allahabad,Senate House Campus, University of Allahabad,Allahabad – 211002 ,Uttar pradesh',
      value:
        'University of Allahabad,Senate House Campus, University of Allahabad,Allahabad – 211002 ,Uttar pradesh',
    },
    {
      label: 'University of Burdwan, Bardhaman – 713104 ,West Bengal',
      value: 'University of Burdwan, Bardhaman – 713104 ,West Bengal',
    },
    {
      label: 'University of Calcutta, Kolkata – 700073 ,West Bengal',
      value: 'University of Calcutta, Kolkata – 700073 ,West Bengal',
    },
    {
      label: 'University of Calicut, Malappuram – 673635 ,Kerala',
      value: 'University of Calicut, Malappuram – 673635 ,Kerala',
    },
    {
      label: 'University of Delhi – 110007 ,Delhi',
      value: 'University of Delhi – 110007 ,Delhi',
    },
    {
      label: 'University of Gour Banga, Malda – 732103 ,West Bengal',
      value: 'University of Gour Banga, Malda – 732103 ,West Bengal',
    },
    {
      label: 'University of Hyderabad, Hyderabad – 500046 ,Telangana',
      value: 'University of Hyderabad, Hyderabad – 500046 ,Telangana',
    },
    {
      label: 'University of Jammu, Jammu – 180006 ,Jammu and Kashmir',
      value: 'University of Jammu, Jammu – 180006 ,Jammu and Kashmir',
    },
    {
      label: 'University of Kalyani, Kalyani, Nadia – 741235 ,West Bengal',
      value: 'University of Kalyani, Kalyani, Nadia – 741235 ,West Bengal',
    },
    {
      label:
        'University of Kashmir, Hazratbal, Srinagar – 190006 ,Jammu And Kashmir',
      value:
        'University of Kashmir, Hazratbal, Srinagar – 190006 ,Jammu And Kashmir',
    },
    {
      label: 'University of Kerala, Thiruvananthapuram – 695034 ,Kerala',
      value: 'University of Kerala, Thiruvananthapuram – 695034 ,Kerala',
    },
    {
      label: 'University of Kota, Kota – 324005 ,Rajasthan',
      value: 'University of Kota, Kota – 324005 ,Rajasthan',
    },
    {
      label: 'University of Madras, Chepauk Campus, Chenna – 600005 Tamil Nadu',
      value: 'University of Madras, Chepauk Campus, Chenna – 600005 Tamil Nadu',
    },
    {
      label: 'University of Mysore, Mysore, Karnataka ,Karnataka',
      value: 'University of Mysore, Mysore, Karnataka ,Karnataka',
    },
    {
      label: 'University of North Bengal, Darjeeling – 734430 ,West Bengal',
      value: 'University of North Bengal, Darjeeling – 734430 ,West Bengal',
    },
    {
      label: 'University of Rajasthan, Jaipur – 302004 ,Rajasthan',
      value: 'University of Rajasthan, Jaipur – 302004 ,Rajasthan',
    },
    {
      label: 'Utkal University, Bhubaneswar – 751004 ,Odisha',
      value: 'Utkal University, Bhubaneswar – 751004 ,Odisha',
    },
    {
      label:
        'Uttarakhand Sanskrit University,Haridwar-Delhi National Highway-58, Bahadrabad,Haridwar – 249402 ,Uttarakhand',
      value:
        'Uttarakhand Sanskrit University,Haridwar-Delhi National Highway-58, Bahadrabad,Haridwar – 249402 ,Uttarakhand',
    },
    {
      label:
        'Veer Bahadur Singh Purvanchal University, Jaunpur – 222003,Uttar Pradesh',
      value:
        'Veer Bahadur Singh Purvanchal University, Jaunpur – 222003,Uttar Pradesh',
    },
    {
      label: 'Veer Narmad South Gujarat University, Surat – 395007 ,Gujarat',
      value: 'Veer Narmad South Gujarat University, Surat – 395007 ,Gujarat',
    },
    {
      label:
        'Veer Surendra Sai University of Technology, Sambalpur – 768018 ,Odisha',
      value:
        'Veer Surendra Sai University of Technology, Sambalpur – 768018 ,Odisha',
    },
    {
      label:
        'Vel Tech Rangarajan Dr Sagunthala R&D Institute of Science and Technology, Chennai ,Tamil Nadu',
      value:
        'Vel Tech Rangarajan Dr Sagunthala R&D Institute of Science and Technology, Chennai ,Tamil Nadu',
    },
    {
      label:
        'Vellore Institute of Technology (Deemed to be University u/s 3 of the UGC Act 1956), Vellore, 632014 ,Tamil Nadu',
      value:
        'Vellore Institute of Technology (Deemed to be University u/s 3 of the UGC Act 1956), Vellore, 632014 ,Tamil Nadu',
    },
    {
      label:
        'Vels Institute of Science, Technology and Advanced Studies(Vistas),Velan Nagar, P. V. Vaithiyalingam Road, Pallavaram, Chennai – 600117 ,Tamil nadu',
      value:
        'Vels Institute of Science, Technology and Advanced Studies(Vistas),Velan Nagar, P. V. Vaithiyalingam Road, Pallavaram, Chennai – 600117 ,Tamil nadu',
    },
    {
      label:
        "Vignan's Foundation for Science Technology and Research Vadlamudi ,Andhra Pradesh",
      value:
        "Vignan's Foundation for Science Technology and Research Vadlamudi ,Andhra Pradesh",
    },
    {
      label: 'Vikram University, Ujjain – 456010 ,Madhya Pradesh',
      value: 'Vikram University, Ujjain – 456010 ,Madhya Pradesh',
    },
    {
      label: 'Vinayaka Mission’s Research Foundation,Salem ,Tamil Nadu',
      value: 'Vinayaka Mission’s Research Foundation,Salem ,Tamil Nadu',
    },
    {
      label: 'Vinoba Bhave University, Hazaribag – 825301 ,Jharkhand',
      value: 'Vinoba Bhave University, Hazaribag – 825301 ,Jharkhand',
    },
    {
      label: 'Visva-Bharati, Birbhum, 731235 ,West Bengal',
      value: 'Visva-Bharati, Birbhum, 731235 ,West Bengal',
    },
    {
      label: 'Yenepoya University, Mangalore ,Karnataka',
      value: 'Yenepoya University, Mangalore ,Karnataka',
    },
    {
      label:
        'YMCA University of Science and Technology, Faridabad – 121006 ,Haryana',
      value:
        'YMCA University of Science and Technology, Faridabad – 121006 ,Haryana',
    },
    {
      label: 'Yogi Vemana University Kadapa (Cuddapah) – 516003 ,Andhra Pradesh',
      value: 'Yogi Vemana University Kadapa (Cuddapah) – 516003 ,Andhra Pradesh',
    },
    {
      label: 'Others',
      value: 'Others',
    },
  ];
  
  export const FORM_VALUES_COMPANY = [
    { label: '91Springboard', value: '91Springboard' },
    { label: 'ABB SHIP MANAGEMENT', value: 'ABB SHIP MANAGEMENT' },
    { label: 'ABP Network', value: 'ABP Network' },
    { label: 'Accenture', value: 'Accenture' },
    {
      label: 'Acuity Knowledge Partners India Pvt Ltd',
      value: 'Acuity Knowledge Partners India Pvt Ltd',
    },
    { label: 'Acuwin Fitness Pvt. Ltd', value: 'Acuwin Fitness Pvt. Ltd' },
    { label: 'ADANI POWER LIMITED', value: 'ADANI POWER LIMITED' },
    { label: 'Adani power maharastra ltd', value: 'Adani power maharastra ltd' },
    { label: 'Addverb Technologies', value: 'Addverb Technologies' },
    {
      label: 'Aditya Birla Fashion and Retail Lts',
      value: 'Aditya Birla Fashion and Retail Lts',
    },
    { label: 'Adroit', value: 'Adroit' },
    { label: 'AECOM', value: 'AECOM' },
    {
      label: 'Aerocraft Engineering Indi Pvt Ltd',
      value: 'Aerocraft Engineering Indi Pvt Ltd',
    },
    {
      label: 'Agriculture retail (family business)',
      value: 'Agriculture retail (family business)',
    },
    { label: 'AKAR ADVERTISING PVT LTD', value: 'AKAR ADVERTISING PVT LTD' },
    { label: 'AKG Finvest', value: 'AKG Finvest' },
    { label: 'Allen Digital', value: 'Allen Digital' },
    { label: 'ALLSTATE SOLUTIONS', value: 'ALLSTATE SOLUTIONS' },
    {
      label: 'Alpha Plus Technologies Pvt Ltd',
      value: 'Alpha Plus Technologies Pvt Ltd',
    },
    { label: 'Amazon', value: 'Amazon' },
    { label: 'American Express', value: 'American Express' },
    {
      label: 'ANB GLOBAL- ANB Solutions Pvt Ltd',
      value: 'ANB GLOBAL- ANB Solutions Pvt Ltd',
    },
    {
      label: 'Anglo Eastern Ship Management',
      value: 'Anglo Eastern Ship Management',
    },
    { label: 'Apttus Conga', value: 'Apttus Conga' },
    { label: 'Artery India', value: 'Artery India' },
    { label: 'ASHOK MEDICAL CLINIC', value: 'ASHOK MEDICAL CLINIC' },
    { label: 'Asian Paints', value: 'Asian Paints' },
    {
      label: 'Astro Sports Private Limited',
      value: 'Astro Sports Private Limited',
    },
    { label: 'AUROVILLE', value: 'AUROVILLE' },
    { label: 'AutoVRse', value: 'AutoVRse' },
    { label: 'AXA XL', value: 'AXA XL' },
    { label: 'AXIS BANK', value: 'AXIS BANK' },
    { label: 'Axtria India', value: 'Axtria India' },
    {
      label: 'Babu Jagjeewan Ram Pvt. ITI',
      value: 'Babu Jagjeewan Ram Pvt. ITI',
    },
    {
      label: 'Bank of America India Pvt Ltd',
      value: 'Bank of America India Pvt Ltd',
    },
    { label: 'Bank Of Baroda', value: 'Bank Of Baroda' },
    { label: 'Barclays', value: 'Barclays' },
    { label: 'BETSOL', value: 'BETSOL' },
    { label: 'Better.com', value: 'Better.com' },
    { label: 'bhabani travels', value: 'bhabani travels' },
    {
      label: 'Bharat Heavy Electricals Limited',
      value: 'Bharat Heavy Electricals Limited',
    },
    { label: 'Billa Jewellers', value: 'Billa Jewellers' },
    { label: 'BNP Paribas', value: 'BNP Paribas' },
    { label: 'BNY Mellon', value: 'BNY Mellon' },
    {
      label: 'Boston Consulting Group (BCG)',
      value: 'Boston Consulting Group (BCG)',
    },
    { label: 'BreachLock', value: 'BreachLock' },
    {
      label: 'Brihanmumbai Municipal Corporation',
      value: 'Brihanmumbai Municipal Corporation',
    },
    {
      label: 'BT Global Business Services Pvt. Ltd',
      value: 'BT Global Business Services Pvt. Ltd',
    },
    { label: 'Builder.Ai', value: 'Builder.Ai' },
    { label: 'BukuWarung', value: 'BukuWarung' },
    {
      label: 'BURDER INDUSTRIES INDIA PVT LTD',
      value: 'BURDER INDUSTRIES INDIA PVT LTD',
    },
    { label: "Byju's", value: "Byju's" },
    { label: 'Cadence Design system’s', value: 'Cadence Design system’s' },
    { label: 'CAIRN OIL AND GAS', value: 'CAIRN OIL AND GAS' },
    { label: 'CANARA BANK', value: 'CANARA BANK' },
    {
      label: 'CapFloat Financial Services Private Limited',
      value: 'CapFloat Financial Services Private Limited',
    },
    { label: 'Capgemini', value: 'Capgemini' },
    { label: 'capri global capital', value: 'capri global capital' },
    { label: 'Caterpillar India PvtLtd', value: 'Caterpillar India PvtLtd' },
    { label: 'CBRE South Asia Pvt Ltd', value: 'CBRE South Asia Pvt Ltd' },
    { label: 'CDK Global', value: 'CDK Global' },
    { label: 'CEAT LIMITED', value: 'CEAT LIMITED' },
    { label: 'Central Books', value: 'Central Books' },
    {
      label: 'Central Excise and GST, Government of India',
      value: 'Central Excise and GST, Government of India',
    },
    {
      label: 'Centre of Advanced Software Technology & Solutions',
      value: 'Centre of Advanced Software Technology & Solutions',
    },
    { label: 'Cerner Corporation', value: 'Cerner Corporation' },
    {
      label: 'Chambers of Mr. Sourav Roy, Advocate-on-Record',
      value: 'Chambers of Mr. Sourav Roy, Advocate-on-Record',
    },
    { label: 'Cinepolis India Pvt. Ltd', value: 'Cinepolis India Pvt. Ltd' },
    {
      label: 'Citigroup Services India Pvt Ltd',
      value: 'Citigroup Services India Pvt Ltd',
    },
    { label: 'Coal India Limited', value: 'Coal India Limited' },
    { label: 'Cochlear', value: 'Cochlear' },
    {
      label: 'Cognizant Technology Solutions',
      value: 'Cognizant Technology Solutions',
    },
    {
      label: 'Colgate palmolive india ltd',
      value: 'Colgate palmolive india ltd',
    },
    {
      label: 'Collective Artists Network India Pvt Ltd',
      value: 'Collective Artists Network India Pvt Ltd',
    },
    { label: 'Compuage Infocom Ltd', value: 'Compuage Infocom Ltd' },
    {
      label: 'ConnectedH - Leading Bird Web Services Pvt Ltd',
      value: 'ConnectedH - Leading Bird Web Services Pvt Ltd',
    },
    { label: 'Consultant', value: 'Consultant' },
    { label: 'CPL Aromas', value: 'CPL Aromas' },
    { label: 'Credit Suisse', value: 'Credit Suisse' },
    { label: 'CriticaLog India Pvt Ltd', value: 'CriticaLog India Pvt Ltd' },
    {
      label: 'Cult.fit Healthcare Private Limited',
      value: 'Cult.fit Healthcare Private Limited',
    },
    { label: 'Dance Inc India', value: 'Dance Inc India' },
    { label: 'Datamark BPO services', value: 'Datamark BPO services' },
    { label: 'Datametica', value: 'Datametica' },
    { label: 'DBS Bank India Ltd', value: 'DBS Bank India Ltd' },
    { label: 'DCM SHRIRAM LTD.', value: 'DCM SHRIRAM LTD.' },
    { label: 'Decathlon', value: 'Decathlon' },
    { label: 'DELHI DISTRICT COURTS', value: 'DELHI DISTRICT COURTS' },
    { label: 'Dell', value: 'Dell' },
    { label: 'Deloitte', value: 'Deloitte' },
    {
      label: 'DELOITTE CONSULTING INDIA PVT. LTD',
      value: 'DELOITTE CONSULTING INDIA PVT. LTD',
    },
    { label: 'Deloitte USI', value: 'Deloitte USI' },
    {
      label: 'Deluxe Entertainment Distribution India Pvt. Ltd',
      value: 'Deluxe Entertainment Distribution India Pvt. Ltd',
    },
    {
      label: 'Department of Revenue,Government of India',
      value: 'Department of Revenue,Government of India',
    },
    {
      label: 'Dhaatu Ridges Private Limited',
      value: 'Dhaatu Ridges Private Limited',
    },
    { label: 'Dhaval Technologies', value: 'Dhaval Technologies' },
    { label: 'Digi Pix Mi', value: 'Digi Pix Mi' },
    { label: 'District Courts', value: 'District Courts' },
    { label: 'DoonValley Agrotech', value: 'DoonValley Agrotech' },
    {
      label: 'Drache Holding India Pvt. Ltd.',
      value: 'Drache Holding India Pvt. Ltd.',
    },
    { label: 'Dunzo', value: 'Dunzo' },
    { label: 'Eaton Technologies Pvt Ltd', value: 'Eaton Technologies Pvt Ltd' },
    { label: 'EclinicalWorks', value: 'EclinicalWorks' },
    {
      label: 'edelweiss gallagher insurance brokers ltd',
      value: 'edelweiss gallagher insurance brokers ltd',
    },
    { label: 'Elegante Interno', value: 'Elegante Interno' },
    { label: 'Elite Gym', value: 'Elite Gym' },
    {
      label: 'Energy Efficiency Services Limited',
      value: 'Energy Efficiency Services Limited',
    },
    {
      label: 'Ericsson india Global Services Private Limited',
      value: 'Ericsson india Global Services Private Limited',
    },
    { label: 'Ernst & Young', value: 'Ernst & Young' },
    { label: 'Everrise Poly Pro', value: 'Everrise Poly Pro' },
    {
      label: 'Excel Technical & Industrial Supplies LLC',
      value: 'Excel Technical & Industrial Supplies LLC',
    },
    { label: 'EXL', value: 'EXL' },
    { label: 'FAMILY BUSINESS', value: 'FAMILY BUSINESS' },
    {
      label: 'Fichtner Consulting Engineers (India) Pvt. Ltd',
      value: 'Fichtner Consulting Engineers (India) Pvt. Ltd',
    },
    { label: 'Fidelity Investments', value: 'Fidelity Investments' },
    { label: 'FIS(GOOGLE ADS)', value: 'FIS(GOOGLE ADS)' },
    { label: 'FLOWSERVE SANMAR PVT LTD', value: 'FLOWSERVE SANMAR PVT LTD' },
    { label: 'Flying Elephant Studio', value: 'Flying Elephant Studio' },
    { label: 'Ford Motor Company', value: 'Ford Motor Company' },
    { label: 'Fortum India Pvt. Ltd', value: 'Fortum India Pvt. Ltd' },
    { label: 'Freshworks Inc', value: 'Freshworks Inc' },
    { label: 'Fusion Associates', value: 'Fusion Associates' },
    {
      label: 'FUTURE GENERALI INDIA LIFE INSURANCE LIMITED',
      value: 'FUTURE GENERALI INDIA LIFE INSURANCE LIMITED',
    },
    { label: 'Fyers', value: 'Fyers' },
    { label: 'G R Infraprojects Limited', value: 'G R Infraprojects Limited' },
    {
      label: 'G&C Valves India Private Limited',
      value: 'G&C Valves India Private Limited',
    },
    { label: 'GAIL India Limited', value: 'GAIL India Limited' },
    { label: 'Gartner', value: 'Gartner' },
    { label: 'Genesys Telecom Labs', value: 'Genesys Telecom Labs' },
    { label: 'Genpact', value: 'Genpact' },
    { label: "Glaz'd Patisserie", value: "Glaz'd Patisserie" },
    { label: 'Globallogic', value: 'Globallogic' },
    {
      label: 'Globallogic India Pvt. Ltd.',
      value: 'Globallogic India Pvt. Ltd.',
    },
    { label: 'GMJ & Co.', value: 'GMJ & Co.' },
    { label: 'Goldman Sachs', value: 'Goldman Sachs' },
    { label: 'Grant Thornton Bharat LLP', value: 'Grant Thornton Bharat LLP' },
    {
      label: 'Grasim Industries, Birla Paints',
      value: 'Grasim Industries, Birla Paints',
    },
    { label: 'Grivaa Capital', value: 'Grivaa Capital' },
    {
      label: 'GVM Engineering Solutions Pvt Ltd',
      value: 'GVM Engineering Solutions Pvt Ltd',
    },
    { label: 'Gyan International Pvt Ltd', value: 'Gyan International Pvt Ltd' },
    {
      label: 'Havmor Ice Cream Private Limited',
      value: 'Havmor Ice Cream Private Limited',
    },
    { label: 'HCL Technologies', value: 'HCL Technologies' },
    { label: 'HDFC Bank', value: 'HDFC Bank' },
    {
      label: 'Heat Consultants Private Limited',
      value: 'Heat Consultants Private Limited',
    },
    { label: 'HERE Technologies', value: 'HERE Technologies' },
    { label: 'HERO', value: 'HERO' },
    { label: 'HiCare Services', value: 'HiCare Services' },
    { label: 'Highradius Technologies', value: 'Highradius Technologies' },
    {
      label: 'Hindustan Coca-Cola Beverages',
      value: 'Hindustan Coca-Cola Beverages',
    },
    {
      label: 'HINDUSTAN PETROLEUM CORPORATION LIMITED',
      value: 'HINDUSTAN PETROLEUM CORPORATION LIMITED',
    },
    { label: 'Hindustan Times', value: 'Hindustan Times' },
    { label: 'Hindustan Unilever Ltd.', value: 'Hindustan Unilever Ltd.' },
    { label: 'Home Interiors', value: 'Home Interiors' },
    {
      label: 'Honeywell Automation India Ltd',
      value: 'Honeywell Automation India Ltd',
    },
    { label: 'HSBC', value: 'HSBC' },
    { label: 'HUAWEI', value: 'HUAWEI' },
    { label: 'Huddl.ai', value: 'Huddl.ai' },
    {
      label: 'Hyundai motor India engineering',
      value: 'Hyundai motor India engineering',
    },
    { label: 'ICICI bank', value: 'ICICI bank' },
    {
      label: 'IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED',
      value: 'IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED',
    },
    { label: 'In My Element', value: 'In My Element' },
    { label: 'INDIA POST PAYMENTS BANK', value: 'INDIA POST PAYMENTS BANK' },
    { label: 'INDIAN ARMY ASSAM RIFLES', value: 'INDIAN ARMY ASSAM RIFLES' },
    {
      label: 'Indian Institute of Technology Bombay',
      value: 'Indian Institute of Technology Bombay',
    },
    { label: 'INDSMEN', value: 'INDSMEN' },
    { label: 'IndusInd Bank Ltd', value: 'IndusInd Bank Ltd' },
    { label: 'Infosys', value: 'Infosys' },
    { label: 'InnovatioQore', value: 'InnovatioQore' },
    { label: 'Innovatiview India Pvt Ltd', value: 'Innovatiview India Pvt Ltd' },
    { label: 'Interactive Brokers', value: 'Interactive Brokers' },
    {
      label: 'IRIS Business Services Limited',
      value: 'IRIS Business Services Limited',
    },
    { label: 'ISRO', value: 'ISRO' },
    { label: 'ITC Infotech India Ltd', value: 'ITC Infotech India Ltd' },
    { label: 'ITC LIMITED', value: 'ITC LIMITED' },
    { label: 'Jacobs Engineering', value: 'Jacobs Engineering' },
    {
      label: 'Jamnagar Utilities & power Pvt Ltd',
      value: 'Jamnagar Utilities & power Pvt Ltd',
    },
    { label: 'Jindal Stainless Limited', value: 'Jindal Stainless Limited' },
    { label: 'JMC Projects India Ltd', value: 'JMC Projects India Ltd' },
    { label: 'Jones Lang Lasalle', value: 'Jones Lang Lasalle' },
    { label: 'Kabir International', value: 'Kabir International' },
    {
      label: 'KAK Engineering Works & Mitraviswa Engineering',
      value: 'KAK Engineering Works & Mitraviswa Engineering',
    },
    { label: 'Kanchan Hall', value: 'Kanchan Hall' },
    {
      label: 'KNAV Services Private Limited',
      value: 'KNAV Services Private Limited',
    },
    { label: 'KOTHARI FOOD INDUSTRIES', value: 'KOTHARI FOOD INDUSTRIES' },
    { label: 'KPMG', value: 'KPMG' },
    { label: 'KRIDL', value: 'KRIDL' },
    { label: 'Larsen & Toubro Infotech', value: 'Larsen & Toubro Infotech' },
    { label: 'Larsen & Toubro Limited', value: 'Larsen & Toubro Limited' },
    { label: 'Leoforce', value: 'Leoforce' },
    { label: 'Life Health Foods Pvt. Ltd', value: 'Life Health Foods Pvt. Ltd' },
    { label: 'Lionbridge Technologies', value: 'Lionbridge Technologies' },
    { label: 'Lodha Group', value: 'Lodha Group' },
    { label: 'M/s K.SRINATH REDDY & CO.', value: 'M/s K.SRINATH REDDY & CO.' },
    { label: 'M/S Sharma Engineering', value: 'M/S Sharma Engineering' },
    { label: 'Machinery Agencies India', value: 'Machinery Agencies India' },
    {
      label: 'Macquarie Global Services Pvt ltd',
      value: 'Macquarie Global Services Pvt ltd',
    },
    { label: 'Mahindra Logistics', value: 'Mahindra Logistics' },
    { label: 'Maihar Consultancy', value: 'Maihar Consultancy' },
    { label: 'Marquardt india', value: 'Marquardt india' },
    { label: 'Marque Advisory Services', value: 'Marque Advisory Services' },
    { label: 'Maruti Suzuki India Ltd', value: 'Maruti Suzuki India Ltd' },
    { label: 'MAVERICKS', value: 'MAVERICKS' },
    { label: 'Mazars Advisory LLP', value: 'Mazars Advisory LLP' },
    { label: 'Merkle B2B', value: 'Merkle B2B' },
    {
      label: 'Mettler Toledo India Private Limited',
      value: 'Mettler Toledo India Private Limited',
    },
    { label: 'Microfocus', value: 'Microfocus' },
    { label: 'Mindtree', value: 'Mindtree' },
    { label: 'Mitsubishi corporation', value: 'Mitsubishi corporation' },
    { label: 'Mittal Costruction Company', value: 'Mittal Costruction Company' },
    { label: 'MK Brothers', value: 'MK Brothers' },
    { label: 'MMSI', value: 'MMSI' },
    {
      label: 'Moody’s Analytics Knowledge Services',
      value: 'Moody’s Analytics Knowledge Services',
    },
    { label: 'Motherson', value: 'Motherson' },
    { label: 'MWIDM', value: 'MWIDM' },
    { label: 'N G JAIN & CO', value: 'N G JAIN & CO' },
    {
      label: 'Nagarjuna Construction Company',
      value: 'Nagarjuna Construction Company',
    },
    {
      label: 'NAROTTAM CHITRANJAN AND CO.',
      value: 'NAROTTAM CHITRANJAN AND CO.',
    },
    {
      label: 'NATIONAL ALUMINIUM COMPANY LTD',
      value: 'NATIONAL ALUMINIUM COMPANY LTD',
    },
    {
      label: 'National Engineering Industries Ltd',
      value: 'National Engineering Industries Ltd',
    },
    {
      label: 'National Themal Power Corporation Ltd.',
      value: 'National Themal Power Corporation Ltd.',
    },
    { label: 'NatWest', value: 'NatWest' },
    { label: 'Naulakha Refrigeration', value: 'Naulakha Refrigeration' },
    { label: 'Nayara Energy', value: 'Nayara Energy' },
    { label: 'Neenu Consulting', value: 'Neenu Consulting' },
    {
      label: 'Netpupps Technologies Pvt. Ltd.',
      value: 'Netpupps Technologies Pvt. Ltd.',
    },
    { label: 'New Madhura Industries', value: 'New Madhura Industries' },
    {
      label: 'Newwave Computing Pvt. Ltd.',
      value: 'Newwave Computing Pvt. Ltd.',
    },
    { label: 'NH MANUFACTURERS', value: 'NH MANUFACTURERS' },
    { label: 'NIIT Ltd', value: 'NIIT Ltd' },
    { label: 'NLF Consultancy', value: 'NLF Consultancy' },
    { label: 'Norther Trust', value: 'Norther Trust' },
    {
      label: 'NPCC Engineering Private Limited',
      value: 'NPCC Engineering Private Limited',
    },
    { label: 'NYK Shipmanagement Pte Ltd', value: 'NYK Shipmanagement Pte Ltd' },
    { label: 'Nykaa', value: 'Nykaa' },
    { label: 'Obel Systems Pvt Ltd', value: 'Obel Systems Pvt Ltd' },
    { label: 'Ocean Casettes Pvt. Ltd.', value: 'Ocean Casettes Pvt. Ltd.' },
    { label: 'One Hand Clap', value: 'One Hand Clap' },
    { label: 'Ongole', value: 'Ongole' },
    { label: 'Onward technologies', value: 'Onward technologies' },
    { label: 'Oracle India Pvt. Limited', value: 'Oracle India Pvt. Limited' },
    { label: 'Pactera EDGE Pvt Ltd', value: 'Pactera EDGE Pvt Ltd' },
    {
      label: 'PADMAJA POLY PACKS PRIVATE LIMITED',
      value: 'PADMAJA POLY PACKS PRIVATE LIMITED',
    },
    { label: 'PANORAMA CO. LTD.', value: 'PANORAMA CO. LTD.' },
    {
      label: 'Paragon Digital Services Pvt Ltd',
      value: 'Paragon Digital Services Pvt Ltd',
    },
    { label: 'PariPosha', value: 'PariPosha' },
    { label: 'Park Hyatt Lucknow', value: 'Park Hyatt Lucknow' },
    {
      label: 'Parnika Commercial & Estates Pvt. Ltd.',
      value: 'Parnika Commercial & Estates Pvt. Ltd.',
    },
    { label: 'Patel Hospital', value: 'Patel Hospital' },
    { label: 'PERFECT TRAVELS', value: 'PERFECT TRAVELS' },
    { label: 'Pikkol.com', value: 'Pikkol.com' },
    { label: 'Policy Bazaar', value: 'Policy Bazaar' },
    {
      label: 'Posh Puppy Technologies Pvt Ltd',
      value: 'Posh Puppy Technologies Pvt Ltd',
    },
    { label: 'Pragati Asha Seva Sanstha', value: 'Pragati Asha Seva Sanstha' },
    { label: 'Prenit World LLP', value: 'Prenit World LLP' },
    { label: 'PS Atree and Company', value: 'PS Atree and Company' },
    { label: 'PwC', value: 'PwC' },
    { label: 'QBS Learning', value: 'QBS Learning' },
    {
      label: 'Qualcomm Semiconductor company',
      value: 'Qualcomm Semiconductor company',
    },
    { label: 'Quest Global', value: 'Quest Global' },
    { label: 'R. S. DISTRIBUTOR', value: 'R. S. DISTRIBUTOR' },
    { label: 'Rambek Industries', value: 'Rambek Industries' },
    {
      label: 'Ramsons Perfumes Private Limited',
      value: 'Ramsons Perfumes Private Limited',
    },
    { label: 'RANVIT ENTERPRISES', value: 'RANVIT ENTERPRISES' },
    { label: 'Ratanlal Mahendra Kumar', value: 'Ratanlal Mahendra Kumar' },
    { label: 'Regalix', value: 'Regalix' },
    { label: 'Rehoboth Infra', value: 'Rehoboth Infra' },
    { label: 'Reliance Industries', value: 'Reliance Industries' },
    { label: 'Reliance Jio', value: 'Reliance Jio' },
    { label: 'RELIANCE RETAIL LIMITED', value: 'RELIANCE RETAIL LIMITED' },
    {
      label: 'Renault Nissan Technology and Business center',
      value: 'Renault Nissan Technology and Business center',
    },
    { label: 'Rimush Innovations Pvt Ltd', value: 'Rimush Innovations Pvt Ltd' },
    {
      label: 'Ring Plus Aqua Limited A Raymond Subsidiary',
      value: 'Ring Plus Aqua Limited A Raymond Subsidiary',
    },
    { label: 'Ritz carlton', value: 'Ritz carlton' },
    { label: 'Rivigo', value: 'Rivigo' },
    { label: 'Robert Bosch', value: 'Robert Bosch' },
    { label: 'Roposo (Glance InMobi)', value: 'Roposo (Glance InMobi)' },
    { label: 'Royal Bank Of Scotland', value: 'Royal Bank Of Scotland' },
    { label: 'Rumsclothing', value: 'Rumsclothing' },
    {
      label: 'RUPEEBOSS FINANCIAL SERVICES PVT LTD',
      value: 'RUPEEBOSS FINANCIAL SERVICES PVT LTD',
    },
    { label: 'RVB CONSULTANCY', value: 'RVB CONSULTANCY' },
    {
      label: 'Samasth Living Pvt. Ltd. (Settl.)',
      value: 'Samasth Living Pvt. Ltd. (Settl.)',
    },
    {
      label: 'SANTHAVANA MAHILA ABHIVRIDDHI SAMSTHE',
      value: 'SANTHAVANA MAHILA ABHIVRIDDHI SAMSTHE',
    },
    {
      label: 'Sarvodaya Specialities Pvt Ltd.',
      value: 'Sarvodaya Specialities Pvt Ltd.',
    },
    { label: 'Sattva Consulting', value: 'Sattva Consulting' },
    { label: 'Schneider Electric', value: 'Schneider Electric' },
    { label: 'Scorpio Group', value: 'Scorpio Group' },
    {
      label: 'Sectona Technologies Private Limited',
      value: 'Sectona Technologies Private Limited',
    },
    { label: 'Self Employed', value: 'Self Employed' },
    { label: 'Servspaces', value: 'Servspaces' },
    { label: 'shah paper pack', value: 'shah paper pack' },
    { label: 'Shapoorji Pallonji', value: 'Shapoorji Pallonji' },
    {
      label: 'Shapoorji Pallonji and Company Private Limited',
      value: 'Shapoorji Pallonji and Company Private Limited',
    },
    { label: 'Sharekhan By BNP Paribas', value: 'Sharekhan By BNP Paribas' },
    {
      label: 'Shree Ganga Vidhyanikethan School',
      value: 'Shree Ganga Vidhyanikethan School',
    },
    { label: 'Siemens Ltd', value: 'Siemens Ltd' },
    { label: 'SKH Metals ltd', value: 'SKH Metals ltd' },
    { label: 'skylark delhi pvt. ltd.', value: 'skylark delhi pvt. ltd.' },
    { label: 'SM Associates', value: 'SM Associates' },
    { label: 'Smart Business Solutions', value: 'Smart Business Solutions' },
    {
      label: 'Societe Generale Global Solutions Center',
      value: 'Societe Generale Global Solutions Center',
    },
    { label: 'Sonam Enterprise', value: 'Sonam Enterprise' },
    {
      label: 'Sonbhadra construction company',
      value: 'Sonbhadra construction company',
    },
    {
      label: 'SP Networking Solutions LLP',
      value: 'SP Networking Solutions LLP',
    },
    { label: 'Spardha Pvt. Ltd.', value: 'Spardha Pvt. Ltd.' },
    {
      label: 'Spiral Content Solutions Pvt. Ltd.',
      value: 'Spiral Content Solutions Pvt. Ltd.',
    },
    { label: 'SRI KAVYA SHOPPING CENTRE', value: 'SRI KAVYA SHOPPING CENTRE' },
    { label: 'SRI UDHAYAM FINANCE', value: 'SRI UDHAYAM FINANCE' },
    { label: 'SRIJAN TECHNOLOGIES', value: 'SRIJAN TECHNOLOGIES' },
    { label: 'SRINIVASA IRON COMPANY', value: 'SRINIVASA IRON COMPANY' },
    { label: 'Sriven Enterprises', value: 'Sriven Enterprises' },
    { label: 'Standard Chartered Bank', value: 'Standard Chartered Bank' },
    {
      label: 'Stellium Consulting India Pvt. Ltd.',
      value: 'Stellium Consulting India Pvt. Ltd.',
    },
    { label: 'Straive', value: 'Straive' },
    { label: 'Sunlife Financials', value: 'Sunlife Financials' },
    { label: 'Supr daily by Swiggy', value: 'Supr daily by Swiggy' },
    {
      label: 'SUTLEJ TEXTILES AND INDUSTRIES LIMITED',
      value: 'SUTLEJ TEXTILES AND INDUSTRIES LIMITED',
    },
    { label: 'SWEETS OF OMAN,MUSCAT', value: 'SWEETS OF OMAN,MUSCAT' },
    { label: 'Talent500 by ANSR', value: 'Talent500 by ANSR' },
    { label: 'TATA CONSULTANCY SERVICES', value: 'TATA CONSULTANCY SERVICES' },
    {
      label: 'TATA IG GENERAL INSURANCE COMPANY',
      value: 'TATA IG GENERAL INSURANCE COMPANY',
    },
    { label: 'Tata Motors', value: 'Tata Motors' },
    { label: 'Tata Projects Ltd.', value: 'Tata Projects Ltd.' },
    { label: 'TATA STEEL', value: 'TATA STEEL' },
    { label: 'Teksystems Global Services', value: 'Teksystems Global Services' },
    { label: 'ThePropertist.com', value: 'ThePropertist.com' },
    { label: 'THINK AND LEARN PVT LTD', value: 'THINK AND LEARN PVT LTD' },
    { label: 'Think Talent Services', value: 'Think Talent Services' },
    { label: 'ThoughtRadius', value: 'ThoughtRadius' },
    { label: 'TIMKEN', value: 'TIMKEN' },
    { label: 'Timkrn India Limited', value: 'Timkrn India Limited' },
    { label: 'TopHire', value: 'TopHire' },
    {
      label: 'Toshiba Transmission & Distribution Systems',
      value: 'Toshiba Transmission & Distribution Systems',
    },
    { label: 'Tradologie', value: 'Tradologie' },
    { label: 'Trafigura Global Services', value: 'Trafigura Global Services' },
    {
      label: 'Transparency technologies Pvt ltd',
      value: 'Transparency technologies Pvt ltd',
    },
    { label: 'Trukker', value: 'Trukker' },
    { label: 'UActiv Pvt. Ltd.', value: 'UActiv Pvt. Ltd.' },
    { label: 'ULTRA TOUCH TRADERS', value: 'ULTRA TOUCH TRADERS' },
    { label: 'Ultratech Cement', value: 'Ultratech Cement' },
    { label: 'Umesh Amita & Co', value: 'Umesh Amita & Co' },
    { label: 'Upscalehub.com', value: 'Upscalehub.com' },
    { label: 'Urban Company', value: 'Urban Company' },
    {
      label: 'Utopus Insights India Pvt. Ltd.',
      value: 'Utopus Insights India Pvt. Ltd.',
    },
    { label: 'Utsav Homes', value: 'Utsav Homes' },
    { label: 'Valuelabs', value: 'Valuelabs' },
    { label: 'Varroc Engineering Ltd', value: 'Varroc Engineering Ltd' },
    { label: 'Vedanta', value: 'Vedanta' },
    { label: 'Veear Baking Solutions', value: 'Veear Baking Solutions' },
    { label: 'Veljan Denison Ltd.', value: 'Veljan Denison Ltd.' },
    { label: 'VEM Technologies Pvt. Ltd.', value: 'VEM Technologies Pvt. Ltd.' },
    { label: 'Vena Energy', value: 'Vena Energy' },
    { label: 'Venkatrama Poultries', value: 'Venkatrama Poultries' },
    { label: 'Vertisystem Global Pvt Ltd', value: 'Vertisystem Global Pvt Ltd' },
    { label: 'VERZEO EDUTECH', value: 'VERZEO EDUTECH' },
    { label: 'Vidyamandir classes', value: 'Vidyamandir classes' },
    { label: 'Vindhya Telelinks Limited', value: 'Vindhya Telelinks Limited' },
    { label: 'Vivek Logani Associates', value: 'Vivek Logani Associates' },
    {
      label: 'Vivish Technologies Pvt Ltd',
      value: 'Vivish Technologies Pvt Ltd',
    },
    { label: 'vodafone', value: 'vodafone' },
    { label: 'VOITH TURBO PVT .LTD.', value: 'VOITH TURBO PVT .LTD.' },
    { label: 'Vyali International', value: 'Vyali International' },
    { label: 'Wipro technologies', value: 'Wipro technologies' },
    { label: 'wyzon biotics', value: 'wyzon biotics' },
    { label: 'YES BANK LTD', value: 'YES BANK LTD' },
    { label: 'Zepto', value: 'Zepto' },
    { label: 'ZS Associates', value: 'ZS Associates' },
    { label: 'Others', value: 'Others' },
  ];
  
  export const FORM_VALUES_ETHNICITY = [
    {
      label: 'Information refused',
      value: 'Information refused',
    },
    {
      label: 'Unknown',
      value: 'Unknown',
    },
    { label: 'Arab', value: 'Arab' },
    {
      label: 'Asian, Asian Scottish, Asian British - Bangladeshi',
      value: 'Asian, Asian Scottish, Asian British - Bangladeshi',
    },
    {
      label: 'Asian, Asian Scottish, Asian British - Indian',
      value: 'Asian, Asian Scottish, Asian British - Indian',
    },
    {
      label: 'Asian, Asian Scottish, Asian British - Pakistani',
      value: 'Asian, Asian Scottish, Asian British - Pakistani',
    },
    { label: 'Chinese', value: 'Chinese' },
    { label: 'Any other Asian background', value: 'Any other Asian background' },
    {
      label: 'Black, Black Scottish, Black British - African',
      value: 'Black, Black Scottish, Black British - African',
    },
    {
      label: 'Black, Black Scottish, Black British - Caribbean',
      value: 'Black, Black Scottish, Black British - Caribbean',
    },
    { label: 'Any other Black background', value: 'Any other Black background' },
    { label: 'Mixed - White and Asian', value: 'Mixed - White and Asian' },
    {
      label: 'Mixed - White and Black African',
      value: 'Mixed - White and Black African',
    },
    {
      label: 'Mixed - White and Black Caribbean',
      value: 'Mixed - White and Black Caribbean',
    },
    { label: 'Other mixed background', value: 'Other mixed background' },
    { label: 'White', value: 'White' },
    {
      label: 'White - Gypsy/Roma/Traveller',
      value: 'White - Gypsy/Roma/Traveller',
    },
    { label: 'White - Irish traveller', value: 'White - Irish traveller' },
    { label: 'White - Polish', value: 'White - Polish' },
    { label: 'White - White Scottish', value: 'White - White Scottish' },
    { label: 'Any other White background', value: 'Any other White background' },
    { label: 'Other ethnic background', value: 'Other ethnic background' },
    { label: 'White - Other British', value: 'White - Other British' },
  ];
  
  export const FORM_VALUES_OCCUPATION = [
    { label: 'Retired', value: 'Retired' },
    { label: 'Unemployed', value: 'Unemployed' },
    { label: 'Not known', value: 'Not known' },
    {
      label: 'Senior officials in national government',
      value: 'Senior officials in national government',
    },
    {
      label: 'Directors & chief executives of major organisations',
      value: 'Directors & chief executives of major organisations',
    },
    {
      label: 'Senior officials in local government',
      value: 'Senior officials in local government',
    },
    {
      label: 'Senior officials of special interest organisations',
      value: 'Senior officials of special interest organisations',
    },
    {
      label: 'Production, works & maintenance managers',
      value: 'Production, works & maintenance managers',
    },
    { label: 'Managers in construction', value: 'Managers in construction' },
    {
      label: 'Managers in mining & energy',
      value: 'Managers in mining & energy',
    },
    {
      label: 'Financial managers & chartered secretaries',
      value: 'Financial managers & chartered secretaries',
    },
    { label: 'Marketing & sales managers', value: 'Marketing & sales managers' },
    { label: 'Purchasing managers', value: 'Purchasing managers' },
    {
      label: 'Advertising & public relations managers',
      value: 'Advertising & public relations managers',
    },
    {
      label: 'Personnel, training & industrial relations managers',
      value: 'Personnel, training & industrial relations managers',
    },
    {
      label: 'Information & communication technology managers',
      value: 'Information & communication technology managers',
    },
    {
      label: 'Research & development managers',
      value: 'Research & development managers',
    },
    { label: 'Quality assurance managers', value: 'Quality assurance managers' },
    { label: 'Customer care managers', value: 'Customer care managers' },
    {
      label: 'Financial institution managers',
      value: 'Financial institution managers',
    },
    { label: 'Office managers', value: 'Office managers' },
    {
      label: 'Transport & distribution managers',
      value: 'Transport & distribution managers',
    },
    {
      label: 'Storage & warehouse managers',
      value: 'Storage & warehouse managers',
    },
    {
      label: 'Retail & wholesale managers',
      value: 'Retail & wholesale managers',
    },
    { label: 'Officers in armed forces', value: 'Officers in armed forces' },
    {
      label: 'Police officers (inspectors & above)',
      value: 'Police officers (inspectors & above)',
    },
    {
      label: 'Senior officers in fire, ambulance, prison & related services',
      value: 'Senior officers in fire, ambulance, prison & related services',
    },
    { label: 'Security managers', value: 'Security managers' },
    {
      label: 'Hospital & health service managers',
      value: 'Hospital & health service managers',
    },
    { label: 'Pharmacy managers', value: 'Pharmacy managers' },
    {
      label: 'Healthcare practice managers',
      value: 'Healthcare practice managers',
    },
    { label: 'Social services managers', value: 'Social services managers' },
    {
      label: 'Residential & day care managers',
      value: 'Residential & day care managers',
    },
    { label: 'Farm managers', value: 'Farm managers' },
    {
      label: 'Natural environment & conservation managers',
      value: 'Natural environment & conservation managers',
    },
    {
      label: 'Managers in animal husbandry, forestry & fishing n.e.c',
      value: 'Managers in animal husbandry, forestry & fishing n.e.c',
    },
    {
      label: 'Hotel & accommodation managers',
      value: 'Hotel & accommodation managers',
    },
    {
      label: 'Conference & exhibition managers',
      value: 'Conference & exhibition managers',
    },
    {
      label: 'Restaurant & catering managers',
      value: 'Restaurant & catering managers',
    },
    {
      label: 'Publicans & managers of licensed premises',
      value: 'Publicans & managers of licensed premises',
    },
    { label: 'Leisure & sports managers', value: 'Leisure & sports managers' },
    { label: 'Travel agency managers', value: 'Travel agency managers' },
    {
      label: 'Property, housing & land managers',
      value: 'Property, housing & land managers',
    },
    {
      label: 'Garage managers & proprietors',
      value: 'Garage managers & proprietors',
    },
    {
      label: 'Hairdressing & beauty salon managers & proprietors',
      value: 'Hairdressing & beauty salon managers & proprietors',
    },
    {
      label: 'Shopkeepers & wholesale/retail dealers',
      value: 'Shopkeepers & wholesale/retail dealers',
    },
    {
      label: 'Recycling & refuse disposal managers',
      value: 'Recycling & refuse disposal managers',
    },
    {
      label: 'Managers & proprietors in other services n.e.c',
      value: 'Managers & proprietors in other services n.e.c',
    },
    { label: 'Chemists', value: 'Chemists' },
    {
      label: 'Biological scientists & biochemists',
      value: 'Biological scientists & biochemists',
    },
    {
      label: 'Physicists, geologists & meteorologists',
      value: 'Physicists, geologists & meteorologists',
    },
    { label: 'Civil engineers', value: 'Civil engineers' },
    { label: 'Mechanical engineers', value: 'Mechanical engineers' },
    { label: 'Electrical engineers', value: 'Electrical engineers' },
    { label: 'Electronics engineers', value: 'Electronics engineers' },
    { label: 'Chemical engineers', value: 'Chemical engineers' },
    {
      label: 'Design & development engineers',
      value: 'Design & development engineers',
    },
    {
      label: 'Production & process engineers',
      value: 'Production & process engineers',
    },
    {
      label: 'Planning & quality control engineers',
      value: 'Planning & quality control engineers',
    },
    {
      label: 'Engineering professionals n.e.c',
      value: 'Engineering professionals n.e.c',
    },
    {
      label: 'IT strategy & planning professionals',
      value: 'IT strategy & planning professionals',
    },
    { label: 'Software professionals', value: 'Software professionals' },
    { label: 'Medical practitioners', value: 'Medical practitioners' },
    { label: 'Psychologists', value: 'Psychologists' },
    {
      label: 'Pharmacists/pharmacologists',
      value: 'Pharmacists/pharmacologists',
    },
    { label: 'Ophthalmic opticians', value: 'Ophthalmic opticians' },
    { label: 'Dental practitioners', value: 'Dental practitioners' },
    { label: 'Veterinarians', value: 'Veterinarians' },
    {
      label: 'Higher education teaching professionals',
      value: 'Higher education teaching professionals',
    },
    {
      label: 'Further education teaching professionals',
      value: 'Further education teaching professionals',
    },
    {
      label: 'Education officers, school inspectors',
      value: 'Education officers, school inspectors',
    },
    {
      label: 'Secondary education teaching professionals',
      value: 'Secondary education teaching professionals',
    },
    {
      label: 'Primary & nursery education teaching professionals',
      value: 'Primary & nursery education teaching professionals',
    },
    {
      label: 'Special needs education teaching professionals',
      value: 'Special needs education teaching professionals',
    },
    {
      label: 'Registrars & senior administrators of educational establishments',
      value: 'Registrars & senior administrators of educational establishments',
    },
    {
      label: 'Teaching professionals n.e.c',
      value: 'Teaching professionals n.e.c',
    },
    { label: 'Scientific researchers', value: 'Scientific researchers' },
    { label: 'Social science researchers', value: 'Social science researchers' },
    { label: 'Researchers n.e.c', value: 'Researchers n.e.c' },
    {
      label: 'Solicitors & lawyers, judges & coroners',
      value: 'Solicitors & lawyers, judges & coroners',
    },
    { label: 'Legal professionals n.e.c', value: 'Legal professionals n.e.c' },
    {
      label: 'Chartered & certified accountants',
      value: 'Chartered & certified accountants',
    },
    { label: 'Management accountants', value: 'Management accountants' },
    {
      label: 'Management consultants, actuaries, economists & statisticians',
      value: 'Management consultants, actuaries, economists & statisticians',
    },
    { label: 'Architects', value: 'Architects' },
    { label: 'Town planners', value: 'Town planners' },
    { label: 'Quantity surveyors', value: 'Quantity surveyors' },
    {
      label: 'Chartered surveyors (not quantity surveyors)',
      value: 'Chartered surveyors (not quantity surveyors)',
    },
    {
      label: 'Public service administrative professionals',
      value: 'Public service administrative professionals',
    },
    { label: 'Social workers', value: 'Social workers' },
    { label: 'Probation officers', value: 'Probation officers' },
    { label: 'Clergy', value: 'Clergy' },
    { label: 'Librarians', value: 'Librarians' },
    { label: 'Archivists & curators', value: 'Archivists & curators' },
    { label: 'Laboratory technicians', value: 'Laboratory technicians' },
    {
      label: 'Electrical/electronics technicians',
      value: 'Electrical/electronics technicians',
    },
    { label: 'Engineering technicians', value: 'Engineering technicians' },
    {
      label: 'Building & civil engineering technicians',
      value: 'Building & civil engineering technicians',
    },
    {
      label: 'Quality assurance technicians',
      value: 'Quality assurance technicians',
    },
    {
      label: 'Science & engineering technicians n.e.c',
      value: 'Science & engineering technicians n.e.c',
    },
    {
      label: 'Architectural technologists & town planning technicians',
      value: 'Architectural technologists & town planning technicians',
    },
    { label: 'Draughtspersons', value: 'Draughtspersons' },
    { label: 'Building inspectors', value: 'Building inspectors' },
    { label: 'IT operations technicians', value: 'IT operations technicians' },
    {
      label: 'IT user support technicians',
      value: 'IT user support technicians',
    },
    { label: 'Nurses', value: 'Nurses' },
    { label: 'Midwives', value: 'Midwives' },
    { label: 'Paramedics', value: 'Paramedics' },
    { label: 'Medical radiographers', value: 'Medical radiographers' },
    { label: 'Chiropodists', value: 'Chiropodists' },
    { label: 'Dispensing opticians', value: 'Dispensing opticians' },
    { label: 'Pharmaceutical dispensers', value: 'Pharmaceutical dispensers' },
    {
      label: 'Medical & dental technicians',
      value: 'Medical & dental technicians',
    },
    { label: 'Physiotherapists', value: 'Physiotherapists' },
    { label: 'Occupational therapists', value: 'Occupational therapists' },
    {
      label: 'Speech & language therapists',
      value: 'Speech & language therapists',
    },
    { label: 'Therapists n.e.c', value: 'Therapists n.e.c' },
    { label: 'Youth & community workers', value: 'Youth & community workers' },
    { label: 'Housing & welfare officers', value: 'Housing & welfare officers' },
    { label: 'NCOs & other ranks', value: 'NCOs & other ranks' },
    {
      label: 'Police officers (sergeant & below)',
      value: 'Police officers (sergeant & below)',
    },
    {
      label: 'Fire service officers (leading fire officer & below)',
      value: 'Fire service officers (leading fire officer & below)',
    },
    {
      label: 'Prison service officers (below principal officer)',
      value: 'Prison service officers (below principal officer)',
    },
    {
      label: 'Protective service associate professionals n.e.c',
      value: 'Protective service associate professionals n.e.c',
    },
    { label: 'Artists', value: 'Artists' },
    { label: 'Authors, writers', value: 'Authors, writers' },
    { label: 'Actors, entertainers', value: 'Actors, entertainers' },
    { label: 'Dancers & choreographers', value: 'Dancers & choreographers' },
    { label: 'Musicians', value: 'Musicians' },
    {
      label: 'Arts officers, producers & directors',
      value: 'Arts officers, producers & directors',
    },
    { label: 'Graphic designers', value: 'Graphic designers' },
    {
      label: 'Product, clothing & related designers',
      value: 'Product, clothing & related designers',
    },
    {
      label: 'Journalists, newspaper & periodical editors',
      value: 'Journalists, newspaper & periodical editors',
    },
    {
      label: 'Broadcasting associate professionals',
      value: 'Broadcasting associate professionals',
    },
    { label: 'Public relations officers', value: 'Public relations officers' },
    {
      label: 'Photographers & audio-visual equipment operators',
      value: 'Photographers & audio-visual equipment operators',
    },
    { label: 'Sports players', value: 'Sports players' },
    {
      label: 'Sports coaches, instructors & officials',
      value: 'Sports coaches, instructors & officials',
    },
    { label: 'Fitness instructors', value: 'Fitness instructors' },
    {
      label: 'Sports & fitness occupations n.e.c',
      value: 'Sports & fitness occupations n.e.c',
    },
    { label: 'Air traffic controllers', value: 'Air traffic controllers' },
    {
      label: 'Aircraft pilots & flight engineers',
      value: 'Aircraft pilots & flight engineers',
    },
    { label: 'Ship & hovercraft officers', value: 'Ship & hovercraft officers' },
    { label: 'Train drivers', value: 'Train drivers' },
    {
      label: 'Legal associate professionals',
      value: 'Legal associate professionals',
    },
    {
      label: 'Estimators, valuers & assessors',
      value: 'Estimators, valuers & assessors',
    },
    { label: 'Brokers', value: 'Brokers' },
    { label: 'Insurance underwriters', value: 'Insurance underwriters' },
    {
      label: 'Finance & investment analysts/advisers',
      value: 'Finance & investment analysts/advisers',
    },
    { label: 'Taxation experts', value: 'Taxation experts' },
    { label: 'Importers, exporters', value: 'Importers, exporters' },
    {
      label: 'Financial & accounting technicians',
      value: 'Financial & accounting technicians',
    },
    {
      label: 'Business & related associate professionals n.e.c',
      value: 'Business & related associate professionals n.e.c',
    },
    {
      label: 'Buyers & purchasing officers',
      value: 'Buyers & purchasing officers',
    },
    { label: 'Sales representatives', value: 'Sales representatives' },
    {
      label: 'Marketing associate professionals',
      value: 'Marketing associate professionals',
    },
    { label: 'Estate agents, auctioneers', value: 'Estate agents, auctioneers' },
    {
      label: 'Conservation & environmental protection officers',
      value: 'Conservation & environmental protection officers',
    },
    { label: 'Countryside & park rangers', value: 'Countryside & park rangers' },
    {
      label: 'Public service associate professionals',
      value: 'Public service associate professionals',
    },
    {
      label: 'Personnel & industrial relations officers',
      value: 'Personnel & industrial relations officers',
    },
    {
      label: 'Vocational & industrial trainers & instructors',
      value: 'Vocational & industrial trainers & instructors',
    },
    {
      label: 'Careers advisers & vocational guidance specialists',
      value: 'Careers advisers & vocational guidance specialists',
    },
    {
      label: 'Inspectors of factories, utilities & trading standards',
      value: 'Inspectors of factories, utilities & trading standards',
    },
    { label: 'Statutory examiners', value: 'Statutory examiners' },
    {
      label: 'Occupational hygienists & safety officers (health & safety)',
      value: 'Occupational hygienists & safety officers (health & safety)',
    },
    {
      label: 'Environmental health officers',
      value: 'Environmental health officers',
    },
    {
      label: 'Civil Service executive officers',
      value: 'Civil Service executive officers',
    },
    {
      label: 'Civil Service administrative officers & assistants',
      value: 'Civil Service administrative officers & assistants',
    },
    {
      label: 'Local government clerical officers & assistants',
      value: 'Local government clerical officers & assistants',
    },
    {
      label: 'Officers of non-governmental organisations',
      value: 'Officers of non-governmental organisations',
    },
    { label: 'Credit controllers', value: 'Credit controllers' },
    {
      label: 'Accounts & wages clerks, book-keepers, other financial clerks',
      value: 'Accounts & wages clerks, book-keepers, other financial clerks',
    },
    { label: 'Counter clerks', value: 'Counter clerks' },
    {
      label: 'Filing & other records assistants/clerks',
      value: 'Filing & other records assistants/clerks',
    },
    {
      label: 'Pensions & insurance clerks',
      value: 'Pensions & insurance clerks',
    },
    { label: 'Stock control clerks', value: 'Stock control clerks' },
    {
      label: 'Transport & distribution clerks',
      value: 'Transport & distribution clerks',
    },
    { label: 'Library assistants/clerks', value: 'Library assistants/clerks' },
    { label: 'Database assistants/clerks', value: 'Database assistants/clerks' },
    {
      label: 'Market research interviewers',
      value: 'Market research interviewers',
    },
    { label: 'Telephonists', value: 'Telephonists' },
    { label: 'Communication operators', value: 'Communication operators' },
    {
      label: 'General office assistants/clerks',
      value: 'General office assistants/clerks',
    },
    { label: 'Medical secretaries', value: 'Medical secretaries' },
    { label: 'Legal secretaries', value: 'Legal secretaries' },
    { label: 'School secretaries', value: 'School secretaries' },
    { label: 'Company secretaries', value: 'Company secretaries' },
    {
      label: 'Personal assistants & other secretaries',
      value: 'Personal assistants & other secretaries',
    },
    { label: 'Receptionists', value: 'Receptionists' },
    { label: 'Typists', value: 'Typists' },
    { label: 'Farmers', value: 'Farmers' },
    { label: 'Horticultural trades', value: 'Horticultural trades' },
    {
      label: 'Gardeners & groundsmen/groundswomen',
      value: 'Gardeners & groundsmen/groundswomen',
    },
    {
      label: 'Agricultural & fishing trades n.e.c',
      value: 'Agricultural & fishing trades n.e.c',
    },
    { label: 'Smiths & forge workers', value: 'Smiths & forge workers' },
    {
      label: 'Moulders, core makers, die casters',
      value: 'Moulders, core makers, die casters',
    },
    { label: 'Sheet metal workers', value: 'Sheet metal workers' },
    {
      label: 'Metal plate workers, shipwrights, riveters',
      value: 'Metal plate workers, shipwrights, riveters',
    },
    { label: 'Welding trades', value: 'Welding trades' },
    { label: 'Pipe fitters', value: 'Pipe fitters' },
    {
      label: 'Metal machining setters & setter-operators',
      value: 'Metal machining setters & setter-operators',
    },
    {
      label: 'Tool makers, tool fitters & markers-out',
      value: 'Tool makers, tool fitters & markers-out',
    },
    {
      label: 'Metal working production & maintenance fitters',
      value: 'Metal working production & maintenance fitters',
    },
    {
      label: 'Precision instrument makers & repairers',
      value: 'Precision instrument makers & repairers',
    },
    {
      label: 'Motor mechanics, auto engineers',
      value: 'Motor mechanics, auto engineers',
    },
    {
      label: 'Vehicle body builders & repairers',
      value: 'Vehicle body builders & repairers',
    },
    { label: 'Auto electricians', value: 'Auto electricians' },
    { label: 'Vehicle spray painters', value: 'Vehicle spray painters' },
    {
      label: 'Electricians, electrical fitters',
      value: 'Electricians, electrical fitters',
    },
    {
      label: 'Telecommunications engineers',
      value: 'Telecommunications engineers',
    },
    {
      label: 'Lines repairers & cable jointers',
      value: 'Lines repairers & cable jointers',
    },
    {
      label: 'TV, video & audio engineers',
      value: 'TV, video & audio engineers',
    },
    {
      label: 'Computer engineers, installation & maintenance',
      value: 'Computer engineers, installation & maintenance',
    },
    {
      label: 'Electrical/electronics engineers n.e.c',
      value: 'Electrical/electronics engineers n.e.c',
    },
    { label: 'Steel erectors', value: 'Steel erectors' },
    { label: 'Bricklayers, masons', value: 'Bricklayers, masons' },
    {
      label: 'Roofers, roof tilers & slaters',
      value: 'Roofers, roof tilers & slaters',
    },
    {
      label: 'Plumbers, heating & ventilating engineers',
      value: 'Plumbers, heating & ventilating engineers',
    },
    { label: 'Carpenters & joiners', value: 'Carpenters & joiners' },
    {
      label: 'Glaziers, window fabricators & fitters',
      value: 'Glaziers, window fabricators & fitters',
    },
    { label: 'Construction trades n.e.c', value: 'Construction trades n.e.c' },
    { label: 'Plasterers', value: 'Plasterers' },
    { label: 'Floorers & wall tilers', value: 'Floorers & wall tilers' },
    { label: 'Painters & decorators', value: 'Painters & decorators' },
    { label: 'Weavers & knitters', value: 'Weavers & knitters' },
    { label: 'Upholsterers', value: 'Upholsterers' },
    { label: 'Leather & related trades', value: 'Leather & related trades' },
    { label: 'Tailors & dressmakers', value: 'Tailors & dressmakers' },
    {
      label: 'Textiles, garments & related trades n.e.c',
      value: 'Textiles, garments & related trades n.e.c',
    },
    {
      label: 'Originators, compositors & print preparers',
      value: 'Originators, compositors & print preparers',
    },
    { label: 'Printers', value: 'Printers' },
    {
      label: 'Bookbinders & print finishers',
      value: 'Bookbinders & print finishers',
    },
    { label: 'Screen printers', value: 'Screen printers' },
    { label: 'Butchers, meat cutters', value: 'Butchers, meat cutters' },
    {
      label: 'Bakers, flour confectioners',
      value: 'Bakers, flour confectioners',
    },
    {
      label: 'Fishmongers, poultry dressers',
      value: 'Fishmongers, poultry dressers',
    },
    { label: 'Chefs, cooks', value: 'Chefs, cooks' },
    {
      label: 'Glass & ceramics makers, decorators & finishers',
      value: 'Glass & ceramics makers, decorators & finishers',
    },
    {
      label: 'Furniture makers, other craft woodworkers',
      value: 'Furniture makers, other craft woodworkers',
    },
    { label: 'Pattern makers (moulds)', value: 'Pattern makers (moulds)' },
    {
      label: 'Musical instrument makers & tuners',
      value: 'Musical instrument makers & tuners',
    },
    {
      label: 'Goldsmiths, silversmiths, precious stone workers',
      value: 'Goldsmiths, silversmiths, precious stone workers',
    },
    { label: 'Floral arrangers, florists', value: 'Floral arrangers, florists' },
    {
      label: 'Hand craft occupations n.e.c',
      value: 'Hand craft occupations n.e.c',
    },
    {
      label: 'Nursing auxiliaries & assistants',
      value: 'Nursing auxiliaries & assistants',
    },
    {
      label: 'Ambulance staff (excluding paramedics)',
      value: 'Ambulance staff (excluding paramedics)',
    },
    { label: 'Dental nurses', value: 'Dental nurses' },
    {
      label: 'Houseparents & residential wardens',
      value: 'Houseparents & residential wardens',
    },
    {
      label: 'Care assistants & home carers',
      value: 'Care assistants & home carers',
    },
    { label: 'Nursery nurses', value: 'Nursery nurses' },
    {
      label: 'Childminders & related occupations',
      value: 'Childminders & related occupations',
    },
    {
      label: 'Playgroup leaders/assistants',
      value: 'Playgroup leaders/assistants',
    },
    { label: 'Educational assistants', value: 'Educational assistants' },
    {
      label: 'Veterinary nurses & assistants',
      value: 'Veterinary nurses & assistants',
    },
    {
      label: 'Animal care occupations n.e.c',
      value: 'Animal care occupations n.e.c',
    },
    {
      label: 'Sports & leisure assistants',
      value: 'Sports & leisure assistants',
    },
    { label: 'Travel agents', value: 'Travel agents' },
    { label: 'Travel & tour guides', value: 'Travel & tour guides' },
    { label: 'Air travel assistants', value: 'Air travel assistants' },
    { label: 'Rail travel assistants', value: 'Rail travel assistants' },
    {
      label: 'Leisure & travel service occupations n.e.c',
      value: 'Leisure & travel service occupations n.e.c',
    },
    { label: 'Hairdressers, barbers', value: 'Hairdressers, barbers' },
    {
      label: 'Beauticians & related occupations',
      value: 'Beauticians & related occupations',
    },
    {
      label: 'Housekeepers & related occupations',
      value: 'Housekeepers & related occupations',
    },
    { label: 'Caretakers', value: 'Caretakers' },
    {
      label: 'Undertakers & mortuary assistants',
      value: 'Undertakers & mortuary assistants',
    },
    { label: 'Pest control officers', value: 'Pest control officers' },
    { label: 'Sales & retail assistants', value: 'Sales & retail assistants' },
    {
      label: 'Retail cashiers & check-out operators',
      value: 'Retail cashiers & check-out operators',
    },
    { label: 'Telephone salespersons', value: 'Telephone salespersons' },
    {
      label: 'Collector salespersons & credit agents',
      value: 'Collector salespersons & credit agents',
    },
    {
      label: 'Debt, rent & other cash collectors',
      value: 'Debt, rent & other cash collectors',
    },
    {
      label: 'Roundsmen/women & van salespersons',
      value: 'Roundsmen/women & van salespersons',
    },
    {
      label: 'Market & street traders & assistants',
      value: 'Market & street traders & assistants',
    },
    {
      label: 'Merchandisers & window dressers',
      value: 'Merchandisers & window dressers',
    },
    {
      label: 'Sales related occupations n.e.c',
      value: 'Sales related occupations n.e.c',
    },
    {
      label: 'Call centre agents/operators',
      value: 'Call centre agents/operators',
    },
    { label: 'Customer care occupations', value: 'Customer care occupations' },
    {
      label: 'Food, drink & tobacco process operatives',
      value: 'Food, drink & tobacco process operatives',
    },
    {
      label: 'Glass & ceramics process operatives',
      value: 'Glass & ceramics process operatives',
    },
    { label: 'Textile process operatives', value: 'Textile process operatives' },
    {
      label: 'Chemical & related process operatives',
      value: 'Chemical & related process operatives',
    },
    { label: 'Rubber process operatives', value: 'Rubber process operatives' },
    {
      label: 'Plastics process operatives',
      value: 'Plastics process operatives',
    },
    {
      label: 'Metal making & treating process operatives',
      value: 'Metal making & treating process operatives',
    },
    { label: 'Electroplaters', value: 'Electroplaters' },
    { label: 'Process operatives n.e.c', value: 'Process operatives n.e.c' },
    {
      label: 'Paper & wood machine operatives',
      value: 'Paper & wood machine operatives',
    },
    { label: 'Coal mine operatives', value: 'Coal mine operatives' },
    {
      label: 'Quarry workers & related operatives',
      value: 'Quarry workers & related operatives',
    },
    { label: 'Energy plant operatives', value: 'Energy plant operatives' },
    {
      label: 'Metal working machine operatives',
      value: 'Metal working machine operatives',
    },
    {
      label: 'Water & sewerage plant operatives',
      value: 'Water & sewerage plant operatives',
    },
    {
      label: 'Plant & machine operatives n.e.c',
      value: 'Plant & machine operatives n.e.c',
    },
    {
      label: 'Assemblers (electrical products)',
      value: 'Assemblers (electrical products)',
    },
    {
      label: 'Assemblers (vehicles & metal goods)',
      value: 'Assemblers (vehicles & metal goods)',
    },
    {
      label: 'Routine inspectors & testers',
      value: 'Routine inspectors & testers',
    },
    { label: 'Weighers, graders, sorters', value: 'Weighers, graders, sorters' },
    {
      label: 'Tyre, exhaust & windscreen fitters',
      value: 'Tyre, exhaust & windscreen fitters',
    },
    { label: 'Clothing cutters', value: 'Clothing cutters' },
    { label: 'Sewing machinists', value: 'Sewing machinists' },
    { label: 'Routine laboratory testers', value: 'Routine laboratory testers' },
    {
      label: 'Assemblers & routine operatives n.e.c',
      value: 'Assemblers & routine operatives n.e.c',
    },
    {
      label: 'Scaffolders, stagers, riggers',
      value: 'Scaffolders, stagers, riggers',
    },
    {
      label: 'Road construction operatives',
      value: 'Road construction operatives',
    },
    {
      label: 'Rail construction & maintenance operatives',
      value: 'Rail construction & maintenance operatives',
    },
    {
      label: 'Construction operatives n.e.c',
      value: 'Construction operatives n.e.c',
    },
    {
      label: 'Heavy goods vehicle drivers',
      value: 'Heavy goods vehicle drivers',
    },
    { label: 'Van drivers', value: 'Van drivers' },
    { label: 'Bus & coach drivers', value: 'Bus & coach drivers' },
    {
      label: 'Taxi, cab drivers & chauffeurs',
      value: 'Taxi, cab drivers & chauffeurs',
    },
    { label: 'Driving instructors', value: 'Driving instructors' },
    { label: 'Rail transport operatives', value: 'Rail transport operatives' },
    {
      label: 'Seafarers (merchant navy); barge, lighter & boat operatives',
      value: 'Seafarers (merchant navy); barge, lighter & boat operatives',
    },
    { label: 'Air transport operatives', value: 'Air transport operatives' },
    { label: 'Transport operatives n.e.c', value: 'Transport operatives n.e.c' },
    { label: 'Crane drivers', value: 'Crane drivers' },
    { label: 'Fork-lift truck drivers', value: 'Fork-lift truck drivers' },
    {
      label: 'Agricultural machinery drivers',
      value: 'Agricultural machinery drivers',
    },
    {
      label: 'Mobile machine drivers & operatives n.e.c',
      value: 'Mobile machine drivers & operatives n.e.c',
    },
    { label: 'Farm workers', value: 'Farm workers' },
    { label: 'Forestry workers', value: 'Forestry workers' },
    {
      label: 'Fishing & agriculture related occupations n.e.c',
      value: 'Fishing & agriculture related occupations n.e.c',
    },
    {
      label: 'Labourers in building & woodworking trades',
      value: 'Labourers in building & woodworking trades',
    },
    {
      label: 'Labourers in other construction trades n.e.c',
      value: 'Labourers in other construction trades n.e.c',
    },
    { label: 'Labourers in foundries', value: 'Labourers in foundries' },
    {
      label: 'Industrial cleaning process occupations',
      value: 'Industrial cleaning process occupations',
    },
    {
      label: 'Printing machine minders & assistants',
      value: 'Printing machine minders & assistants',
    },
    {
      label: 'Packers, bottlers, canners, fillers',
      value: 'Packers, bottlers, canners, fillers',
    },
    {
      label: 'Labourers in process & plant operations n.e.c',
      value: 'Labourers in process & plant operations n.e.c',
    },
    {
      label: 'Stevedores, dockers & slingers',
      value: 'Stevedores, dockers & slingers',
    },
    {
      label: 'Other goods handling & storage occupations n.e.c',
      value: 'Other goods handling & storage occupations n.e.c',
    },
    {
      label: 'Postal workers, mail sorters, messengers, couriers',
      value: 'Postal workers, mail sorters, messengers, couriers',
    },
    {
      label: 'Elementary office occupations n.e.c',
      value: 'Elementary office occupations n.e.c',
    },
    { label: 'Hospital porters', value: 'Hospital porters' },
    { label: 'Hotel porters', value: 'Hotel porters' },
    {
      label: 'Kitchen & catering assistants',
      value: 'Kitchen & catering assistants',
    },
    { label: 'Waiters, Waitresses', value: 'Waiters, Waitresses' },
    { label: 'Bar staff', value: 'Bar staff' },
    {
      label: 'Leisure & theme park attendants',
      value: 'Leisure & theme park attendants',
    },
    {
      label: 'Elementary personal services occupations n.e.c',
      value: 'Elementary personal services occupations n.e.c',
    },
    { label: 'Window cleaners', value: 'Window cleaners' },
    { label: 'Road sweepers', value: 'Road sweepers' },
    { label: 'Cleaners, domestics', value: 'Cleaners, domestics' },
    {
      label: 'Launderers, dry cleaners, pressers',
      value: 'Launderers, dry cleaners, pressers',
    },
    {
      label: 'Refuse & salvage occupations',
      value: 'Refuse & salvage occupations',
    },
    {
      label: 'Elementary cleaning occupations n.e.c',
      value: 'Elementary cleaning occupations n.e.c',
    },
    {
      label: 'Security guards & related occupations',
      value: 'Security guards & related occupations',
    },
    { label: 'Traffic wardens', value: 'Traffic wardens' },
    {
      label: 'School crossing patrol attendants',
      value: 'School crossing patrol attendants',
    },
    { label: 'School mid-day assistants', value: 'School mid-day assistants' },
    { label: 'Car park attendants', value: 'Car park attendants' },
    {
      label: 'Elementary security occupations n.e.c',
      value: 'Elementary security occupations n.e.c',
    },
    { label: 'Shelf fillers', value: 'Shelf fillers' },
    {
      label: 'Elementary sales occupations n.e.c',
      value: 'Elementary sales occupations n.e.c',
    },
  ];
  
  export const FORM_VALUES_DISABLITY = [
    {
      label:
        'A specific learning difficulty such as dyslexia, dyspraxia or AD(H)D',
      value:
        'A specific learning difficulty such as dyslexia, dyspraxia or AD(H)D',
    },
    {
      label:
        "A social/communication impairment such as Asperger's syndrome/other autistic spectrum disorder",
      value:
        "A social/communication impairment such as Asperger's syndrome/other autistic spectrum disorder",
    },
    {
      label:
        'A long standing illness or health condition such as cancer, HIV, diabetes, chronic heart disease, or epilepsy',
      value:
        'A long standing illness or health condition such as cancer, HIV, diabetes, chronic heart disease, or epilepsy',
    },
    {
      label:
        'A mental health condition, such as depression, schizophrenia or anxiety disorder',
      value:
        'A mental health condition, such as depression, schizophrenia or anxiety disorder',
    },
    {
      label:
        'A physical impairment or mobility issues, such as difficulty using arms or using a wheelchair or crutches',
      value:
        'A physical impairment or mobility issues, such as difficulty using arms or using a wheelchair or crutches',
    },
    {
      label: 'Deaf or a serious hearing impairment',
      value: 'Deaf or a serious hearing impairment',
    },
    {
      label: 'Blind or a serious visual impairment uncorrected by glasses',
      value: 'Blind or a serious visual impairment uncorrected by glasses',
    },
    {
      label: 'A disability, impairment or medical condition that is not listed',
      value: 'A disability, impairment or medical condition that is not listed',
    },
  ];
  
  export const FORM_VALUES_PARENT_OCCUPATION = [
    { label: 'Information refused', value: 'Information refused' },
    { label: 'Retired', value: 'Retired' },
    { label: 'Unemployed', value: 'Unemployed' },
    { label: 'Not known', value: 'Not known' },
    {
      label: 'Accounts & wages clerks, book-keepers, other financial clerks',
      value: 'Accounts & wages clerks, book-keepers, other financial clerks',
    },
    { label: 'Actors, entertainers', value: 'Actors, entertainers' },
    {
      label: 'Advertising & public relations managers',
      value: 'Advertising & public relations managers',
    },
    {
      label: 'Agricultural & fishing trades n.e.c',
      value: 'Agricultural & fishing trades n.e.c',
    },
    {
      label: 'Agricultural machinery drivers',
      value: 'Agricultural machinery drivers',
    },
    { label: 'Air traffic controllers', value: 'Air traffic controllers' },
    { label: 'Air transport operatives', value: 'Air transport operatives' },
    { label: 'Air travel assistants', value: 'Air travel assistants' },
    {
      label: 'Aircraft pilots & flight engineers',
      value: 'Aircraft pilots & flight engineers',
    },
    {
      label: 'Ambulance staff (excluding paramedics)',
      value: 'Ambulance staff (excluding paramedics)',
    },
    {
      label: 'Animal care occupations n.e.c',
      value: 'Animal care occupations n.e.c',
    },
    { label: 'Architects', value: 'Architects' },
    {
      label: 'Architectural technologists & town planning technicians',
      value: 'Architectural technologists & town planning technicians',
    },
    { label: 'Archivists & curators', value: 'Archivists & curators' },
    { label: 'Artists', value: 'Artists' },
    {
      label: 'Arts officers, producers & directors',
      value: 'Arts officers, producers & directors',
    },
    {
      label: 'Assemblers (electrical products)',
      value: 'Assemblers (electrical products)',
    },
    {
      label: 'Assemblers (vehicles & metal goods)',
      value: 'Assemblers (vehicles & metal goods)',
    },
    {
      label: 'Assemblers & routine operatives n.e.c',
      value: 'Assemblers & routine operatives n.e.c',
    },
    { label: 'Authors, writers', value: 'Authors, writers' },
    { label: 'Auto electricians', value: 'Auto electricians' },
    {
      label: 'Bakers, flour confectioners',
      value: 'Bakers, flour confectioners',
    },
    { label: 'Bar staff', value: 'Bar staff' },
    {
      label: 'Beauticians & related occupations',
      value: 'Beauticians & related occupations',
    },
    {
      label: 'Biological scientists & biochemists',
      value: 'Biological scientists & biochemists',
    },
    {
      label: 'Bookbinders & print finishers',
      value: 'Bookbinders & print finishers',
    },
    { label: 'Bricklayers, masons', value: 'Bricklayers, masons' },
    {
      label: 'Broadcasting associate professionals',
      value: 'Broadcasting associate professionals',
    },
    { label: 'Brokers', value: 'Brokers' },
    {
      label: 'Building & civil engineering technicians',
      value: 'Building & civil engineering technicians',
    },
    { label: 'Building inspectors', value: 'Building inspectors' },
    { label: 'Bus & coach drivers', value: 'Bus & coach drivers' },
    {
      label: 'Business & related associate professionals n.e.c',
      value: 'Business & related associate professionals n.e.c',
    },
    { label: 'Butchers, meat cutters', value: 'Butchers, meat cutters' },
    {
      label: 'Buyers & purchasing officers',
      value: 'Buyers & purchasing officers',
    },
    {
      label: 'Call centre agents/operators',
      value: 'Call centre agents/operators',
    },
    { label: 'Car park attendants', value: 'Car park attendants' },
    {
      label: 'Care assistants & home carers',
      value: 'Care assistants & home carers',
    },
    {
      label: 'Careers advisers & vocational guidance specialists',
      value: 'Careers advisers & vocational guidance specialists',
    },
    { label: 'Caretakers', value: 'Caretakers' },
    { label: 'Carpenters & joiners', value: 'Carpenters & joiners' },
    {
      label: 'Chartered & certified accountants',
      value: 'Chartered & certified accountants',
    },
    {
      label: 'Chartered surveyors (not quantity surveyors)',
      value: 'Chartered surveyors (not quantity surveyors)',
    },
    { label: 'Chefs, cooks', value: 'Chefs, cooks' },
    {
      label: 'Chemical & related process operatives',
      value: 'Chemical & related process operatives',
    },
    { label: 'Chemical engineers', value: 'Chemical engineers' },
    { label: 'Chemists', value: 'Chemists' },
    {
      label: 'Childminders & related occupations',
      value: 'Childminders & related occupations',
    },
    { label: 'Chiropodists', value: 'Chiropodists' },
    { label: 'Civil engineers', value: 'Civil engineers' },
    {
      label: 'Civil Service administrative officers & assistants',
      value: 'Civil Service administrative officers & assistants',
    },
    {
      label: 'Civil Service executive officers',
      value: 'Civil Service executive officers',
    },
    { label: 'Cleaners, domestics', value: 'Cleaners, domestics' },
    { label: 'Clergy', value: 'Clergy' },
  
    { label: 'Clothing cutters', value: 'Clothing cutters' },
    { label: 'Coal mine operatives', value: 'Coal mine operatives' },
    {
      label: 'Collector salespersons & credit agents',
      value: 'Collector salespersons & credit agents',
    },
    { label: 'Communication operators', value: 'Communication operators' },
    { label: 'Company secretaries', value: 'Company secretaries' },
    {
      label: 'Computer engineers, installation & maintenance',
      value: 'Computer engineers, installation & maintenance',
    },
    {
      label: 'Conference & exhibition managers',
      value: 'Conference & exhibition managers',
    },
    {
      label: 'Conservation & environmental protection officers',
      value: 'Conservation & environmental protection officers',
    },
    {
      label: 'Construction operatives n.e.c',
      value: 'Construction operatives n.e.c',
    },
    { label: 'Construction trades n.e.c', value: 'Construction trades n.e.c' },
    { label: 'Counter clerks', value: 'Counter clerks' },
    { label: 'Countryside & park rangers', value: 'Countryside & park rangers' },
    { label: 'Crane drivers', value: 'Crane drivers' },
    { label: 'Credit controllers', value: 'Credit controllers' },
    { label: 'Customer care managers', value: 'Customer care managers' },
    { label: 'Customer care occupations', value: 'Customer care occupations' },
    { label: 'Dancers & choreographers', value: 'Dancers & choreographers' },
    { label: 'Database assistants/clerks', value: 'Database assistants/clerks' },
    {
      label: 'Debt, rent & other cash collectors',
      value: 'Debt, rent & other cash collectors',
    },
    { label: 'Dental nurses', value: 'Dental nurses' },
    { label: 'Dental practitioners', value: 'Dental practitioners' },
    {
      label: 'Design & development engineers',
      value: 'Design & development engineers',
    },
    {
      label: 'Directors & chief executives of major organisations',
      value: 'Directors & chief executives of major organisations',
    },
    { label: 'Dispensing opticians', value: 'Dispensing opticians' },
    { label: 'Draughtspersons', value: 'Draughtspersons' },
    { label: 'Driving instructors', value: 'Driving instructors' },
    {
      label: 'Education officers, school inspectors',
      value: 'Education officers, school inspectors',
    },
    { label: 'Educational assistants', value: 'Educational assistants' },
    { label: 'Electrical engineers', value: 'Electrical engineers' },
    {
      label: 'Electrical/electronics engineers n.e.c',
      value: 'Electrical/electronics engineers n.e.c',
    },
    {
      label: 'Electrical/electronics technicians',
      value: 'Electrical/electronics technicians',
    },
    {
      label: 'Electricians, electrical fitters',
      value: 'Electricians, electrical fitters',
    },
    { label: 'Electronics engineers', value: 'Electronics engineers' },
    { label: 'Electroplaters', value: 'Electroplaters' },
    {
      label: 'Elementary cleaning occupations n.e.c',
      value: 'Elementary cleaning occupations n.e.c',
    },
    {
      label: 'Elementary office occupations n.e.c',
      value: 'Elementary office occupations n.e.c',
    },
    {
      label: 'Elementary personal services occupations n.e.c',
      value: 'Elementary personal services occupations n.e.c',
    },
    {
      label: 'Elementary sales occupations n.e.c',
      value: 'Elementary sales occupations n.e.c',
    },
    {
      label: 'Elementary security occupations n.e.c',
      value: 'Elementary security occupations n.e.c',
    },
    { label: 'Energy plant operatives', value: 'Energy plant operatives' },
    {
      label: 'Engineering professionals n.e.c',
      value: 'Engineering professionals n.e.c',
    },
    { label: 'Engineering technicians', value: 'Engineering technicians' },
    {
      label: 'Environmental health officers',
      value: 'Environmental health officers',
    },
    { label: 'Estate agents, auctioneers', value: 'Estate agents, auctioneers' },
    {
      label: 'Estimators, valuers & assessors',
      value: 'Estimators, valuers & assessors',
    },
    { label: 'Farm managers', value: 'Farm managers' },
    { label: 'Farm workers', value: 'Farm workers' },
    { label: 'Farmers', value: 'Farmers' },
    {
      label: 'Filing & other records assistants/clerks',
      value: 'Filing & other records assistants/clerks',
    },
    {
      label: 'Finance & investment analysts/advisers',
      value: 'Finance & investment analysts/advisers',
    },
    {
      label: 'Financial & accounting technicians',
      value: 'Financial & accounting technicians',
    },
    {
      label: 'Financial institution managers',
      value: 'Financial institution managers',
    },
    {
      label: 'Financial managers & chartered secretaries',
      value: 'Financial managers & chartered secretaries',
    },
    {
      label: 'Fire service officers (leading fire officer & below)',
      value: 'Fire service officers (leading fire officer & below)',
    },
    {
      label: 'Fishing & agriculture related occupations n.e.c',
      value: 'Fishing & agriculture related occupations n.e.c',
    },
    {
      label: 'Fishmongers, poultry dressers',
      value: 'Fishmongers, poultry dressers',
    },
    { label: 'Fitness instructors', value: 'Fitness instructors' },
    { label: 'Floorers & wall tilers', value: 'Floorers & wall tilers' },
    { label: 'Floral arrangers, florists', value: 'Floral arrangers, florists' },
    {
      label: 'Food, drink & tobacco process operatives',
      value: 'Food, drink & tobacco process operatives',
    },
    { label: 'Forestry workers', value: 'Forestry workers' },
    { label: 'Fork-lift truck drivers', value: 'Fork-lift truck drivers' },
    {
      label: 'Furniture makers, other craft woodworkers',
      value: 'Furniture makers, other craft woodworkers',
    },
    {
      label: 'Further education teaching professionals',
      value: 'Further education teaching professionals',
    },
    {
      label: 'Garage managers & proprietors',
      value: 'Garage managers & proprietors',
    },
    {
      label: 'Gardeners & groundsmen/groundswomen',
      value: 'Gardeners & groundsmen/groundswomen',
    },
    {
      label: 'General office assistants/clerks',
      value: 'General office assistants/clerks',
    },
    {
      label: 'Glass & ceramics makers, decorators & finishers',
      value: 'Glass & ceramics makers, decorators & finishers',
    },
    {
      label: 'Glass & ceramics process operatives',
      value: 'Glass & ceramics process operatives',
    },
    {
      label: 'Glaziers, window fabricators & fitters',
      value: 'Glaziers, window fabricators & fitters',
    },
    {
      label: 'Goldsmiths, silversmiths, precious stone workers',
      value: 'Goldsmiths, silversmiths, precious stone workers',
    },
    { label: 'Graphic designers', value: 'Graphic designers' },
    { label: 'Hairdressers, barbers', value: 'Hairdressers, barbers' },
    {
      label: 'Hairdressing & beauty salon managers & proprietors',
      value: 'Hairdressing & beauty salon managers & proprietors',
    },
    {
      label: 'Hand craft occupations n.e.c',
      value: 'Hand craft occupations n.e.c',
    },
    {
      label: 'Healthcare practice managers',
      value: 'Healthcare practice managers',
    },
    {
      label: 'Heavy goods vehicle drivers',
      value: 'Heavy goods vehicle drivers',
    },
    {
      label: 'Higher education teaching professionals',
      value: 'Higher education teaching professionals',
    },
    { label: 'Horticultural trades', value: 'Horticultural trades' },
    {
      label: 'Hospital & health service managers',
      value: 'Hospital & health service managers',
    },
    { label: 'Hospital porters', value: 'Hospital porters' },
    {
      label: 'Hotel & accommodation managers',
      value: 'Hotel & accommodation managers',
    },
    { label: 'Hotel porters', value: 'Hotel porters' },
    {
      label: 'Housekeepers & related occupations',
      value: 'Housekeepers & related occupations',
    },
    {
      label: 'Houseparents & residential wardens',
      value: 'Houseparents & residential wardens',
    },
    { label: 'Housing & welfare officers', value: 'Housing & welfare officers' },
    { label: 'Importers, exporters', value: 'Importers, exporters' },
    {
      label: 'Industrial cleaning process occupations',
      value: 'Industrial cleaning process occupations',
    },
    {
      label: 'Information & communication technology managers',
      value: 'Information & communication technology managers',
    },
    {
      label: 'Inspectors of factories, utilities & trading standards',
      value: 'Inspectors of factories, utilities & trading standards',
    },
    { label: 'Insurance underwriters', value: 'Insurance underwriters' },
    { label: 'IT operations technicians', value: 'IT operations technicians' },
    {
      label: 'IT strategy & planning professionals',
      value: 'IT strategy & planning professionals',
    },
    {
      label: 'IT user support technicians',
      value: 'IT user support technicians',
    },
    {
      label: 'Journalists, newspaper & periodical editors',
      value: 'Journalists, newspaper & periodical editors',
    },
    {
      label: 'Kitchen & catering assistants',
      value: 'Kitchen & catering assistants',
    },
    { label: 'Laboratory technicians', value: 'Laboratory technicians' },
    {
      label: 'Labourers in building & woodworking trades',
      value: 'Labourers in building & woodworking trades',
    },
    { label: 'Labourers in foundries', value: 'Labourers in foundries' },
    {
      label: 'Labourers in other construction trades n.e.c',
      value: 'Labourers in other construction trades n.e.c',
    },
    {
      label: 'Labourers in process & plant operations n.e.c',
      value: 'Labourers in process & plant operations n.e.c',
    },
    {
      label: 'Launderers, dry cleaners, pressers',
      value: 'Launderers, dry cleaners, pressers',
    },
    { label: 'Leather & related trades', value: 'Leather & related trades' },
    {
      label: 'Legal associate professionals',
      value: 'Legal associate professionals',
    },
    { label: 'Legal professionals n.e.c', value: 'Legal professionals n.e.c' },
    { label: 'Legal secretaries', value: 'Legal secretaries' },
    { label: 'Leisure & sports managers', value: 'Leisure & sports managers' },
    {
      label: 'Leisure & theme park attendants',
      value: 'Leisure & theme park attendants',
    },
    {
      label: 'Leisure & travel service occupations n.e.c',
      value: 'Leisure & travel service occupations n.e.c',
    },
    { label: 'Librarians', value: 'Librarians' },
    { label: 'Library assistants/clerks', value: 'Library assistants/clerks' },
    {
      label: 'Lines repairers & cable jointers',
      value: 'Lines repairers & cable jointers',
    },
    {
      label: 'Local government clerical officers & assistants',
      value: 'Local government clerical officers & assistants',
    },
    { label: 'Management accountants', value: 'Management accountants' },
    {
      label: 'Management consultants, actuaries, economists & statisticians',
      value: 'Management consultants, actuaries, economists & statisticians',
    },
    {
      label: 'Managers & proprietors in other services n.e.c',
      value: 'Managers & proprietors in other services n.e.c',
    },
    {
      label: 'Managers in animal husbandry, forestry & fishing n.e.c',
      value: 'Managers in animal husbandry, forestry & fishing n.e.c',
    },
    { label: 'Managers in construction', value: 'Managers in construction' },
    {
      label: 'Managers in mining & energy',
      value: 'Managers in mining & energy',
    },
    {
      label: 'Market & street traders & assistants',
      value: 'Market & street traders & assistants',
    },
    {
      label: 'Market research interviewers',
      value: 'Market research interviewers',
    },
    { label: 'Marketing & sales managers', value: 'Marketing & sales managers' },
    {
      label: 'Marketing associate professionals',
      value: 'Marketing associate professionals',
    },
    { label: 'Mechanical engineers', value: 'Mechanical engineers' },
    {
      label: 'Medical & dental technicians',
      value: 'Medical & dental technicians',
    },
    { label: 'Medical practitioners', value: 'Medical practitioners' },
    { label: 'Medical radiographers', value: 'Medical radiographers' },
    { label: 'Medical secretaries', value: 'Medical secretaries' },
    {
      label: 'Merchandisers & window dressers',
      value: 'Merchandisers & window dressers',
    },
    {
      label: 'Metal machining setters & setter-operators',
      value: 'Metal machining setters & setter-operators',
    },
    {
      label: 'Metal making & treating process operatives',
      value: 'Metal making & treating process operatives',
    },
    {
      label: 'Metal plate workers, shipwrights, riveters',
      value: 'Metal plate workers, shipwrights, riveters',
    },
    {
      label: 'Metal working machine operatives',
      value: 'Metal working machine operatives',
    },
    {
      label: 'Metal working production & maintenance fitters',
      value: 'Metal working production & maintenance fitters',
    },
    { label: 'Midwives', value: 'Midwives' },
    {
      label: 'Mobile machine drivers & operatives n.e.c',
      value: 'Mobile machine drivers & operatives n.e.c',
    },
    {
      label: 'Motor mechanics, auto engineers',
      value: 'Motor mechanics, auto engineers',
    },
    {
      label: 'Moulders, core makers, die casters',
      value: 'Moulders, core makers, die casters',
    },
    {
      label: 'Musical instrument makers & tuners',
      value: 'Musical instrument makers & tuners',
    },
    { label: 'Musicians', value: 'Musicians' },
    {
      label: 'Natural environment & conservation managers',
      value: 'Natural environment & conservation managers',
    },
    { label: 'NCOs & other ranks', value: 'NCOs & other ranks' },
    { label: 'Nursery nurses', value: 'Nursery nurses' },
    { label: 'Nurses', value: 'Nurses' },
    {
      label: 'Nursing auxiliaries & assistants',
      value: 'Nursing auxiliaries & assistants',
    },
    {
      label: 'Occupational hygienists & safety officers (health & safety)',
      value: 'Occupational hygienists & safety officers (health & safety)',
    },
    { label: 'Occupational therapists', value: 'Occupational therapists' },
    { label: 'Office managers', value: 'Office managers' },
    { label: 'Officers in armed forces', value: 'Officers in armed forces' },
    {
      label: 'Officers of non-governmental organisations',
      value: 'Officers of non-governmental organisations',
    },
    { label: 'Ophthalmic opticians', value: 'Ophthalmic opticians' },
    {
      label: 'Originators, compositors & print preparers',
      value: 'Originators, compositors & print preparers',
    },
    {
      label: 'Other goods handling & storage occupations n.e.c',
      value: 'Other goods handling & storage occupations n.e.c',
    },
    {
      label: 'Packers, bottlers, canners, fillers',
      value: 'Packers, bottlers, canners, fillers',
    },
    { label: 'Painters & decorators', value: 'Painters & decorators' },
    {
      label: 'Paper & wood machine operatives',
      value: 'Paper & wood machine operatives',
    },
    { label: 'Paramedics', value: 'Paramedics' },
    { label: 'Pattern makers (moulds)', value: 'Pattern makers (moulds)' },
    {
      label: 'Pensions & insurance clerks',
      value: 'Pensions & insurance clerks',
    },
    {
      label: 'Personal assistants & other secretaries',
      value: 'Personal assistants & other secretaries',
    },
    {
      label: 'Personnel & industrial relations officers',
      value: 'Personnel & industrial relations officers',
    },
    {
      label: 'Personnel, training & industrial relations managers',
      value: 'Personnel, training & industrial relations managers',
    },
    { label: 'Pest control officers', value: 'Pest control officers' },
    { label: 'Pharmaceutical dispensers', value: 'Pharmaceutical dispensers' },
    {
      label: 'Pharmacists/pharmacologists',
      value: 'Pharmacists/pharmacologists',
    },
    { label: 'Pharmacy managers', value: 'Pharmacy managers' },
    {
      label: 'Photographers & audio-visual equipment operators',
      value: 'Photographers & audio-visual equipment operators',
    },
    {
      label: 'Physicists, geologists & meteorologists',
      value: 'Physicists, geologists & meteorologists',
    },
    { label: 'Physiotherapists', value: 'Physiotherapists' },
    { label: 'Pipe fitters', value: 'Pipe fitters' },
    {
      label: 'Planning & quality control engineers',
      value: 'Planning & quality control engineers',
    },
    {
      label: 'Plant & machine operatives n.e.c',
      value: 'Plant & machine operatives n.e.c',
    },
    { label: 'Plasterers', value: 'Plasterers' },
    {
      label: 'Plastics process operatives',
      value: 'Plastics process operatives',
    },
    {
      label: 'Playgroup leaders/assistants',
      value: 'Playgroup leaders/assistants',
    },
    {
      label: 'Plumbers, heating & ventilating engineers',
      value: 'Plumbers, heating & ventilating engineers',
    },
    {
      label: 'Police officers (inspectors & above)',
      value: 'Police officers (inspectors & above)',
    },
    {
      label: 'Police officers (sergeant & below)',
      value: 'Police officers (sergeant & below)',
    },
    {
      label: 'Postal workers, mail sorters, messengers, couriers',
      value: 'Postal workers, mail sorters, messengers, couriers',
    },
    {
      label: 'Precision instrument makers & repairers',
      value: 'Precision instrument makers & repairers',
    },
    {
      label: 'Primary & nursery education teaching professionals',
      value: 'Primary & nursery education teaching professionals',
    },
    { label: 'Printers', value: 'Printers' },
    {
      label: 'Printing machine minders & assistants',
      value: 'Printing machine minders & assistants',
    },
    {
      label: 'Prison service officers (below principal officer)',
      value: 'Prison service officers (below principal officer)',
    },
    { label: 'Probation officers', value: 'Probation officers' },
    { label: 'Process operatives n.e.c', value: 'Process operatives n.e.c' },
    {
      label: 'Product, clothing & related designers',
      value: 'Product, clothing & related designers',
    },
    {
      label: 'Production & process engineers',
      value: 'Production & process engineers',
    },
    {
      label: 'Production, works & maintenance managers',
      value: 'Production, works & maintenance managers',
    },
    {
      label: 'Property, housing & land managers',
      value: 'Property, housing & land managers',
    },
    {
      label: 'Protective service associate professionals n.e.c',
      value: 'Protective service associate professionals n.e.c',
    },
    { label: 'Psychologists', value: 'Psychologists' },
    { label: 'Public relations officers', value: 'Public relations officers' },
    {
      label: 'Public service administrative professionals',
      value: 'Public service administrative professionals',
    },
    {
      label: 'Public service associate professionals',
      value: 'Public service associate professionals',
    },
    {
      label: 'Publicans & managers of licensed premises',
      value: 'Publicans & managers of licensed premises',
    },
    { label: 'Purchasing managers', value: 'Purchasing managers' },
    { label: 'Quality assurance managers', value: 'Quality assurance managers' },
    {
      label: 'Quality assurance technicians',
      value: 'Quality assurance technicians',
    },
    { label: 'Quantity surveyors', value: 'Quantity surveyors' },
    {
      label: 'Quarry workers & related operatives',
      value: 'Quarry workers & related operatives',
    },
    {
      label: 'Rail construction & maintenance operatives',
      value: 'Rail construction & maintenance operatives',
    },
    { label: 'Rail transport operatives', value: 'Rail transport operatives' },
    { label: 'Rail travel assistants', value: 'Rail travel assistants' },
    { label: 'Receptionists', value: 'Receptionists' },
    {
      label: 'Recycling & refuse disposal managers',
      value: 'Recycling & refuse disposal managers',
    },
    {
      label: 'Refuse & salvage occupations',
      value: 'Refuse & salvage occupations',
    },
    {
      label: 'Registrars & senior administrators of educational establishments',
      value: 'Registrars & senior administrators of educational establishments',
    },
    {
      label: 'Research & development managers',
      value: 'Research & development managers',
    },
    { label: 'Researchers n.e.c', value: 'Researchers n.e.c' },
    {
      label: 'Residential & day care managers',
      value: 'Residential & day care managers',
    },
    {
      label: 'Restaurant & catering managers',
      value: 'Restaurant & catering managers',
    },
    {
      label: 'Retail & wholesale managers',
      value: 'Retail & wholesale managers',
    },
    {
      label: 'Retail cashiers & check-out operators',
      value: 'Retail cashiers & check-out operators',
    },
    {
      label: 'Road construction operatives',
      value: 'Road construction operatives',
    },
    { label: 'Road sweepers', value: 'Road sweepers' },
    {
      label: 'Roofers, roof tilers & slaters',
      value: 'Roofers, roof tilers & slaters',
    },
    {
      label: 'Roundsmen/women & van salespersons',
      value: 'Roundsmen/women & van salespersons',
    },
    {
      label: 'Routine inspectors & testers',
      value: 'Routine inspectors & testers',
    },
    { label: 'Routine laboratory testers', value: 'Routine laboratory testers' },
    { label: 'Rubber process operatives', value: 'Rubber process operatives' },
    { label: 'Sales & retail assistants', value: 'Sales & retail assistants' },
    {
      label: 'Sales related occupations n.e.c',
      value: 'Sales related occupations n.e.c',
    },
    { label: 'Sales representatives', value: 'Sales representatives' },
    {
      label: 'Scaffolders, stagers, riggers',
      value: 'Scaffolders, stagers, riggers',
    },
    {
      label: 'School crossing patrol attendants',
      value: 'School crossing patrol attendants',
    },
    { label: 'School mid-day assistants', value: 'School mid-day assistants' },
    { label: 'School secretaries', value: 'School secretaries' },
    {
      label: 'Science & engineering technicians n.e.c',
      value: 'Science & engineering technicians n.e.c',
    },
    { label: 'Scientific researchers', value: 'Scientific researchers' },
    { label: 'Screen printers', value: 'Screen printers' },
    {
      label: 'Seafarers (merchant navy); barge, lighter & boat operatives',
      value: 'Seafarers (merchant navy); barge, lighter & boat operatives',
    },
    {
      label: 'Secondary education teaching professionals',
      value: 'Secondary education teaching professionals',
    },
    {
      label: 'Security guards & related occupations',
      value: 'Security guards & related occupations',
    },
    { label: 'Security managers', value: 'Security managers' },
    {
      label: 'Senior officers in fire, ambulance, prison & related services',
      value: 'Senior officers in fire, ambulance, prison & related services',
    },
    {
      label: 'Senior officials in local government',
      value: 'Senior officials in local government',
    },
    {
      label: 'Senior officials in national government',
      value: 'Senior officials in national government',
    },
    {
      label: 'Senior officials of special interest organisations',
      value: 'Senior officials of special interest organisations',
    },
    { label: 'Sewing machinists', value: 'Sewing machinists' },
    { label: 'Sheet metal workers', value: 'Sheet metal workers' },
    { label: 'Shelf fillers', value: 'Shelf fillers' },
    { label: 'Ship & hovercraft officers', value: 'Ship & hovercraft officers' },
    {
      label: 'Shopkeepers & wholesale/retail dealers',
      value: 'Shopkeepers & wholesale/retail dealers',
    },
    { label: 'Smiths & forge workers', value: 'Smiths & forge workers' },
    { label: 'Social science researchers', value: 'Social science researchers' },
    { label: 'Social services managers', value: 'Social services managers' },
    { label: 'Social workers', value: 'Social workers' },
    { label: 'Software professionals', value: 'Software professionals' },
    {
      label: 'Solicitors & lawyers, judges & coroners',
      value: 'Solicitors & lawyers, judges & coroners',
    },
    {
      label: 'Special needs education teaching professionals',
      value: 'Special needs education teaching professionals',
    },
    {
      label: 'Speech & language therapists',
      value: 'Speech & language therapists',
    },
    {
      label: 'Sports & fitness occupations n.e.c',
      value: 'Sports & fitness occupations n.e.c',
    },
    {
      label: 'Sports & leisure assistants',
      value: 'Sports & leisure assistants',
    },
    {
      label: 'Sports coaches, instructors & officials',
      value: 'Sports coaches, instructors & officials',
    },
    { label: 'Sports players', value: 'Sports players' },
    { label: 'Statutory examiners', value: 'Statutory examiners' },
    { label: 'Steel erectors', value: 'Steel erectors' },
    {
      label: 'Stevedores, dockers & slingers',
      value: 'Stevedores, dockers & slingers',
    },
    { label: 'Stock control clerks', value: 'Stock control clerks' },
    {
      label: 'Storage & warehouse managers',
      value: 'Storage & warehouse managers',
    },
    { label: 'Tailors & dressmakers', value: 'Tailors & dressmakers' },
    { label: 'Taxation experts', value: 'Taxation experts' },
    {
      label: 'Taxi, cab drivers & chauffeurs',
      value: 'Taxi, cab drivers & chauffeurs',
    },
    {
      label: 'Teaching professionals n.e.c',
      value: 'Teaching professionals n.e.c',
    },
    {
      label: 'Telecommunications engineers',
      value: 'Telecommunications engineers',
    },
    { label: 'Telephone salespersons', value: 'Telephone salespersons' },
    { label: 'Telephonists', value: 'Telephonists' },
    { label: 'Textile process operatives', value: 'Textile process operatives' },
    {
      label: 'Textiles, garments & related trades n.e.c',
      value: 'Textiles, garments & related trades n.e.c',
    },
    { label: 'Therapists n.e.c', value: 'Therapists n.e.c' },
    {
      label: 'Tool makers, tool fitters & markers-out',
      value: 'Tool makers, tool fitters & markers-out',
    },
    { label: 'Town planners', value: 'Town planners' },
    { label: 'Traffic wardens', value: 'Traffic wardens' },
    { label: 'Train drivers', value: 'Train drivers' },
    {
      label: 'Transport & distribution clerks',
      value: 'Transport & distribution clerks',
    },
    {
      label: 'Transport & distribution managers',
      value: 'Transport & distribution managers',
    },
    { label: 'Transport operatives n.e.c', value: 'Transport operatives n.e.c' },
    { label: 'Travel & tour guides', value: 'Travel & tour guides' },
    { label: 'Travel agency managers', value: 'Travel agency managers' },
    { label: 'Travel agents', value: 'Travel agents' },
    {
      label: 'TV, video & audio engineers',
      value: 'TV, video & audio engineers',
    },
    { label: 'Typists', value: 'Typists' },
    {
      label: 'Tyre, exhaust & windscreen fitters',
      value: 'Tyre, exhaust & windscreen fitters',
    },
    {
      label: 'Undertakers & mortuary assistants',
      value: 'Undertakers & mortuary assistants',
    },
    { label: 'Upholsterers', value: 'Upholsterers' },
    { label: 'Van drivers', value: 'Van drivers' },
    {
      label: 'Vehicle body builders & repairers',
      value: 'Vehicle body builders & repairers',
    },
    { label: 'Vehicle spray painters', value: 'Vehicle spray painters' },
    { label: 'Veterinarians', value: 'Veterinarians' },
    {
      label: 'Veterinary nurses & assistants',
      value: 'Veterinary nurses & assistants',
    },
    {
      label: 'Vocational & industrial trainers & instructors',
      value: 'Vocational & industrial trainers & instructors',
    },
    { label: 'Waiters, Waitresses', value: 'Waiters, Waitresses' },
    {
      label: 'Water & sewerage plant operatives',
      value: 'Water & sewerage plant operatives',
    },
    { label: 'Weavers & knitters', value: 'Weavers & knitters' },
    { label: 'Weighers, graders, sorters', value: 'Weighers, graders, sorters' },
    { label: 'Welding trades', value: 'Welding trades' },
    { label: 'Window cleaners', value: 'Window cleaners' },
    { label: 'Youth & community workers', value: 'Youth & community workers' },
  ];
  